{
  "en": {
    "account": {
      "line_links": {
        "already_linked": "This LINE account is already linked to another account.",
        "failed": "Failed to link your LINE account. Please try again.",
        "linked": "Your LINE account has been linked.",
        "not_configured": "LINE account linking is currently unavailable.",
        "unlink_confirm": "Unlink your LINE account?",
        "unlinked": "Your LINE account has been unlinked."
      },
      "password": {
        "edit": {
          "current_password": "Current Password",
          "current_password_note": "We need your current password to confirm your changes.",
          "minimum_length": "(%{count} characters minimum)",
          "new_password": "New Password",
          "new_password_note": "Leave blank if you don't want to change it.",
          "password_confirmation": "New Password (Confirmation)",
          "submit": "Update",
          "title": "Change Password"
        },
        "update": {
          "success": "Password has been successfully updated."
        }
      },
      "profile": {
        "edit": {
          "first_name": "First Name (in Chinese, if any)",
          "first_name_reading": "First Name (in English)",
          "last_name": "Last Name  (in Chinese, if any)",
          "last_name_reading": "Last Name (in English)",
          "nickname": "Display Name (Nickname)",
          "phone_number_note_1": "Please enter numbers only without hyphens (-).",
          "phone_number_note_2": "Example: 123-456-7890 → 1234567890",
          "postal_code_note_1": "Please enter numbers only without hyphens (-).",
          "postal_code_note_2": "Example: 123-4567 → 1234567",
          "submit": "Update",
          "title": "Edit Profile"
        },
        "show": {
          "address": "Address",
          "basic_information": "Basic Information",
          "change_password": "Change Password",
          "contact_information": "Contact Information",
          "edit": "Edit",
          "full_name": "Full Name (in Chinese, if any)",
          "full_name_japanese": "Full Name (in English)",
          "line_link": "LINE Account Linking",
          "line_link_after": "*After linking, you can open My Page from the menu in LINE.",
          "line_link_contact": "For inquiries, please contact us at the email address below.",
          "line_link_contact_label": "Contact: ",
          "line_link_lead_html": "Linking LINE with My Page lets you <strong>open My Page easily from LINE</strong>. Use it to check your reservation details.",
          "line_linked_status": "Linked",
          "line_not_linked_status": "Not linked",
          "link_line": "Link with LINE",
          "logout": "Log Out",
          "occupation": "Occupation",
          "password": "Password",
          "primary_contact_information": "Representative Information",
          "support_email": "support@hoikuen-ryugaku.zendesk.com",
          "title": "Account Settings",
          "unlink_line": "Unlink"
        },
        "update": {
          "success": "Profile has been successfully updated."
        }
      }
    },
    "account_confirmation": {
      "email": "Email Address",
      "submit": "Resend Confirmation Email",
      "title": "Resend Confirmation Email"
    },
    "account_confirmation_email": {
      "letter_block_1": {
        "text_1": "This email address is for distribution purposes only.",
        "text_2": "For inquiries, click here ▼"
      },
      "letter_block_2": {
        "text_1": "We have created your account using the registered email address.",
        "text_10": "※This URL is valid for 24 hours.",
        "text_11": "If the expiration period has passed, please resend the identity verification email from %{confirmation_resend_link}.",
        "text_12": "here",
        "text_2": "To proceed with confirming your application or completing necessary procedures, please access the URL below and complete the account verification. ",
        "text_3": "Once the verification is complete, you will be able to log in to your MyPage.",
        "text_4": "Account Verification URL",
        "text_5": "Next Steps",
        "text_6": "1. Access the URL above and complete the account verification.",
        "text_7": "2. Log in to your My Page to check your application details.",
        "text_8": "3. Once your application is approved, you can review the necessary procedures via the ToDo List on your MyPage.",
        "text_9": "If you have any questions, please contact the Preschool Exchange Operation Desk.",
        "text_password_label": "Initial Password",
        "text_password_note": "※For security purposes, please change your password after logging in."
      },
      "letter_block_3": {
        "text_1": "Preschool Exchange Operation Desk",
        "text_2": "Website: %{jpe_url}",
        "text_3": "E-mail: %{support_email}",
        "text_4": "Please allow 3 to 4 business days for a reply (excluding Saturdays, Sundays, and holidays).",
        "text_5": "Management Company: KitchHike, Inc.",
        "text_6": "92-1 Kamisato, Assabu-cho, Hiyama-gun, Hokkaido, Japan"
      }
    },
    "account_confirmation_instructions_email": {
      "letter_block_1": {
        "text_1": "This email address is for distribution purposes only.",
        "text_2": "For inquiries, contact below:"
      },
      "letter_block_2": {
        "text_1": "Please access the URL below to complete the account verification.",
        "text_2": "Once the verification is complete, you will be able to log in to your MyPage.",
        "text_3": "Account Verification URL",
        "text_4": "If you have any questions, please feel free to contact the Preschool Exchange Operation Desk."
      },
      "letter_block_3": {
        "text_1": "Preschool Exchange Operation Desk",
        "text_2": "Website: %{jpe_url}",
        "text_3": "E-mail: %{support_email}",
        "text_4": "Please allow 3 to 4 business days for a reply (excluding Saturdays, Sundays, and holidays).",
        "text_5": "Management Company: KitchHike, Inc.",
        "text_6": "92-1 Kamisato, Assabu-cho, Hiyama-gun, Hokkaido, Japan"
      }
    },
    "account_confirmation_mailer": {
      "confirmation_instructions": {
        "from": "Preschool Exchange Operation Desk <no-reply@kitchhike.com>",
        "subject": "Complete Your Account Verification [Preschool Exchange]"
      },
      "custom_welcome_instructions": {
        "from": "Preschool Exchange Operation Desk <no-reply@kitchhike.com>",
        "subject": "Complete Your Account Registration by Verifying Your Account [Preschool Exchange]"
      }
    },
    "account_reset_password_email": {
      "letter_block_1": {
        "text_1": "This email address is for distribution purposes only.",
        "text_2": "For inquiries, click here ▼"
      },
      "letter_block_2": {
        "text_1": "We have received your request to reset your password.",
        "text_2": "Please set a new password using the link below.",
        "text_3": "Set a New Password"
      },
      "letter_block_3": {
        "text_1": "Preschool Exchange Operation Desk",
        "text_2": "Website: %{jpe_url}",
        "text_3": "E-mail: %{support_email}",
        "text_4": "Please allow 3 to 4 business days for a reply (excluding Saturdays, Sundays, and holidays).",
        "text_5": "Management Company: KitchHike, Inc.",
        "text_6": "92-1 Kamisato, Assabu-cho, Hiyama-gun, Hokkaido, Japan"
      }
    },
    "activemodel": {
      "attributes": {
        "kintone/family_master": {
          "allergenic_foods": "Please select the foods that cause the allergies.",
          "allergy_causes": "Please specify the allergens.",
          "allergy_elimination": "Do you wish to have allergen-free meals provided?",
          "appetite_food": "Appetite",
          "baby_food": "Weaning",
          "birth_date": "Date of birth",
          "breastfeeding": "Feeding",
          "business": "Business",
          "company_name": "Company Name",
          "country": "Country",
          "development_concerns": "Areas of concern",
          "development_current_support": "Support at your current school/facility",
          "development_professional_support": "Use of specialist services",
          "developmentaldisorder": "Has your child ever been diagnosed with a developmental disability?",
          "diagnosis": "Please specify the diagnostic name.",
          "dietary_restriction_elimination_level": "Level of elimination",
          "dietary_restriction_other_text": "If \"Other\", please specify",
          "dietary_restriction_type": "Type of restriction",
          "email_address": "E-mail address",
          "exercise": "Achieved Body Movements",
          "family_relationship": "Relationship to the child participating the program",
          "family_relationship_other": "If the relationship is 'other', please indicate the relationship.",
          "favorite_playing": "Favorite Activities",
          "first_name": "First Name (in Chinese Characters, if any)",
          "first_name_reading": "First Name (in English)",
          "food_allergies_yes_or_no": "Does this child have any food allergies?",
          "food_allergy_anaphylaxis_history": "Has this child ever had an anaphylactic reaction?",
          "food_allergy_elimination_level": "Level of elimination",
          "food_allergy_epipen": "Does this child carry an epinephrine auto-injector (EpiPen)?",
          "food_allergy_guardian_visit": "Can a parent or guardian come to the school/facility?",
          "food_allergy_medication_required": "Is medication required?",
          "food_allergy_severity": "Severity",
          "foodrequest": "Fill in any special requests for meals.",
          "foodrequest_yes_or_no": "Is there any special consideration needed regarding meals due to religious reasons or a plant-based diet (such as vegetarianism)?",
          "full_name": "Full Name (in Chinese Characters, if any)",
          "full_name_reading": "Full Name (in English)",
          "gender": "Gender",
          "language": "Language(s) spoken by this child",
          "last_name": "Last Name (in Chinese Characters, if any)",
          "last_name_reading": "Last Name (in English)",
          "medical_condition_name": "Condition / diagnosis name",
          "medical_current_status": "Current status",
          "medical_history": "Does this child have any history of illness, surgery, injury, or treatment?",
          "medical_history_details": "Please specify the details of medical history.",
          "medical_support_level": "Level of support needed at the school/facility",
          "municipalities": "City/Town/Village",
          "name_of_building": "Building name, etc.",
          "napping": "Nap",
          "nonfood_allergies": "Does this child have any non-food allergies?",
          "nonfood_allergy_causes": "Causes",
          "nonfood_allergy_epipen": "Does this child carry an epinephrine auto-injector (EpiPen)?",
          "nonfood_allergy_other_text": "If \"Other\", please specify",
          "nonfood_allergy_precautions": "Things to avoid / support needed during activities",
          "nonfood_allergy_severity": "Severity",
          "opportunitynurseryschool": "Has this child attended any childcare/educational facilities for more than 3 days a week?",
          "other_food_name": "If other, please specify the ingredients.",
          "personality": "Please tell us about the positive characteristics you see in your child and the areas you would like to improve.",
          "phone_number": "Phone number",
          "planned_participation": "Program Type",
          "postal_code": "Postal code",
          "prefecture": "State/Province",
          "question1": "Please consult with the childcare/educational facility directly at the time of the online pre-meeting and follow the necessary procedures if your child has any special dietary needs. Please note that the availability and level of accommodation for allergen-free meals may vary by facility.",
          "same_as_representative_address": "Same as the representative",
          "same_as_representative_phone_number": "Same as the representative",
          "school_name": "Please name of the school your child currently attends.",
          "school_type": "Please select the type of school your child currently attends.",
          "symptoms": "Please describe the allergy symptoms in detail.",
          "things_that_need_attention": "Please provide details if there are any developmental delays or considerations needed for your child in a group setting.",
          "toilet": "Toilet Habits",
          "town_area_street_address": "Street number/Other address",
          "underwear": "Underwear"
        },
        "kintone/representative_user_master": {
          "birth_date": "Date of Birth",
          "building": "Building (Optional)",
          "business": "Occupation",
          "co_workers": "Co_Worker",
          "company_name": "Company Name",
          "country": "Country",
          "email_address": "Email Address",
          "family_relationship": "Relation to Participating Child",
          "first_name": "First Name",
          "first_name_reading": "First Name (Reading)",
          "gender": "Gender",
          "last_name": "Last Name",
          "last_name_reading": "Last Name (Reading)",
          "municipalities": "City/Town/Village",
          "name_of_building": "Building Name, etc.",
          "other": "Other",
          "phone_number": "Phone Number",
          "postal_code": "Postal Code",
          "prefecture": "State/Province",
          "prefecture_text": "Prefecture",
          "town_area_street_address": "Street Number/Other Address"
        },
        "kintone/reservation_request": {
          "billing_fee": "Billing Total",
          "billing_fee_total": "Billing Total",
          "cancel_fee": "Cancellation Fee",
          "cancel_processed_date": "Cancellation Date",
          "charge_date": "Payment Date",
          "check_in_time": "Arrival Time at the Accommodation",
          "discount_amount": "Discounted Price",
          "emergency_contact1": "Emergency Contact #1",
          "emergency_contact2": "Emergency Contact #2",
          "end_of_stay": "Check-out Date",
          "guardian_name": "Name of Parent/Guardian Who will be Picking up and Dropping off Your Child(ren)",
          "id": "Reservation Number",
          "interview": "Would you be willing to cooperate with interviews and media coverage during and after your stay?",
          "number_of_adults": "Number of Adults",
          "number_of_preschoolers": "Preschool Participants",
          "number_of_preschoolers_1": "Not in the Program (Aged 0 to 6 Years)",
          "number_of_students": "Not in the Program (Aged 7 to 12 Years)",
          "number_of_students_1": "Elementary School Participants",
          "nursery_name": "Childcare/Educational Facility",
          "nursery_name_0": "Childcare/Educational Facility_2",
          "option_count": "Options Count",
          "option_name": "Options",
          "option_price": "Options Price",
          "option_total": "Options Total",
          "plan_name": "Plan Name",
          "prtrait_right": "Do you agree that your child's photo may be used in local publicity, on the official website of Preschool Exchange, and in media such as magazines and television?",
          "room_name": "Accommodation",
          "route": "Please tell us the motivation/reason for your participation.",
          "route_others": "Other",
          "start_of_stay": "Check-in Date",
          "total_number_of_people": "Total Guests"
        },
        "questionnaire": {
          "absent_days": "If there were any days during your stay when your child(ren) did not attend the preschool, please let us know the number of days.",
          "feedback_on_omutei": "(For those who answered \"Yes\") Please share your feedback on Omukai Takeout.",
          "food_cost": "Food Cost",
          "other_cost": "Other Cost",
          "reason_for_moving_interest": "Reason for Moving Interest",
          "reason_for_recommendation": "Please let us know the reasons for the score you provided in the previous question.",
          "reason_for_using_nouzei": "(For those who answered \"Yes\") Please let us know why you used furusato nouzei.",
          "reason_for_using_omutei": "(For those who answered \"Yes\") Please let us know why you used Omukai Takeout.",
          "region_suggestion": "If you have any requests or suggestions for improvements in the area you visited, please share them with us. (optional response)",
          "satisfaction": "Please let us know your overall satisfaction with this preschool exchange experience.",
          "service_request": "If you have any requests for new features in future Preschool Study Abroad programs, please share them with us. (optional response)",
          "service_suggestion": "If you have any points you'd like to see improved or any suggestions for the host area / preschool, please share them with us. (optional response)",
          "transportation_cost": "Transportation Cost",
          "used_nouzei": "Did you use furusato nouzei for your study abroad destination before your trip?",
          "used_omutei": "Did you use Omukai Takeout during your stay?",
          "want_to_move": "Did you consider relocating to the region where you participated in Japan Preschool Exchange this time?",
          "want_to_move_other": "(For those who answered \"Other\") Please provide more details.",
          "want_to_recommend": "Would you like to recommend this program to others?",
          "want_to_repeat": "Would you like to participate in the program again?",
          "want_to_repeat_nouzei": "(For those who answered \"Yes\") Would you like to use furusato nouzei again for your next study abroad? Please share your reasons as well.",
          "want_to_repeat_other": "(For those who answered \"Other\") Please provide more details."
        }
      },
      "errors": {
        "messages": {
          "blank": "Please enter",
          "inclusion": "Please select",
          "too_long": "Please enter no more than %{count} characters"
        }
      },
      "models": {
        "kintone": {
          "family_master": "family_master",
          "representative_user_master": "representative_user_master"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "review": {
          "activity_details": "Please share how often each activity took place, any additional details, and any activities your child experienced that aren't listed above.",
          "comment_en": "Please share your thoughts on the Japan Preschool Exchange program. If you have any particularly memorable episodes, kindly share us as well.",
          "experienced_activities": "Which activities did your child experience as part of the preschool program during your stay?",
          "message_to_locals_en": "Message to the accommodation staff and local community",
          "message_to_teacher_en": "Message to the preschool teachers",
          "published": "Publish Review",
          "title_en": "Title of Your Feedback"
        },
        "user": {
          "confirmation_sent_at": "Confirmation sent at",
          "confirmation_token": "Confirmation token",
          "confirmed_at": "Confirmed at",
          "created_at": "Created at",
          "current_password": "Current password",
          "current_sign_in_at": "Current sign in at",
          "current_sign_in_ip": "Current sign in IP",
          "email": "Email",
          "encrypted_password": "Encrypted password",
          "failed_attempts": "Failed attempts",
          "last_sign_in_at": "Last sign in at",
          "last_sign_in_ip": "Last sign in IP",
          "locked_at": "Locked at",
          "password": "Password",
          "password_confirmation": "Password confirmation",
          "remember_created_at": "Remember created at",
          "remember_me": "Remember me",
          "representative_building": "Building (Optional)",
          "representative_business": "Occupation",
          "representative_co_workers": "Co-workers",
          "representative_company_name": "Company Name (Optional)",
          "representative_country": "Country",
          "representative_day": "Day",
          "representative_family_relationship": "Family Relationship",
          "representative_first_name": "First Name",
          "representative_first_name_reading": "First Name (Reading)",
          "representative_gender": "Gender",
          "representative_last_name": "Last Name",
          "representative_last_name_reading": "Last Name (Reading)",
          "representative_month": "Month",
          "representative_municipalities": "Municipalities",
          "representative_other": "Other relationship detail",
          "representative_phone_number": "Phone Number",
          "representative_postal_code": "Postal Code",
          "representative_prefecture": "Prefecture",
          "representative_town": "Town",
          "representative_year": "Year",
          "reset_password_sent_at": "Reset password sent at",
          "reset_password_token": "Reset password token",
          "sign_in_count": "Sign in count",
          "unconfirmed_email": "Unconfirmed email",
          "unlock_token": "Unlock token",
          "updated_at": "Updated at"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        },
        "models": {
          "review": {
            "attributes": {
              "published": {
                "inclusion": "must be true or false."
              }
            }
          },
          "user": {
            "attributes": {
              "nickname": {
                "too_long": "is too long (maximum is 50 characters)"
              },
              "password": {
                "complexity": "must be at least 8 characters and include at least one lowercase letter and one digit. Symbols are allowed, but spaces, accented characters, and full-width characters are not.",
                "invalid_characters": "contains characters that cannot be used. Spaces, accented characters, full-width characters, and emoji are not allowed.",
                "too_long": "is too long"
              }
            }
          }
        }
      },
      "models": {
        "user": {
          "one": "User",
          "other": "Users"
        }
      }
    },
    "common": {
      "foot_consultation": {
        "button": "Consult with us about Preschool Exchange",
        "lead_1": "Consult with our Preschool Exchange planner",
        "lead_2": "",
        "notes": "Our Preschool Exchange planner will support you in selecting a destination that fits your preferences, as well as consulting with you on any concerns you may have about our program. Please feel free to consult with us via chat or online meeting (Zoom).",
        "url": "https://preschool-exchange.com/#apply"
      },
      "footer": {
        "consult": {
          "link": "Contact our planner for consultation",
          "notes": "For those who require special support such as allergies, our planner will be happy to assist.",
          "title": "For Families with Special Needs",
          "url": "https://preschool-exchange.com/#planner"
        },
        "fee": {
          "link": "What is included in the fee?",
          "notes": "Please see below for information about the price details.",
          "title": "About the Price",
          "url": "https://preschool-exchange.com/#plan"
        },
        "landing_page": {
          "about": "",
          "company_info": "",
          "conditions": "Conditions of Transaction",
          "contact_about_banner": "",
          "contact_modal": {
            "after_booking": "",
            "before_booking": "",
            "go_to_line": "",
            "go_to_mail": "",
            "title": ""
          },
          "contact_via_line": "",
          "elementary_school": "",
          "faq": "",
          "inquiries": "Inquiries",
          "invite_friend": "",
          "kitchhike_company": "",
          "mypage_button": "Participant Families Only - MyPage",
          "operation_company": "",
          "plan_contact": "",
          "plan_hint": "",
          "plan_list": "",
          "price_plan": "",
          "privacy_policy": "Privacy Policy",
          "recruit": "",
          "related_service": "",
          "responsibility": "",
          "search_plan": "",
          "stipulation": "Stipulation for Travel Agency",
          "study_abroad_experience": "",
          "study_abroad_tax": "",
          "terms_of_use": "Terms of Service",
          "title": "",
          "travel_deal_details": "Travel Transaction Details",
          "your_nursery": ""
        },
        "request": {
          "link_1": "Request to All Families",
          "link_2": "Cancellation Policy",
          "notes_1": "The Preschool Exchange program is a collaborative initiative involving childcare/educational facilities, accommodations, and local communities.",
          "notes_2": "Please review the following list of requests that we kindly ask you to adhere to when participating.",
          "policy_text": "The cancellation policy that applies differs depending on the content of the program.",
          "title": "Read Before Applying",
          "url_1": "https://japan.preschool-exchange.com/request/en"
        },
        "sitemap": {
          "link_text_1": "Management Company",
          "link_text_2": "Contact Us",
          "link_text_3": "Details of Travel Transactions",
          "link_text_4": "Travel Agency Terms and Conditions",
          "link_text_5": "Conditions of Transaction",
          "url_1": "https://kitchhike.jp/",
          "url_2": "mailto:support@hoikuen-ryugaku.zendesk.com",
          "url_3": "https://hoikuen-ryugaku.com/travel-deal-details",
          "url_4": "https://japan.preschool-exchange.com/stipulation/en",
          "url_5": "https://japan.preschool-exchange.com/conditions/en"
        }
      },
      "google_tag_manager": {
        "id": "GTM-KN865G3B"
      },
      "header": {
        "back_path_text": "Service Site",
        "logo": "/images/logo_image_en.jpg",
        "menu": {
          "mypage": "MyPage",
          "mypage_top": "MyPage",
          "service_top": "Service Site"
        },
        "title": "Application Site",
        "url": "https://preschool-exchange.com/"
      },
      "message_bar": {
        "holiday": "--- Notice of year-end and New Year holidays ---\nHoliday period: December 30, 2025 (Tue.) - January 4, 2026 (Sun.)\nReservation request results will be confirmed and communicated sequentially from January 5, after the New Year.\nWe apologize for any inconvenience this may cause and appreciate your understanding and cooperation.\n",
        "maintenance": "Due to ongoing system maintenance, operations may be unstable. If you encounter any issues, please wait a moment and try again later."
      }
    },
    "csv_upload": {
      "created": {
        "one": "Created %{count} record.",
        "other": "Created %{count} records."
      },
      "error": "Failed to upload CSV file.",
      "error_detail": {
        "all_records_skipped": "All records were skipped as they already exist.",
        "kintone_sync_failed": "Failed to sync with Kintone.",
        "no_valid_records": "No valid records found.",
        "save_failed": "Failed to save to database.",
        "transaction_failed": "Transaction failed."
      },
      "more_errors": "%{count} more errors",
      "no_file": "No CSV file selected.",
      "row": "Row %{number}",
      "skipped": {
        "one": "Skipped %{count} record (existing data).",
        "other": "Skipped %{count} records (existing data)."
      },
      "success": "CSV file uploaded successfully.",
      "with_errors": {
        "one": "%{count} error occurred.",
        "other": "%{count} errors occurred."
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "date_full_with_weekday": "%Y-%m-%d, %a",
        "date_full_with_weekday_and_year": "%Y/%m/%d(%a)",
        "default": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "short": "%b %d",
        "year_and_month_and_day": "%-b %-d, %Y"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Seconds",
        "year": "Year"
      },
      "relative": {
        "future": "in %{time}",
        "past": "%{time} ago"
      }
    },
    "day": {
      "formats": {
        "short": {
          "friday": "Fri",
          "monday": "Mon",
          "saturday": "Sat",
          "sunday": "Sun",
          "thursday": "Thu",
          "tuesday": "Tue",
          "wednesday": "Wed"
        }
      }
    },
    "devise": {
      "confirmations": {
        "account_verified": "Account verified.",
        "already_confirmed": "This email address has already been confirmed.",
        "confirmation_sent": "A confirmation email has been sent.",
        "confirmed": "Your email address has been successfully confirmed.",
        "failed": "Failed to confirm your email address. The confirmation link may be invalid or the email address may have already been confirmed.",
        "new": {
          "resend_confirmation_instructions": "Resend confirmation instructions"
        },
        "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
      },
      "failure": {
        "already_authenticated": "You are already signed in.",
        "inactive": "Your account is not activated yet.",
        "invalid": "Invalid %{authentication_keys} or password.",
        "last_attempt": "You have one more attempt before your account is locked.",
        "locked": "Your account is locked.",
        "not_found_in_database": "Invalid %{authentication_keys} or password.",
        "timeout": "Your session expired. Please sign in again to continue.",
        "unauthenticated": "You need to sign in or sign up before continuing.",
        "unconfirmed": "Your email address has not been confirmed yet. Use \"Haven't confirmed your email? Click here\" below to resend the confirmation email, then open the link in that email to complete confirmation."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirm my account",
          "greeting": "Welcome %{recipient}!",
          "instruction": "You can confirm your account email through the link below:",
          "subject": "Confirmation instructions"
        },
        "email_changed": {
          "greeting": "Hello %{recipient}!",
          "message": "We're contacting you to notify you that your email has been changed to %{email}.",
          "message_unconfirmed": "We're contacting you to notify you that your email is being changed to %{email}.",
          "subject": "Email Changed"
        },
        "password_change": {
          "greeting": "Hello %{recipient}!",
          "message": "We're contacting you to notify you that your password has been changed.",
          "subject": "Password Changed"
        },
        "reset_password_instructions": {
          "action": "Change my password",
          "greeting": "Hello %{recipient}!",
          "instruction": "Someone has requested a link to change your password. You can do this through the link below.",
          "instruction_2": "If you didn't request this, please ignore this email.",
          "instruction_3": "Your password won't change until you access the link above and create a new one.",
          "subject": "Reset password instructions"
        },
        "unlock_instructions": {
          "action": "Unlock my account",
          "greeting": "Hello %{recipient}!",
          "instruction": "Click the link below to unlock your account:",
          "message": "Your account has been locked due to an excessive number of unsuccessful sign in attempts.",
          "subject": "Unlock instructions"
        }
      },
      "omniauth_callbacks": {
        "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
        "success": "Successfully authenticated from %{kind} account."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Change my password",
          "change_your_password": "Change your password",
          "confirm_new_password": "Confirm new password",
          "new_password": "New password"
        },
        "new": {
          "forgot_your_password": "Forgot your password?",
          "send_me_reset_password_instructions": "Send me reset password instructions"
        },
        "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
        "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
        "token_expired_html": "The password reset link has expired.<br> If you have received multiple password reset emails, please use the <strong>most recent email</strong> to reset your password.<br> If needed, please try password reset again.\n",
        "token_invalid_html": "The password reset link is invalid.<br> It may have already been used or the URL may be incorrect.<br> Please try password reset again.\n",
        "updated": "Your password has been changed successfully. You are now signed in.",
        "updated_not_active": "Your password has been changed successfully."
      },
      "registrations": {
        "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
        "edit": {
          "are_you_sure": "Are you sure?",
          "cancel_my_account": "Cancel my account",
          "currently_waiting_confirmation_for_email": "Currently waiting confirmation for: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "leave blank if you don't want to change it",
          "title": "Edit %{resource}",
          "unhappy": "Unhappy?",
          "update": "Update",
          "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
        },
        "invalid_credentials": "Invalid email or password.",
        "new": {
          "sign_up": "Sign up"
        },
        "signed_up": "Welcome! You have signed up successfully.",
        "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
        "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
        "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
        "update_needs_confirmation": "Profile has been successfully updated, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
        "updated": "Your account has been updated successfully.",
        "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
      },
      "sessions": {
        "already_signed_out": "Signed out successfully.",
        "new": {
          "sign_in": "Log in"
        },
        "signed_in": "Signed in successfully.",
        "signed_out": "Signed out successfully."
      },
      "shared": {
        "links": {
          "back": "Back",
          "didn_t_receive_confirmation_instructions": "Didn't receive confirmation instructions?",
          "didn_t_receive_unlock_instructions": "Didn't receive unlock instructions?",
          "forgot_your_password": "Forgot your password?",
          "sign_in": "Log in",
          "sign_in_with_provider": "Sign in with %{provider}",
          "sign_up": "Sign up"
        },
        "minimum_password_length": {
          "one": "(%{count} character minimum)",
          "other": "(%{count} characters minimum)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Resend unlock instructions"
        },
        "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
        "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
        "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
      }
    },
    "discount_code_mailer": {
      "discount_code_email": {
        "subject": "The referral code has been successfully issued [Preschool Exchange]"
      }
    },
    "enumerize": {
      "kintone/family_master": {
        "allergenic_foods": {
          "buckwheat": "Buckwheat",
          "crab": "Crab",
          "egg": "Egg",
          "fruit": "Fruits",
          "meat_fish": "Meat/Fish",
          "milk": "Milk/Milk and dairy products",
          "others": "Others",
          "peanut": "Peanut",
          "shellfish": "Crustaceans",
          "shrimp": "Shrimp",
          "soy": "Beans, Grains, Seeds",
          "soybean": "Soybean",
          "walnut": "Walnut",
          "wheat": "Wheat"
        },
        "allergy_elimination": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "appetite_food": {
          "high": "Hearty appetite",
          "low": "Limited appetite",
          "normal": "Average appetite"
        },
        "baby_food": {
          "before_start": "Before starting solid food introduction.",
          "complete": "Transitioned to a fully solid food diet.",
          "early": "Introducing simple, pureed or mashed foods.",
          "late": "Introducing soft, small pieces of food and encouraging self-feeding.",
          "middle": "Introducing a variety of textured foods.",
          "toddler": "Toddler meals"
        },
        "breastfeeding": {
          "breast_milk": "Exclusively breastfeeding",
          "formula": "Formula milk",
          "mixed": "Mixed feeding",
          "weaned": "Weaned"
        },
        "business": {
          "company_employee_1": "Company employee",
          "company_employee_2": "Company employee (support staff)",
          "contract_employee": "Contract employee / Temporary employee",
          "housewife": "Housewife/Househusband",
          "manager": "Manager / Executive",
          "medical_personnel": "Medical personnel",
          "other": "Other",
          "part_timer": "Part-timer",
          "professional": "Professional (Certified Public Accountant, Lawyer, Certified Tax Accountant, Judicial Scrivener)",
          "public_employee": "Public employee (excluding teacher)",
          "retired": "Retired",
          "self_employed": "Self-employed",
          "student": "Student",
          "teacher": "Teacher",
          "unemployed": "Unemployed"
        },
        "development_concerns": {
          "attention": "Sustaining attention / hyperactivity",
          "communication": "Language comprehension / communication",
          "group_rules": "Behaving in a group / following rules",
          "instruction": "Responding to / understanding group instructions",
          "motor": "Fine motor skills / body movement",
          "sensory": "Sensory sensitivity (over- or under-sensitive)",
          "transition": "Switching between activities / tantrums"
        },
        "development_current_support": {
          "none": "No special support",
          "not_attending": "Not attending a school/facility",
          "teacher_care": "Individual attention from the class teacher (no aide)",
          "with_aide": "Has an aide or support staff"
        },
        "development_professional_support": {
          "not_using": "Not using",
          "using": "Using (developmental support or medical services)"
        },
        "developmentaldisorder": {
          "concern": "No diagnosis, but there are some concerns",
          "diagnosed": "Has received a diagnosis",
          "no_answer": "No",
          "none": "Nothing in particular",
          "yes_answer": "Yes"
        },
        "dietary_restriction_elimination_level": {
          "complete": "Complete elimination | The ingredient is not used (trace amounts tolerated)",
          "conditional": "Conditional | Can be eaten if heated or processed",
          "legacy_no": "Allergen-free meals not requested",
          "legacy_yes": "Allergen-free meals requested",
          "strict": "Strict elimination | No stock, extracts, or trace amounts"
        },
        "dietary_restriction_type": {
          "halal": "Halal",
          "kosher": "Kosher",
          "other": "Other",
          "pescatarian": "Pescatarian",
          "vegan": "Vegan",
          "vegetarian": "Vegetarian"
        },
        "exercise": {
          "crawling": "Crawling",
          "rolling_over": "Rolling Over",
          "standing_with_support": "Standing with Support",
          "walking": "Walking"
        },
        "family_relationship": {
          "brother": "Brother/Sister",
          "father": "Father",
          "grandfather": "Grandfather",
          "grandmother": "Grandmother",
          "member": "member",
          "mother": "Mother",
          "other": "Other"
        },
        "food_allergies_yes_or_no": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "food_allergy_anaphylaxis_history": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "food_allergy_elimination_level": {
          "complete": "Complete elimination | The ingredient is not used (trace amounts tolerated)",
          "conditional": "Conditional | Can be eaten if heated or processed",
          "legacy_no": "Allergen-free meals not requested",
          "legacy_yes": "Allergen-free meals requested",
          "strict": "Strict elimination | No stock, extracts, or trace amounts"
        },
        "food_allergy_epipen": {
          "have": "Yes (the school/facility may need to administer it)",
          "not_have": "No"
        },
        "food_allergy_guardian_visit": {
          "can_visit": "A parent or guardian can come to the school/facility to administer medication",
          "cannot_visit": "It is difficult for a parent or guardian to come"
        },
        "food_allergy_medication_required": {
          "not_required": "Not required",
          "required": "Required (antihistamines, etc.)"
        },
        "food_allergy_severity": {
          "mild": "Mild (skin symptoms only)",
          "moderate": "Moderate (multiple symptoms)",
          "severe": "Severe (history of anaphylaxis)"
        },
        "foodrequest_yes_or_no": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "gender": {
          "female": "Female",
          "male": "Male",
          "other": "Other"
        },
        "medical_current_status": {
          "observing": "Under observation",
          "remission": "In remission / recovered",
          "treating": "Under treatment / on medication"
        },
        "medical_history": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "medical_support_level": {
          "daily": "Daily support needed (medication management, daily care, etc.)",
          "on_symptom": "Support needed only when symptoms appear",
          "share_only": "For information only (no special support needed)"
        },
        "napping": {
          "alone": "Nap alone",
          "carried": "Needs to be carried on someone's back",
          "cuddle": "Needs a companion for napping",
          "held": "Nap while being held or carried"
        },
        "nonfood_allergies": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "nonfood_allergy_causes": {
          "animal": "Animals",
          "house_dust": "House dust",
          "insect": "Insects",
          "medicine": "Medications",
          "metal": "Metals",
          "other": "Other",
          "pollen": "Pollen",
          "sunlight": "Sunlight"
        },
        "nonfood_allergy_epipen": {
          "have": "Yes (the school/facility may need to administer it)",
          "not_have": "No"
        },
        "nonfood_allergy_severity": {
          "mild": "Mild (for information only, no action needed)",
          "moderate": "Moderate (activity restrictions needed)",
          "severe": "Severe (history of anaphylaxis)"
        },
        "opportunitynurseryschool": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "planned_participation": {
          "daycare": "Preschool Exchange",
          "elementary": "Japan Elementary Exchange and Camp Programs"
        },
        "question1": {
          "answer": "Confirmed"
        },
        "same_as_representative_address": {
          "same_as_representative_address": "same_as_representative_address"
        },
        "same_as_representative_phone_number": {
          "same_as_representative_phone_number": "same_as_representative_phone_number"
        },
        "school_type": {
          "national": "National",
          "private": "Private",
          "public": "Public"
        },
        "toilet": {
          "fail": "Cannot use toilet",
          "success": "Can use toilet",
          "training": "Practicing"
        },
        "underwear": {
          "cloth_diaper": "Cloth diapers",
          "cloth_pants": "Cloth Pants",
          "disposable_diaper": "Paper diapers",
          "training_pants": "Training Pants"
        }
      },
      "kintone/representative_user_master": {
        "business": {
          "company_employee_1": "Company employee",
          "company_employee_2": "Company employee (support staff)",
          "contract_employee": "Contract employee / Temporary employee",
          "housewife": "Housewife/Househusband",
          "manager": "Manager / Executive",
          "medical_personnel": "Medical personnel",
          "other": "Other",
          "part_timer": "Part-timer",
          "professional": "Professional (Certified Public Accountant, Lawyer, Certified Tax Accountant, Judicial Scrivener)",
          "public_employee": "Public employee (excluding teacher)",
          "retired": "Retired",
          "self_employed": "Self-employed",
          "student": "Student",
          "teacher": "Teacher",
          "unemployed": "Unemployed"
        },
        "co_workers": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "family_relationship": {
          "brother": "Brother/Sister",
          "father": "Father",
          "grandfather": "Grandfather",
          "grandmother": "Grandmother",
          "member": "member",
          "mother": "Mother",
          "other": "Other"
        },
        "gender": {
          "female": "Female",
          "male": "Male",
          "other": "Other"
        }
      },
      "kintone/reservation_request": {
        "interview": {
          "cooperation": "Cooperation.",
          "no_cooperation": "I will not cooperate."
        },
        "prtrait_right": {
          "limited_permission": "I give permission for my photos to be shared exclusively for personal use by persons/guardians associated with the childcare/educational facility (e.g., in communication notebooks, etc.).",
          "no_permission": "I do not permit the publication of photographs.",
          "yes_permission": "I give permission for my photo to be published."
        },
        "route": {
          "facebook": "Facebook",
          "family": "Referral from parents or family members",
          "flyers": "Flyers",
          "friends": "Referral from a friend or colleague",
          "instagram": "Instagram",
          "line": "LINE",
          "newspapers": "Newspapers",
          "other": "Other",
          "preschool": "Referral from the preschool my child attends",
          "search": "Web Search",
          "tv": "TV",
          "web_news": "Web news/web articles",
          "x": "X",
          "youtube": "Youtube"
        }
      }
    },
    "error_page": {
      "back_path": "Back to Bookable Destinations"
    },
    "errors": {
      "connection_refused": "Oops! Failed to connect to the Web Console middleware.\nPlease make sure a rails development server is running.\n",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "already_confirmed": "was already confirmed, please try signing in",
        "blank": "can't be blank",
        "confirmation": "doesn't match Password.",
        "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "expired": "has expired, please request a new one",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "in": "must be in %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid.",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "not_found": "not found",
        "not_locked": "was not locked",
        "not_saved": {
          "one": "1 error prohibited this %{resource} from being saved:",
          "other": "%{count} errors prohibited this %{resource} from being saved:"
        },
        "odd": "must be odd",
        "only_numbers_allowed": "Please enter numbers only.",
        "other_than": "must be other than %{count}",
        "password_invalid": "Password is invalid.",
        "password_too_long": "is too long",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": "is too short (minimum is %{count} characters).",
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "rate_limit_exceeded": "Rate limit exceeded. Please try again later.",
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      },
      "unacceptable_request": "A supported version is expected in the Accept header.\n",
      "unavailable_session": "Session %{id} is no longer available in memory.\n\nIf you happen to run on a multi-process server (like Unicorn or Puma) the process\nthis request hit doesn't store %{id} in memory. Consider turning the number of\nprocesses/workers to one (1) or using a different server in development.\n"
    },
    "flash": {
      "actions": {
        "create": {
          "notice": "%{resource_name} was successfully created."
        },
        "destroy": {
          "alert": "%{resource_name} could not be destroyed.",
          "notice": "%{resource_name} was successfully destroyed."
        },
        "update": {
          "notice": "%{resource_name} was successfully updated."
        }
      }
    },
    "hello": "Hello world",
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "complete": "Proceed to Complete",
        "create": "Create %{model}",
        "save": "save",
        "submit": "submit",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "jpe_reservation_lp": {
      "basic_info": {
        "school_lunch_not_provided": "School lunch: Not provided",
        "school_lunch_provided": "School lunch: Provided"
      },
      "destination": {
        "categories": {
          "clover": "Scenic Views",
          "hand-holding-heart": "Family Friendly",
          "hands-holding-circle": "Nature & Wellness",
          "person-skiing": "Activities & Workshops",
          "person-walking-luggage": "City Guide / Sightseeing",
          "torii-gate": "History & Heritage",
          "utensils": "Food / JapaneseCuisine"
        }
      },
      "price": {
        "adults": {
          "one": "%{count} adult",
          "other": "%{count} adults"
        },
        "children": {
          "one": "%{count} child",
          "other": "%{count} children"
        },
        "week": {
          "one": "%{count} week",
          "other": "%{count} weeks"
        }
      }
    },
    "jpe_thank_you_mailer": {
      "thank_you_after_questionnaire": {
        "body_1": "Thank you so much for taking the time to share your feedback with us. Your insights are invaluable in helping us create seamless stays and unforgettable memories for families around the world.",
        "body_2": "As a token of our appreciation and to commemorate your journey, we are delighted to present your Certificate of Participation.",
        "body_3": "This certificate recognizes the successful completion of your program and celebrates the meaningful connections you built across our communities and cultures. We hope it serves as a wonderful reminder of your children's growth in curiosity, kindness, and global awareness during their time in Japan.",
        "certificate_link": "Download Your Certificate Here",
        "certificate_title": "Your Certificate of Participation",
        "closing_1": "Thank you once again for being a part of the Japan Preschool Exchange family. We hope the bonds you formed in Japan last a lifetime, and we look forward to supporting your family's next adventure.",
        "closing_2": "Warm regards,",
        "greeting": "Dear %{family_name} Family,",
        "opportunities_intro": "As you move forward from this program, we have a special invitation for you to stay connected with the JPE community:",
        "opportunities_title": "Exclusive Opportunities for Our JPE Families",
        "photos_body_1": "We would be honored to feature the wonderful moments you captured—whether at the preschool or in the local community—to inspire future families.",
        "photos_body_2": "If you are happy to share your memories, please upload them via the link below:",
        "photos_privacy": "Note on Privacy: We take the safety of our preschools seriously. If other children appear in your footage, we will strictly ensure there are no privacy concerns by confirming with the school before any use in our advertisements or on our website.",
        "photos_title": "Share Your Memories with Us",
        "photos_upload_label": "Upload Link:",
        "photos_upload_url": "https://forms.gle/YZ51RjmTidU4zuX79",
        "subject": "A Heartfelt Thank You from Japan Preschool Exchange"
      }
    },
    "landing_page": {
      "avaiability": {
        "room": {
          "access_way": "Access",
          "bathroom": "Bathroom",
          "check_floor_plan": "Check Floor Plan",
          "drawer_title": "Accommodation Details",
          "environment": "Features",
          "food": "Food",
          "food_text": "Food service: %{food}",
          "max_capacity": "Capacity (Maximum %{count} people)",
          "max_capacity_text": "%{count} people",
          "work_environment": "Work Environment"
        }
      },
      "availability_status": {
        "available": "Available",
        "contact": "Consult via WhatsApp",
        "legend_aria": "Availability status legend",
        "limited_availability": "Limited availability",
        "sold_out": "Sold out"
      },
      "search_calendar": {
        "adults": "Adult",
        "children": "Child",
        "stay_period": "Duration of stay",
        "subtitle": "Change stay dates and number of guests",
        "title": "Check rates",
        "txt_change": ""
      }
    },
    "login": {
      "email": "Email Address",
      "password": "Password",
      "resend_confirmation": "Haven't confirmed your email? Click here",
      "reset_password": "Forgot your password? Click here",
      "submit": "Log In",
      "title": "Login"
    },
    "mailer": {
      "from": "Preschool Exchange Operation Desk <no-reply@kitchhike.com>"
    },
    "message": {
      "error": {
        "address": {
          "load": "Failed to search address. Please enter address manually."
        },
        "card": {
          "expiration_date": {
            "expired": "Your card has expired.",
            "incorrect": "The expiration date of your card is incorrect."
          },
          "number": {
            "incorrect": "The number of your card is incorrect."
          },
          "security_code": {
            "incorrect": "The security code of your card is incorrect."
          }
        },
        "code": {
          "e_000": "An unexpected error has occurred. Please contact the Operation Desk for assistance.",
          "e_001": "The start date is invalid, or the check-in date has already been booked. Please double-check if the dates are available for application.",
          "e_002": "The input parameters are incorrect. Please review the selected destination, plan, and dates.",
          "e_003": "The email address you entered already has an application for this period. Please review the application details sent in the email.",
          "e_004": "The destination could not be found. Please review the selected destination.",
          "e_005": "The plan could not be found. Please review the selected plan.",
          "e_006": "The accommodation could not be found. Please review the selected plan and dates.",
          "e_007": "The accommodation could not be found. Please review the selected plan and dates.",
          "e_008": "The number of available dates for sale does not match the length of stay. Please contact the Operation Desk for assistance.",
          "e_010": "The page you were looking for could not be found."
        },
        "email": {
          "load": "Failed to check if the email address is available for registration."
        },
        "field": {
          "date": "Date"
        },
        "input": {
          "check": "Please check %{field_name}.",
          "email_exists_login_required": "This email address is already registered. Please log in.",
          "enter": "Please enter %{field_name}.",
          "full_capacity": "This date is fully booked and cannot be reserved. Please select a different date.",
          "password_invalid_characters": "%{field_name} contains characters that cannot be used. Spaces, accented characters, full-width characters, and emoji are not allowed.",
          "password_mismatch": "The passwords do not match.",
          "password_too_long": "Your password is too long.",
          "select": "Please select %{field_name}.",
          "valid_enter": "Please enter valid %{field_name}."
        },
        "please_try_again": "Please try again after some time.",
        "promotion": {
          "already_used": "This promotion code has already been used.",
          "invalid_code": "This promotion code is invalid.",
          "invalid_period": "This promotion code is outside of an available period.",
          "invalid_plan": "This promotion code is not applicable to this plan.",
          "own_code": "Your own referral code cannot be used."
        }
      },
      "error_404": "404 Not Found",
      "error_422": "422 Unprocessable Entity",
      "error_500": "500 Internal Server Error"
    },
    "month": {
      "abbr_month_names": {
        "1": "Jan",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec",
        "2": "Feb",
        "3": "Mar",
        "4": "Apr",
        "5": "May",
        "6": "Jun",
        "7": "Jul",
        "8": "Aug",
        "9": "Sep"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "nursery_meeting_email": {
      "to_nursery": {
        "subject": "ご家族の面談予約を承りました【保育園留学 運営事務局】"
      },
      "to_user": {
        "meeting_date_time": "Date and Time: %{meeting_date_time}",
        "nursery_name": "Location: %{nursery_name}",
        "subject": "Online Pre-Meeting Confirmed [Preschool Exchange]",
        "text1": "Thank you for your application. Your meeting has been successfully scheduled.",
        "text2": "Please note that if the application is made within three days of the meeting date, there may be adjustments due to the teacher's childcare schedule. Thank you for your understanding.",
        "text3": "As the scheduled meeting time approaches, please check the meeting item in the ToDo List on your MyPage.",
        "text4": "[Check the ToDo List] ",
        "text5": "Please note that changes or cancellations are generally not accepted.\nHowever, if unforeseen circumstances arise, please contact the Preschool Exchange Operation Desk.",
        "text6": "*Please note that the meeting time is in Japan Time (JST).\nIf you are joining from a different time zone, please make sure to convert the time accordingly.",
        "user_full_name": "Attendee: %{last_name} %{first_name}",
        "user_name": "Dear %{user_name}"
      }
    },
    "ogp": {
      "account": {
        "password": {
          "edit": {
            "title": "JAPAN PRESCHOOL EXCHANGE | Change Password"
          }
        }
      },
      "confirmation": {
        "new": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Resend Confirmation Email"
        }
      },
      "error": {
        "show": {
          "title": "Error"
        }
      },
      "landing_page": {
        "title": "JAPAN PRESCHOOL EXCHANGE | %{nursery_name}"
      },
      "mypage": {
        "index": {
          "title": "JAPAN PRESCHOOL EXCHANGE | My Page"
        }
      },
      "plan": {
        "index": {
          "description": "You can check the plan list of %{alias}.",
          "title": "JAPAN PRESCHOOL EXCHANGE | Plans List of %{alias}"
        },
        "show": {
          "description": "You can check the details of the plan of %{name}.",
          "title": "JAPAN PRESCHOOL EXCHANGE | Plan Detail of %{name}"
        }
      },
      "profile": {
        "show": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Profile"
        }
      },
      "referral_code": {
        "complete": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Referral Code Issuance Completed"
        },
        "new": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Referral Code Issuance Information Entry"
        }
      },
      "registration": {
        "edit": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Email Address Change"
        }
      },
      "reservation": {
        "complete": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Application Complete"
        },
        "confirm": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Application Confirmation"
        },
        "new": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Application Details Input"
        }
      },
      "reset_password": {
        "new": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Reset Password"
        }
      },
      "reviews": {
        "index": {
          "description": "You can check the family voice list of %{alias}.",
          "title": "JAPAN PRESCHOOL EXCHANGE | Family Voice List of %{alias}"
        }
      },
      "session": {
        "new": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Login"
        }
      },
      "site_name": "JAPAN PRESCHOOL EXCHANGE | Application Site",
      "top": {
        "index": {
          "description": "You can check the availability and fees of Preschool Exchange programs.",
          "image": "/images/nursery_OGP_image_en.jpg",
          "title": "JAPAN PRESCHOOL EXCHANGE | Destinations List"
        }
      }
    },
    "password": {
      "confirm_password": "Confirm Password",
      "email": "Email Address",
      "notes_1": "A password reset URL will be sent to the provided email address.",
      "password": "Password",
      "reset_button": "Set Password",
      "reset_email_submit": "Send",
      "title": "Reset Password"
    },
    "plan_detail": {
      "access": {
        "address": "Address : %{postal_code}",
        "title": "Access"
      },
      "accommodation": {
        "title": "Accommodation",
        "type": "Accommodation Type : %{type}, Max. %{capacity} Guests"
      },
      "back_path": "Back to Destination List",
      "carousel": {
        "more": "See More Photos"
      },
      "check_in_out": {
        "check_in": "Check-in",
        "check_out": "Check-out",
        "title": "Check-in and Check-out"
      },
      "childcare": {
        "notes": "Check what to bring and attire",
        "title": "Program Hours",
        "weekdays": "Weekdays : %{start_time}〜%{end_time} (%{hours} hours)"
      },
      "eligibility": "Eligibility : %{eligibility}",
      "extended": {
        "title": "Extended Program Hours"
      },
      "facility": {
        "notes": "Check Facilities Detail",
        "title": "Facilities and Amenities"
      },
      "label": {
        "aboard_accept_class": "Age range",
        "access": "Access",
        "address": "Address",
        "allergy": "Children with Allergies",
        "childcare_time": "Time",
        "elementary_accept_class": "Grade",
        "entry_requirement": "Children without prior preschool experience",
        "extending_time": "Extended Program Hours",
        "google_map": "Check on Google map",
        "lunch": "Preschool Lunch"
      },
      "local": {
        "button": "View Details of This Destination",
        "text": "For more detailed information on the location, such as the charms and features of the preschools, living environment, workspace, neighborhood map, and weekend activities, please visit our website.",
        "title": "Local Information"
      },
      "navigation": {
        "accommodation": "Accommodation Facility",
        "available_plan": "Available Plans",
        "family_voice": "Family Voices",
        "nursery_info": "Preschool / Educational Facility"
      },
      "preschool": "Preschool Facility",
      "remote_work": {
        "title": "Working Space"
      },
      "reservation": {
        "breakdown": "Price Details",
        "button": "Proceed to Next Step",
        "date_range": {
          "select": "Select a Date"
        },
        "modal": {
          "breakdown": {
            "adult_rate": "Adult (tax included, total)",
            "child_rate": "Child (tax included, total)",
            "elementary_aboard": "Elementary Exchange and Camp Programs ×",
            "not_and_elementary": "Not in Program (Aged 7-12) ×",
            "not_and_toddler": "Not in Program (Aged 0-6) ×",
            "nursery_aboard": "Preschool Exchange Program ×",
            "option_price": "Option Price (tax included)",
            "plan_price": "Plan Price (tax included)",
            "title": "Price Breakdown",
            "total": "Total Cost (including tax)"
          },
          "clear": "Clear",
          "close": "Close",
          "people": {
            "adult": "Adult",
            "birthdate_notice": "Please enter your child's date of birth to confirm the class at the time of your stay.",
            "child": "Child",
            "elementary_aboard": "Elementary Exchange and Camp Programs",
            "min_children_notice": "Please enter at least 1 child.",
            "not_and_elementary": "Not in the Program (Aged 7-12)",
            "not_and_toddler": "Not in the Program (Aged 0-6)",
            "notes_1": "Please input your child's age based on the start date of the program. Some plans may have age restrictions.",
            "notes_3": "If there are accompanying family members (adults) for only a few days, please enter the number of people and the length of stay in the Option Selection on the next screen.",
            "nursery_aboard": "Preschool Exchange Program",
            "nursery_elementary_aboard": "保育園留学・小学生留学",
            "study_abroad": "Child",
            "study_abroad_birthdate": "Child %{count} - Date of Birth",
            "title": "Number of Guests"
          },
          "save": "Save"
        },
        "sold_out": "Sold Out",
        "total": "Total Fee"
      },
      "reviews": {
        "read_more": "Read more",
        "read_others": "View all %{count} reviews"
      },
      "room_info": {
        "accommodation_info": "Accommodation Overview",
        "accommodation_type": "Accommodation Type",
        "address": "Address",
        "bathroom": "Bathroom",
        "bedroom": "Bedroom",
        "capacity": {
          "number": {
            "one": "Max. %{count} Person",
            "other": "Max. %{count} People"
          },
          "title": "Capacity"
        },
        "coworking_space": "Coworking Space",
        "kitchen": "Kitchen",
        "laundry": "Laundry",
        "meal_service": "Food Service",
        "pets": "Pet",
        "separate_room": "Separate Workspace for Couples",
        "transportation": "Transportation",
        "wifi": "Wi-Fi"
      },
      "same_region_plan": "Other Plans",
      "section": {
        "access_way": "Access (accommodation↔︎childcare facility)",
        "accommodation": "Accommodation",
        "accommodation_access_aboard": "Access between Educational facility to Accommodation",
        "accommodation_access_nursery": "Access between Preschool to Accommodation",
        "accommodation_info": "Accommodation Overview",
        "available_plan": "Available Plans",
        "educational_facility": "Educational Facility",
        "family_voice": "Family Voices",
        "preschool_facility": "Preschool Facility"
      },
      "view_detail": "View Details of This Destination",
      "view_detail_accommodation": "View Details of This Accommodation"
    },
    "plan_list": {
      "back_path": "Back to Destinations List",
      "component": {
        "accept_class": "Acceptance Class",
        "button": {
          "available_date": "Available Dates",
          "select": "Select",
          "sold_out": "Sold Out"
        },
        "capacity": {
          "all": "Capacity %{count} people",
          "one": "Max. %{count} Person",
          "other": "Max. %{count} People"
        },
        "currency": "JPY",
        "estimate": "Estimate for 2 adults and 1 child",
        "inquire_whatapp": "Inquire via WhatsApp",
        "loading": "Loading...",
        "lp_check_availability": "Check Availability",
        "lp_see_more": "View Details",
        "see_more": "View more",
        "slot": {
          "full": "Sold Out",
          "left": {
            "one": "%{count} Slot left",
            "other": "%{count} Slots left"
          }
        },
        "time": "Program Hours",
        "year_section": "%{year}"
      },
      "empty": {
        "text_1": "There are currently no available plans being offered at this destination.",
        "text_2": "Please search for other destinations."
      },
      "filtering": {
        "content": {
          "count": {
            "one": "Filter Results: %{count} Result",
            "other": "Filter Results: %{count}/%{total} Results"
          },
          "count_result": "Filter Results: %{count} Results",
          "title": "Available Plans"
        },
        "period": {
          "form": "Select a Travel Period",
          "title": "Filter by Travel Period"
        },
        "title": "Filter"
      }
    },
    "plan_search_service": {
      "accept_class_code_map": {
        "0": "0 Year Old",
        "1": "1 Year Old",
        "10": "Grade 5",
        "11": "Grade 6",
        "2": "2 Years Old",
        "3": "3 Years Old",
        "4": "4 Years Old",
        "5": "5 Years Old",
        "6": "Grade 1",
        "7": "Grade 2",
        "8": "Grade 3",
        "9": "Grade 4"
      }
    },
    "price_text": "JPY %{price}",
    "referral_code": {
      "cannot_be_used_for_the_referrers_own": "The referral code cannot be used for the referrer's own application.",
      "cannot_be_used_in_conjunction": "The referral code cannot be used in conjunction with other promotion codes.",
      "click_the_button": "Please enter the referrer's name and email address, then click the button to issue the referral code.",
      "copied_text": "Referral Code: [ %{code_value} ] \n\nDiscount Amount: %{amount_value} JPY\n\nNote: The code can only be used once per person.\n\n\"Preschool Exchange\" is a program that connects local communities with families raising children, building a brighter future together. https://preschool-exchange.com/",
      "copy_completed": "Copy completed",
      "copy_the_referral_code": "Copy the referral code",
      "email_address": "Email Address",
      "errors": {
        "not_valid": "The information does not match our records. Please check the details and try again."
      },
      "first_name": "First name",
      "information_entry": "Referral information entry",
      "issuance_of_referral_code": "Issuance of referral code",
      "issue_the_referral_code": "Issue the referral code",
      "last_name": "Last name",
      "no_expiration_date": "There is no expiration date for the use of the referral code.",
      "please_check_it": "Your referral code has been issued. A confirmation email with your referral code has been sent to the email address you provided. Please check it.",
      "settings_to_allow_receipt_html": "When entering a mobile email address, there may be cases where emails do not arrive. Please ensure you configure your email settings to allow receipt from no-reply@kitchhike.com.",
      "the_same_code_will_be_displayed": "Even if you repeat the issuance process, the same code will be displayed. Please note this.",
      "usage_guidelines": "Usage Guidelines",
      "use_the_referral_code_only_once": "The referred person can use the referral code only once.",
      "you_can_share": "You can share your referral code with as many people as you like.",
      "your_referral_code": "Your referral code"
    },
    "registration": {
      "edit": {
        "email": "Representatives email address",
        "password": "Password",
        "submit": "Change",
        "title": "Change Email Address"
      }
    },
    "reservation": {
      "children_info": {
        "count": "Child #%{count}",
        "title": "Participating Child(ren)"
      },
      "daycare_experience_modal": {
        "button_contact": "Consult with a Planner",
        "button_continue": "Find Other Destinations",
        "text_1": "The facility you have selected has difficulty accommodating children without daycare experience for safety and operational reasons.",
        "title": "Notice Regarding Childcare",
        "validation_text": "The selected facility cannot accommodate children without at least 3 days of daycare experience, so the reservation cannot proceed."
      },
      "food_allergy_modal": {
        "button_contact": "Consult with a Planner",
        "button_continue": "Find Other Destinations",
        "text_1": "The facility you have selected has difficulty accommodating children with food allergies. Your reservation request may not be accepted.",
        "text_2": "We can suggest facilities that meet your requirements.",
        "title": "Notice Regarding Childcare"
      },
      "full_capacity_modal": {
        "button_contact": "Consult with a Planner",
        "button_contact_url": "mailto:support@hoikuen-ryugaku.zendesk.com",
        "button_continue": "Find Other Destinations",
        "text_1": "The class and dates you have selected are currently at full capacity.",
        "text_2": "We apologize for the inconvenience, but please select other dates or destinations.",
        "title": "Capacity Reached"
      },
      "heart_modal": {
        "check_text": "I agree to the Guidelines for Participating Families above.",
        "holiday_check_text": "I understand and acknowledge the holiday notice above.",
        "mission": "Our mission is to create a future where families can fully enjoy life and vibrant communities continue to thrive. To support the sustainability of this program, we ask you to follow the guidelines below to enjoy your stay.",
        "rule_1": "Respect the local community and express your gratitude.",
        "rule_2": "Understand and respect the philosophy of each childcare/educational facility.",
        "rule_3": "Follow good manners and stick to drop-off and pick-up times.",
        "rule_4": "Prioritize your child’s growth.",
        "rule_5": "Follow accommodation rules.",
        "rule_6": "Follow local living rules.",
        "sub_subscription": "Preschool Exchange",
        "sub_title": "Guidelines for Participating Families",
        "submit": "Proceed to Application",
        "subscription": "Please review the following before proceeding with your application.",
        "text_1": "Japan Preschool/Elementary School Exchange is a local living experience, not a sightseeing tour. Please act respectfully as a member of the local community.",
        "text_2": "You will experience the daily activities of the childcare/educational facilities as they are. Interpretation devices may be used in some cases, but communication with teachers is primarily conducted in Japanese. Even if different from your own values, use this opportunity to learn and grow with your child.",
        "text_3": "While some facilities may offer extended hours, please adhere to the scheduled times. Excessive requests may result in the cancellation of your participation.",
        "text_4": "The goal of the program is to support your child’s healthy growth and enriching experiences within the community. The local childcare/educational facilities, accommodations, municipalities, and the entire city/town welcome your family with this in mind. If your main goal is relaxation, please consider other services.",
        "text_5": "Accommodations may include local-government-operated facilities as well as hotels and inns. Respect their rules and schedules, and avoid making excessive requests.",
        "text_6": "Please comply with local rules, such as waste sorting and traffic regulations. Be mindful of your behavior, and follow the rules and schedules when using local facilities or services to ensure a positive experience for everyone.",
        "title": "Application Terms Confirmation"
      },
      "progress": {
        "complete": "Complete",
        "confirm": "Confirm",
        "enter": "Enter"
      },
      "representative": {
        "occupation": {
          "company_employee": "Company employee",
          "company_employee_support": "Company employee (support staff)",
          "contract_temporary": "Contract employee / Temporary employee",
          "default": "Select",
          "employer": "Employer (Optional)",
          "house": "Housewife / Househusband",
          "income": "Are you a double income or single income family?",
          "item": "Occupation",
          "manager": "Manager / Executive",
          "medical": "Medical personnel",
          "no_answer": "Single Income",
          "other": "Other",
          "part_time": "Part-timer",
          "professional": "Professional (Certified Public Accountant, Lawyer, Certified Tax Accountant, Judicial Scrivener)",
          "public_employee": "Public employee (excluding teacher)",
          "retired": "Retired",
          "self_employ": "Self-employed",
          "student": "Student",
          "teacher": "Teacher",
          "title": "Occupation",
          "unemploy": "Unemployed",
          "yes_answer": "Double Income"
        }
      },
      "room_capacity_modal": {
        "button_contact": "Consult with a Planner",
        "button_contact_url": "mailto:support@hoikuen-ryugaku.zendesk.com",
        "button_continue": "Find Other Destinations",
        "capacity_adults": "up to %{count} adult(s)",
        "capacity_children": "up to %{count} child(ren)",
        "capacity_separator": ", ",
        "capacity_total": "%{count} guest(s) in total",
        "text_1": "The party you specified (%{adults} adult(s) and %{children} child(ren)) exceeds the capacity of the accommodation you selected.",
        "text_2": "This accommodation accepts %{capacity}. We apologize for the inconvenience, but please change the number of guests or select another accommodation or destination.",
        "title": "Exceeds the Accommodation Capacity"
      },
      "summary": {
        "accommodation": "Accommodation : %{accommodation}",
        "adult": {
          "one": "%{count} Adult",
          "other": "%{count} Adults"
        },
        "button": "View Plan Details",
        "child": {
          "one": "%{count} Child",
          "other": "%{count} Children"
        },
        "people": "Number of Guests : ",
        "period": "Period : %{start_date}~%{end_date}",
        "preschool": "Childcare/Educational Facility : %{preschool}"
      }
    },
    "reservation_complete": {
      "back_path": "Back to Bookable Destinations",
      "heading": "Application Submitted",
      "notes_1": "Please be aware that we may not be able to accommodate your application.",
      "notes_10": "Your account has been successfully created.",
      "notes_11": "A confirmation email has been sent for account verification,",
      "notes_12": "so please check your inbox.",
      "notes_2": "Please wait to arrange transportation or make any other preparations until your application is confirmed.",
      "notes_3": "We will now proceed with the final confirmation of availability with the preschool and accommodation. Once this is complete, your application will be confirmed. ",
      "notes_4": "A confirmation email with further instructions will be sent to your registered email address within three business days. Please wait for this email.",
      "notes_5": "Until your application is confirmed, please avoid making any arrangements for the following:",
      "notes_6": "Airplane or train tickets",
      "notes_7": "Rental car reservations",
      "notes_8": "Cancellation insurance, etc.",
      "title": "Your application is not yet confirmed."
    },
    "reservation_confirm": {
      "3dsecure": {
        "button": "Regarding 3D Secure Authentication",
        "modal": {
          "body": "To enhance security, 3D Secure authentication is now required when using your credit card.\nDuring the application process, 3D Secure authentication will be conducted to verify that your card is valid for use.\n\nAdditionally, due to the implementation of 3D Secure, the transaction amount may appear as “JPY 0” on the authentication screen. However, authentication and payment processing are handled correctly.\n\nTo continue using our services with confidence, please review this information.",
          "title": "Regarding 3D Secure Authentication"
        }
      },
      "account": {
        "password": "Password",
        "title": "Account Information"
      },
      "card_3ds_error": "3D Secure authentication failed. Please try again or change your card and try again.",
      "caution": {
        "notes": "The application is not confirmed until it is approved by the management.\nPayment is processed on the first day of your stay.\nFor cancellation fees, please refer to our Cancellation Policy.",
        "title": "Application"
      },
      "heading": "Confirmation of Application Details",
      "information": {
        "agree": {
          "check_box": "Agree",
          "notes": "To apply for an application, you must agree to the above contents."
        },
        "cancellation": {
          "cancellation_policy_text": "Cancellation Policy",
          "notes_1": "If you cancel or change the date after submitting your application, a cancellation fee will be charged according to the number of days. The applicable cancellation policy varies depending on the program. For more details, please refer to the",
          "title": "Cancellation Policy"
        },
        "confirmation": {
          "notes": "Applications are not confirmed at the time of submitting your application. We will send a confirmation e-mail to you after we confirm with the childcare/educational facilities and the accommodation. Please note that your application may not be accepted depending on the situation.",
          "title": "Application Confirmation"
        },
        "local_taxes": {
          "notes": "Local taxes such as accommodation or bath tax may apply and are not included in the price. These typically range from JPY 100 to JPY 1,000 per person per night. Please pay at the property where applicable.",
          "title": "Notice on Local Taxes"
        },
        "other_item": {
          "cancel_text": "Cancellation Policy",
          "conditions_text": "Conditions of Transaction",
          "conditions_url": "https://japan.preschool-exchange.com/conditions/en",
          "family_text": "Basic Rules for Participating Families",
          "family_url": "https://preschool-exchange.com/family-rules",
          "note": "* The Conditions of Transaction will be provided electronically. Please make sure to review and save the document yourself.",
          "privacy_policy_text": "Privacy Policy",
          "privacy_policy_url": "https://japan.preschool-exchange.com/privacy_policy/en",
          "terms_text": "Terms of Service",
          "terms_url": "https://japan.preschool-exchange.com/terms_of_service/en",
          "title": "Pre-Application Confirmation"
        },
        "request_to_family": {
          "notes_1": "We kindly ask all families, as members of the local community, to adhere to the",
          "notes_2": "Basic Rules for Participating Families.",
          "text": "Basic Rules",
          "title": "Request for All Families",
          "url": "https://preschool-exchange.com/family-rules"
        },
        "title": "Notes and Information"
      },
      "modal_booking": {
        "booking_info": "Reservation Details",
        "button": "Proceed to submitting the application",
        "capacity_over": {
          "adults": "up to %{count} adult(s)",
          "children": "up to %{count} child(ren)",
          "message": "The party you specified exceeds the capacity of this accommodation (%{capacity}). Please change the number of guests, or select another accommodation or destination.",
          "separator": ", ",
          "total": "%{count} guest(s) in total"
        },
        "contact": "Consult via WhatsApp",
        "currency": " yen",
        "currency_man": "yen",
        "holiday_caption": "Holidays may be closed",
        "people": "",
        "period": "Program Duration: ",
        "sold_out": "Sold Out",
        "storage_notice": {
          "allergy": "This preschool may not be able to accept children with food allergies.",
          "school_experience": "This preschool may not be able to accept children who do not have experience attending preschool at least 3 days a week.",
          "title": "Important Notice Regarding Childcare"
        },
        "title": {
          "text_1": "Would you like to proceed to submitting the application with the following details?",
          "text_2": ""
        }
      },
      "payment": {
        "card_info": "Credit Card Information",
        "card_number": "Credit Card Number",
        "error_invalid_email": "The email addresses do not match. Please check again.",
        "expiration_date": "Expiration Date",
        "security_code": "Security Code",
        "title": "Payment Method"
      },
      "price": {
        "breakdown": "Breakdown",
        "breakdown_button": "View Price Breakdown",
        "button": "Submit Application",
        "confirmation": "I confirm that I have read and agree to Conditions of Transaction, Privacy Policy, Terms of Service, Cancellation Policy, and  Basic Rules for Participating Families. I also agree to pay the total amount if my application is approved by the management.",
        "processing": "Processing",
        "total": "Total Fee (tax included)"
      },
      "promotion": {
        "amount": "-JPY %{amount}",
        "applied": "%{code} applied",
        "button": "Apply",
        "code": "Referral Code / Promo Code (Optional)",
        "discount": "Promotional discount : ",
        "title": "Promotions"
      },
      "representative": {
        "address": {
          "country": "Country",
          "email": "E-mail",
          "phone_number": "Phone Number",
          "postal_code": "Postal Code",
          "title": "Address"
        },
        "date_of_birth": "Date of Birth",
        "gender": "Gender",
        "name": "Name (in English)",
        "name_cn": "Name  (in Chinese, if any)",
        "relationship": "Relationship to the Child Participating the Program",
        "title": "Primary Contact"
      }
    },
    "reservation_email": {
      "letter_block_1": {
        "text_1": "This email address is for delivery only.",
        "text_2": "For enquiries, please contact:",
        "text_4": "Thank you for your interest in applying for the Preschool Exchange program.",
        "text_5": "Your application has been received.",
        "text_6": "Your application has not been confirmed yet.",
        "text_7": "We will contact you by e-mail once your application has been confirmed.",
        "text_8": "Please understand in advance that we may not be able to confirm your application,",
        "text_9": "depending on the situation of childcare/educational facility."
      },
      "letter_block_2": {
        "text_1": "[Application details]",
        "text_2": "Plan Name: %{name}",
        "text_3": "Check-in Date: %{start_date}",
        "text_4": "Check-out Date: %{end_date}",
        "text_5": "Representative's Name: %{representative_name}",
        "text_6": "Total Fee: JPY %{total_fee}"
      },
      "letter_block_3": {
        "text_1": "We will now confirm the application details with the host accommodation",
        "text_10": "※If your account registration verification has not been completed, please complete the verification process using the email sent to you separately.",
        "text_11": "Login URL: %{login_url}",
        "text_12": "Cancellation or Change of Application",
        "text_13": "If you wish to cancel or change your reservation, a cancellation fee will be charged.",
        "text_14": "The cancellation policy that applies differs depending on the content of the program.Please refer to our <a href=\"https://preschool-exchange.com/cancellation_policy\">Cancellation Policy</a> for details.",
        "text_15": "We sincerely hope that the Preschool Exchange program will be a wonderful experience for your child(ren) and your family.",
        "text_2": "and childcare/educational facility and make final arrangements,",
        "text_3": "and let you know via your registered e-mail address in about 5 business days.",
        "text_4": "Please note that we may offer online consultation sessions depending on your application status and other circumstances.",
        "text_5": "If you have any preferences, we are also open to conducting online consultation sessions.",
        "text_6": "Please feel free to let us know.",
        "text_7": "[About MyPage]",
        "text_8": "You can check your application details from MyPage.",
        "text_9": "Once your application is approved, you can also review the necessary procedures via the ToDo List on your MyPage."
      },
      "letter_block_4": {
        "text_1": "Preschool Exchange Operation Desk",
        "text_2": "Website: %{jpe_url}",
        "text_3": "E-mail: %{support_email}",
        "text_4": "Please allow 3 to 4 business days for a reply (excluding Saturdays, Sundays, and holidays).",
        "text_5": "Management Company: KitchHike, Inc.",
        "text_6": "92-1 Kamisato, Assabu-cho, Hiyama-gun, Hokkaido, Japan"
      }
    },
    "reservation_input": {
      "accordion": {
        "icon_message": "There are issues with the input fields.",
        "icon_message_missing": "There are fields that have not been filled in.",
        "message_no_selected": "No Selection",
        "message_not_input": "No Entries"
      },
      "children_info": {
        "allergy": {
          "allergenic_foods": {
            "beans_grains_nuts": "Beans, Grains, Seeds",
            "buckwheat": "Buckwheat",
            "crab": "Crab",
            "default": null,
            "egg": "Egg",
            "fruits": "Fruits",
            "meat_fish": "Meat and Fish",
            "milk": "Milk and dairy products",
            "other": "Other",
            "peanut": "Peanut",
            "shellfish": "Crustaceans",
            "shrimp": "Shrimp",
            "soybean": "Soybean",
            "title": "Please select the foods that cause the allergies.",
            "validation_title": "an answer",
            "walnut": "Walnut",
            "wheat": "Wheat"
          },
          "allergy_causes": {
            "default": null,
            "title": "Please specify the allergens.",
            "validation_title": "an answer"
          },
          "allergy_elimination": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Do you wish to have allergen-free meals provided?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "anaphylaxis": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Has this child ever had an anaphylactic reaction?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "availability": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Does this child have any food allergies?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "elimination_level": {
            "complete": "Complete elimination | The ingredient is not used (trace amounts tolerated)",
            "conditional": "Conditional | Can be eaten if heated or processed",
            "default": "Please select",
            "legacy_no": "Allergen-free meals not requested",
            "legacy_yes": "Allergen-free meals requested",
            "strict": "Strict elimination | No stock, extracts, or trace amounts",
            "title": "Level of elimination",
            "validation_title": "an answer"
          },
          "epipen": {
            "default": "Please select",
            "have": "Yes (the school/facility may need to administer it)",
            "not_have": "No",
            "title": "Does this child carry an epinephrine auto-injector (EpiPen)?",
            "validation_title": "an answer"
          },
          "foodrequest": {
            "default": null,
            "title": "Fill in any special requests for meals.",
            "validation_title": "an answer"
          },
          "foodrequest_yes_or_no": {
            "default": "Please select",
            "description": "Please list restrictions due to a medical condition or diagnosis under \"Medical history\". This section is only for religious, ethical, or lifestyle restrictions.",
            "no_answer": "No",
            "title": "Is there any special consideration needed regarding meals due to religious reasons or a plant-based diet (such as vegetarianism)?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "guardian_visit": {
            "can_visit": "A parent or guardian can come to the school/facility to administer medication",
            "cannot_visit": "It is difficult for a parent or guardian to come",
            "default": "Please select",
            "description": "Some schools/facilities cannot have staff administer medication. We will let you know individually when confirming acceptance.",
            "title": "Can a parent or guardian come to the school/facility?",
            "validation_title": "an answer"
          },
          "legacy_title": "Meal and Allergy Information",
          "medication": {
            "default": "Please select",
            "not_required": "Not required",
            "required": "Required (antihistamines, etc.)",
            "title": "Is medication required?",
            "validation_title": "an answer"
          },
          "nonfood_allergies": {
            "default": "Please select",
            "description": "Mild conditions such as hay fever or mild rhinitis do not need to be listed. Please list anything that affects activities at the school/facility or that requires emergency response.",
            "no_answer": "No",
            "title": "Does this child have any non-food allergies?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "other_food_name": {
            "default": null,
            "title": "If other, please specify the ingredients.",
            "validation_title": "an answer"
          },
          "question1": {
            "confirmation": "Confirmed",
            "title": "Please consult with the childcare/educational facility directly at the time of the online pre-meeting and follow the necessary procedures if your child has any special dietary needs. Please note that the availability and level of accommodation for allergen-free meals may vary by facility.",
            "validation_title": "the confirmation box"
          },
          "severity": {
            "default": "Please select",
            "mild": "Mild (skin symptoms only)",
            "moderate": "Moderate (multiple symptoms)",
            "severe": "Severe (history of anaphylaxis)",
            "title": "Severity",
            "validation_title": "an answer"
          },
          "symptoms": {
            "default": null,
            "description": "Please be sure to provide any considerations or necessary accommodations in daily life, as well as details if anaphylaxis is present.",
            "title": "Please describe the allergy symptoms in detail.",
            "validation_title": "an answer"
          },
          "title": "Meal and Allergy Information"
        },
        "base": {
          "title": "Basic Information"
        },
        "development": {
          "concerns": {
            "attention": "Sustaining attention / hyperactivity",
            "communication": "Language comprehension / communication",
            "group_rules": "Behaving in a group / following rules",
            "instruction": "Responding to / understanding group instructions",
            "motor": "Fine motor skills / body movement",
            "sensory": "Sensory sensitivity (over- or under-sensitive)",
            "title": "Areas of concern",
            "transition": "Switching between activities / tantrums",
            "validation_title": "an answer"
          },
          "current_support": {
            "default": "Please select",
            "none": "No special support",
            "not_attending": "Not attending a school/facility",
            "teacher_care": "Individual attention from the class teacher (no aide)",
            "title": "Support at your current school/facility",
            "validation_title": "an answer",
            "with_aide": "Has an aide or support staff"
          },
          "description": "Whether or not there is a diagnosis, please feel free to let us know anything you are concerned about. This helps the teachers prepare in advance.",
          "professional_support": {
            "default": "Please select",
            "not_using": "Not using",
            "title": "Use of specialist services",
            "using": "Using (developmental support or medical services)",
            "validation_title": "an answer"
          },
          "title": "Development & Group Activities"
        },
        "diet": {
          "elimination_level": {
            "title": "Level of elimination",
            "validation_title": "an answer"
          },
          "other_text": {
            "title": "If \"Other\", please specify",
            "validation_title": "an answer"
          },
          "title": "Dietary Restrictions (religious, ethical, lifestyle)",
          "types": {
            "halal": "Halal",
            "kosher": "Kosher",
            "other": "Other",
            "pescatarian": "Pescatarian",
            "title": "Type of restriction",
            "validation_title": "an answer",
            "vegan": "Vegan",
            "vegetarian": "Vegetarian"
          }
        },
        "enrollment_school": {
          "school_name": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Please name of the school your child currently attends.",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "school_type": {
            "default": "Please select",
            "national": "National",
            "private": "Private",
            "public": "Public",
            "title": "Please select the type of school your child currently attends.",
            "validation_title": "an answer"
          },
          "title": "Educational Experience"
        },
        "gender": {
          "female": "Female",
          "male": "Male",
          "other": "Other"
        },
        "life_habit": {
          "developmentaldisorder": {
            "concern": "No diagnosis, but there are some concerns",
            "default": "Please select",
            "diagnosed": "Has received a diagnosis",
            "no_answer": "No",
            "none": "Nothing in particular",
            "title": "Has your child ever been diagnosed with a developmental disability?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "diagnosis": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Please specify the diagnostic name.",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "language": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Language(s) spoken by this child",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "medical_history": {
            "default": "Please select",
            "description": "Examples: Febrile seizures, Elbow disorder, Epilepsy, Asthma, Kawasaki Disease, or any history of hospitalization and surgery, etc.",
            "no_answer": "No",
            "title": "Does this child have any history of illness, surgery, injury, or treatment?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "medical_history_details": {
            "default": "Please select",
            "description": "Please provide details on the disease, frequency, age at onset, and any current medication. (e.g., Febrile seizures, twice, onset at 18 months, current medication: none).",
            "no_answer": "No",
            "title": "Please specify the details of medical history.",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "opportunitynurseryschool": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Has this child attended any childcare/educational facilities for more than 3 days a week?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "preschool_name": {
            "title": "Please provide the name of the preschool or daycare your child has attended regularly.",
            "validation_title": "Preschool name"
          },
          "preschool_url": {
            "title": "Please share the link to the facility's website, if possible.",
            "validation_title": "Preschool website URL"
          },
          "things_that_need_attention": {
            "title": "Please provide details if there are any developmental delays or considerations needed for your child in a group setting",
            "validation_title": "Developmental delays or considerations"
          },
          "title": "Health and Lifestyle"
        },
        "medical": {
          "condition_name": {
            "placeholder": "e.g., febrile seizures, nursemaid's elbow, asthma",
            "title": "Condition / diagnosis name",
            "validation_title": "an answer"
          },
          "current_status": {
            "default": "Please select",
            "observing": "Under observation",
            "remission": "In remission / recovered",
            "title": "Current status",
            "treating": "Under treatment / on medication",
            "validation_title": "an answer"
          },
          "support_level": {
            "daily": "Daily support needed (medication management, daily care, etc.)",
            "default": "Please select",
            "on_symptom": "Support needed only when symptoms appear",
            "share_only": "For information only (no special support needed)",
            "title": "Level of support needed at the school/facility",
            "validation_title": "an answer"
          },
          "title": "Medical History & Health"
        },
        "nonfood": {
          "causes": {
            "animal": "Animals",
            "house_dust": "House dust",
            "insect": "Insects",
            "medicine": "Medications",
            "metal": "Metals",
            "other": "Other",
            "pollen": "Pollen",
            "sunlight": "Sunlight",
            "title": "Causes",
            "validation_title": "an answer"
          },
          "epipen": {
            "default": "Please select",
            "have": "Yes (the school/facility may need to administer it)",
            "not_have": "No",
            "title": "Does this child carry an epinephrine auto-injector (EpiPen)?",
            "validation_title": "an answer"
          },
          "other_text": {
            "title": "If \"Other\", please specify",
            "validation_title": "an answer"
          },
          "precautions": {
            "title": "Things to avoid / support needed during activities",
            "validation_title": "an answer"
          },
          "severity": {
            "default": "Please select",
            "mild": "Mild (for information only, no action needed)",
            "moderate": "Moderate (activity restrictions needed)",
            "severe": "Severe (history of anaphylaxis)",
            "title": "Severity",
            "validation_title": "an answer"
          },
          "title": "Non-food Allergies"
        },
        "planned_participation": {
          "default": "Please select",
          "elementary_school": "Japan Elementary Exchange and Camp Programs",
          "nursery_school": "Preschool Exchange",
          "title": "Program Type",
          "validation_title": "Program Type"
        },
        "pledge": {
          "acceptance_and_liability": "I understand and agree to the above regarding the acceptance decision, responsibility, and compensation for damages.",
          "agreed": "I agree",
          "declaration_is_true": "I pledge that everything I have declared is true and that I have not intentionally omitted any important information.",
          "description": "Each school/facility decides whether it can accept your child based on the information you provide. Even after your request has been approved, acceptance may be declined if the information differs from the actual situation or if it is judged that your child cannot be safely accommodated.",
          "error": "Please agree to all items in the confirmation and pledge.",
          "notify_on_change": "I agree to promptly notify the office if any of the declared information changes.",
          "title": "Confirmation and Pledge",
          "validation_title": "the pledge boxes"
        },
        "yes_no": {
          "no_label": "No",
          "yes_label": "Yes"
        }
      },
      "heading": "Enter application details",
      "holiday_alert": "Please note that if the program period includes public holidays, the preschool may be closed and childcare will not be available on those days.",
      "modal": {
        "breakdown": {
          "adult_count_format": "Adult × %{number}",
          "count_format": " × %{number}",
          "elementary_aboard": "Elementary Exchange and Camp Programs",
          "not_and_elementary": "Not in Program (Aged 7-12)",
          "not_and_toddler": "Not in Program (Aged 0-6)",
          "nursery_aboard": "Preschool Exchange Program",
          "option_price": "Option Price (tax included)",
          "plan_price": "Plan Price (tax included)",
          "price_number": "JPY %{unit_price} × %{number}",
          "promotion": "Promotions",
          "title": "Price Breakdown",
          "total": "Total Fee (tax included)"
        },
        "close": "Close",
        "error": {
          "body": "In order to proceed with your reservation for this date, you will need to change or cancel your previous reservation. For detailed procedures, please contact the Help Desk.",
          "button": "Contact Help Desk",
          "title": "Date Conflict"
        },
        "overlap_error": {
          "button": "Go Back",
          "message": "You already have a reservation for the same period (%{start_date} to %{end_date}). Overlapping reservations are not allowed.",
          "title": "Reservation Overlap Error"
        },
        "plan_detail": {
          "accommodation": {
            "title": "Accommodation",
            "type": "Accommodation Type : %{type}"
          },
          "adult": "%{count} Adults, ",
          "child": "%{count} Children (Ages)",
          "people": "Number of People: ",
          "period": "Period : %{start_date}~%{end_date}",
          "preschool": {
            "eligibility": "Eligibility : %{eligibility}",
            "title": "Childcare/Educational Facility"
          },
          "preschoolers": {
            "one": "Preschool Participants %{count} Child",
            "other": "Preschool Participants %{count} Children"
          },
          "preschoolers_1": {
            "one": "Not in Program (Aged 0-6) %{count} Child",
            "other": "Not in Program (Aged 0-6) %{count} Children"
          },
          "students": {
            "one": "Elementary School Participants %{count} Child",
            "other": "Elementary School Participants %{count} Children"
          },
          "students_1": {
            "one": "Not in the Program (Aged 7-12) %{count} Child",
            "other": "Not in the Program (Aged 7-12) %{count} Children"
          },
          "title": "Plan Details"
        }
      },
      "option_select": {
        "close": "Close",
        "label": "Option Descriptions",
        "notes": "Review the Option Descriptions for details of the options.",
        "title": "Option Selection (Optional)"
      },
      "price": {
        "breakdown": "Breakdown",
        "button": "Proceed to Confirmation",
        "total": "Total Fee"
      },
      "representative": {
        "account": {
          "account_notes_1": "You will receive an identity verification email once your application is complete.",
          "account_notes_2": "After verification is complete, an account for logging into your My Page will be created.",
          "login": "Log In",
          "login_link": "＞If you already have an account, click here",
          "login_title": "Login",
          "password": "Password",
          "password_confirmation": "Confirm Password",
          "password_description": "Password must be at least 8 characters and include at least one lowercase letter and one number. Symbols are allowed, but spaces, accented characters, and full-width characters are not.",
          "reset_password": "Forgot your password? Click here",
          "title": "Account Information"
        },
        "address": {
          "building": "Building name, etc. (optional)",
          "city_town_village": "City/Town/Village",
          "country": "Country",
          "email": "E-mail",
          "email_notes_1": "Enter the e-mail address at which you would like to receive the application confirmation e-mail. ",
          "email_notes_2": "Please make sure that you can receive e-mails from no-reply@kitchhike.com.",
          "phone_notes_1": "Please enter letters and numbers only, without hyphens (-).",
          "phone_notes_2": "Example: 123-456-7890 → 1234567890",
          "phone_number": "Phone Number",
          "postal_code": "Postal Code",
          "postal_code_notes_1": "Please enter letters and numbers only, without hyphens (-).",
          "postal_code_notes_2": "Example: 123-4567 → 1234567",
          "prefecture": "State/Province",
          "street_address": "Street number/Other address",
          "title": "Address"
        },
        "date_of_birth": "Date of Birth",
        "first_name": "First Name (in English)",
        "first_name_cn": "First Name  (in Chinese, if any)",
        "gender": {
          "female": "Female",
          "male": "Male",
          "other": "Other",
          "title": "Gender"
        },
        "last_name": "Last Name (in English)",
        "last_name_cn": "Last Name  (in Chinese, if any)",
        "relationship": {
          "brother_sister": "Brother / Sister",
          "default": "Select",
          "father": "Father",
          "grand_father": "Grandfather",
          "grand_mother": "Grandmother",
          "mother": "Mother",
          "other": "Other",
          "other_text": "Please describe your relationship to the child",
          "other_text_label": "Other relationship detail",
          "title": "Relationship to the Child Participating the Program"
        },
        "sub_title": "Basic Information",
        "title": "Primary Contact"
      }
    },
    "reservation_mailer": {
      "reservation_email": {
        "from": "Preschool Exchange Operation Desk <no-reply@kitchhike.com>",
        "subject": "Thank you for your application [Preschool Exchange]"
      }
    },
    "reset_password_mailer": {
      "from": "Preschool Exchange Operation Desk <no-reply@kitchhike.com>",
      "subject": "Please Reset Your Password [Preschool Exchange]"
    },
    "review": {
      "posted_date": "%{date}",
      "usage_count": "%{count} time in the program"
    },
    "review_index": {
      "activity_details": "Activity details",
      "back_path": "Back",
      "children_age_text": "Children Age",
      "empty": "Family voices not found.",
      "experienced_activities": "Activities at the preschool",
      "guest_house": "Accommodation",
      "message_locals": "Message to Local People",
      "message_preschool": "Message to Preschool Teachers",
      "number_of_people": {
        "adult": {
          "one": "%{count} Adult",
          "other": "%{count} Adults"
        },
        "child": {
          "one": "%{count} Child",
          "other": "%{count} Children"
        },
        "title": "Number of People",
        "total": {
          "one": "%{count} Person",
          "other": "%{count} People"
        }
      },
      "nursery": "Educational Facility",
      "read_more": "Read more",
      "stay_days": {
        "content": {
          "one": "%{count} Week (From %{date})",
          "other": "%{count} Weeks (From %{date})"
        },
        "title": "Period"
      },
      "translation_note": "This review is AI-translated from Japanese; some expressions may be inaccurate."
    },
    "search": {
      "sections": {
        "popular": {
          "tags": {
            "no_car": {
              "value": "車なしで移動可能"
            }
          }
        }
      }
    },
    "stripe_3ds_request_update_card": {
      "confirm_box": {
        "body": "We checked the validity of your credit card two weeks before the payment date, and we were unable to confirm the validity of your currently registered card.\nWe apologize for the inconvenience, but please change to a different card within 5 days.",
        "button": "Change credit card",
        "title": "Please change your credit card"
      },
      "text_1": "Thank you as always.\nPlease change your credit card.",
      "update_done": "Credit card was successfully updated."
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%Y/%m/%d %H:%M",
        "long": "%B %d, %Y %H:%M",
        "month": "%b",
        "only_time": "%-I:%M %p",
        "short": "%d %b %H:%M",
        "year": "%Y",
        "year_and_month": "%b %Y",
        "year_and_month_and_day": "%-B %-d, %Y"
      },
      "pm": "pm"
    },
    "todo_reminder": {
      "send_one_day_later_reminder": {
        "certificate_note": "The certificate will be sent to you by email approximately one week after we receive your submission.",
        "certificate_text": "As a small thank-you for your time and support, families who share their user voice will receive a <strong>Certificate of Participation</strong>, prepared to celebrate your child's time in Japan.",
        "closing1": "Thank you very much for being part of the Japan Preschool Exchange community.",
        "closing2": "We hope you continue to enjoy the remaining days of your stay.",
        "questionnaire_link_text": "Click here to share your voice",
        "sign_off": "Warm regards,",
        "subject": "Share Your Voice & Receive a Certificate of Participation [Japan Preschool Exchange]",
        "text1": "We hope you are enjoying your time with the Japan Preschool Exchange program.\n\nAs your preschool experience is coming to an end, we would like to kindly ask for your comments about your time in Japan and your child's experience at the preschool.",
        "text2": "Your voice is very important to us.\nYour comments support the preschool teachers and local communities who welcomed your family, and they also help future families feel more confident when considering the Japan Preschool Exchange program.",
        "text3": "If you have a few minutes, we would truly appreciate it if you could share your thoughts through the short questionnaire below.\nIt should take about three minutes to complete."
      },
      "three_days_before_reminder": {
        "link": "[Check your ToDo List] ",
        "subject": "Upcoming Due Date on ToDo List [Preschool Exchange]",
        "text1": "Greetings from the Preschool Exchange Operation Desk.\nWe hope your preparations for your stay are going smoothly.\n",
        "text2": "◾️ Tasks Approaching Due Date",
        "text3": "Please make sure to complete these tasks in time. Once you’ve completed the necessary steps, you’ll be ready to smoothly proceed to the next stage.",
        "text4": "If you have any questions or need support, please don't hesitate to contact the Preschool Exchange Operation Desk.",
        "text5": "Best regards,",
        "time_limit": "Due Date: %{time_limit}"
      },
      "time_limit_reminder": {
        "subject": "Overdue ToDo List [Preschool Exchange]",
        "text1": "The due date for one of the tasks we previously informed you about has passed, but it appears that it has not yet been completed.",
        "text2": "◾️ Incomplete Task",
        "text3": "Please note that if the task remains incomplete, you will not be able to proceed to the next step, which may affect your travel preparations. Kindly log in to your MyPage and complete the necessary steps as soon as possible."
      }
    },
    "top": {
      "category_list": {
        "all": "All",
        "elementary_ok": "Elementary OK",
        "forest_play": "Forest play",
        "heritage": "Heritage",
        "sea_play": "Sea play",
        "snow_play": "Snow play",
        "top_picks": "Top Picks"
      },
      "component": {
        "minimum_price": "From JPY %{minimum_price}",
        "people": "2 Adults, 1 Child"
      },
      "empty": {
        "text_1": "There are no plans that match your search criteria.",
        "text_2": "Please change the time period.",
        "text_3": "We cannot find a destination that matches your search criteria.",
        "text_4": "Please change your search criteria."
      },
      "filtering": {
        "area": {
          "title": "Destination Area"
        },
        "button": {
          "apply": "Apply",
          "clear": "Clear"
        },
        "class": {
          "age": {
            "age_text": "%{age}-Year-Old Class",
            "asterisk": "(*)",
            "birth_period": "%{start_date} - %{end_date}",
            "birth_period_header": "Date of Birth",
            "caution": "(*) The acceptable age varies depending on their age in months. Please refer to the detailed page for each destination for more information.",
            "class_header": "Class",
            "label": "Class Age Table",
            "notes": "Classes are determined according to the Japanese school year calendar. Please confirm your child's class based on the timing of participation and the table below.",
            "period": "For those participating in the Preschool Exchange from April 1, %{start} to March 31, %{end}:",
            "year": "%{year} School Year"
          },
          "option": "%{age} Year Olds Class",
          "text": "Please select your child's class.",
          "title": "Class"
        },
        "content": {
          "count": {
            "one": "Filter Results: %{count} Result",
            "other": "Filter Results: %{count} Results"
          },
          "title": "Destinations List"
        },
        "criteria": "Search By",
        "season": {
          "form": "Select the year and month",
          "text": "Select the year and month you wish to travel.",
          "title": "Travel Period"
        },
        "title": "Filter"
      },
      "heading": "Bookable Destinations",
      "modal_search": {
        "class": {
          "0_year_old_class": "0 Year Old Class",
          "1_year_old_class": "1 Year Old Class",
          "2_years_old_class": "2 Years Old Class",
          "3_years_old_class": "3 Years Old Class",
          "4_years_old_class": "4 Years Old Class",
          "5_years_old_class": "5 Years Old Class",
          "no_attendance": "Not in the Program"
        },
        "default_placeholder": "Filter by Age, Period, and Region",
        "header": "Filter",
        "local_transportation": {
          "option_1": "Accessible Without a Car",
          "title": "Local Transportation",
          "value": "car_free"
        },
        "month": "",
        "month_number_from": " month~",
        "plan_month": {
          "title": "Select the year and month you wish to participate"
        },
        "region": {
          "title": "Destination Area"
        },
        "search_region": {
          "chugoku_shikoku": "Chugoku/Shikoku",
          "hokkaido": "Hokkaido",
          "hokuriku_koshinetsu": "Hokuriku/Koshinetsu",
          "kanto": "Kanto",
          "kyushu_okinawa": "Kyushu/Okinawa",
          "tohoku": "Tohoku",
          "tokai_kinki": "Tokai/Kinki"
        },
        "search_text": {
          "placeholder": "Search by Preschool / Educational Facility or Destination Area"
        },
        "stay_day": {
          "subtitle": "Select Duration",
          "title": "Period"
        },
        "stay_period": "Duration of stay",
        "title": "Filter",
        "value": {
          "0_year_old_class": "0 Year Old",
          "1_year_old_class": "1 Year Old",
          "2_years_old_class": "2 Years Old",
          "3_years_old_class": "3 Years Old",
          "4_years_old_class": "4 Years Old",
          "5_years_old_class": "5 Years Old"
        },
        "week": " week",
        "within_a_week": "Within a week",
        "year": " year"
      },
      "subheading": "Below are destinations that are available for application."
    },
    "update_card_email": {
      "body": "Dear Sir or Madam,\n\nThank you very much for your application for the Preschool Exchange program.\nWe recently attempted to verify the validity of your registered credit card as part of our routine check conducted two weeks before the start of your stay.\nHowever, the authorization was unsuccessful.\n\nWe apologize for any inconvenience this may cause.\nPlease check your credit card status and update your payment information via the link below:\n\n▼ Update Your Credit Card Information Here\n%{update_card_url}\n\nPossible reasons for the authorization failure include:\n- The credit card has expired\n- The credit limit has been exceeded\n- The transaction was blocked due to your card issuer's security settings\nFor more details, please contact your credit card provider.\n\nIf the issue is not resolved, we may not be able to proceed with your reservation.\nTherefore, we kindly ask you to take action as soon as possible.\nIf you have any questions or need assistance, please feel free to contact us.\n%{support_email}\nBest regards,\nPreschool Exchange Operation Desk\n━━━━━━━━━━━━━━━━━━━━━━━━━\nPreschool Exchange Operation Desk\n%{support_email}\n%{jpe_url}\nPlease note that it may take 3-4 business days to\nreceive a response excluding weekends and holidays.\n───────────────────\nOperation Company: KitchHike, Inc.\n92-1 Kamisato, Assabu-cho, Hiyama-gun, Hokkaido, Japan\n%{kitchhike_url}\n━━━━━━━━━━━━━━━━━━━━━━━━━",
      "subject": "[Important] Credit Card Authorization Error [Preschool Exchange]"
    },
    "url": {
      "cancel_policy": "https://preschool-exchange.com/cancellation_policy",
      "conditions": "https://japan.preschool-exchange.com/conditions/en",
      "inquiries": "mailto:support@hoikuen-ryugaku.zendesk.com",
      "privacy_policy": "https://japan.preschool-exchange.com/privacy_policy/en",
      "stipulation": "https://preschool-exchange.com/stipulation",
      "terms_of_use": "https://preschool-exchange.com/terms-of-use",
      "travel_deal_details": "https://japan.preschool-exchange.com/travel_transaction_details/en"
    },
    "views": {
      "admin": {
        "nurseries": {
          "values": {
            "nursery_size": [
              "Micro-sized (〜30)",
              "Small-sized (31〜50)",
              "Mid-sized (51〜100)",
              "Full-sized / Large-sized (101〜)"
            ]
          }
        },
        "planner_search": {
          "capacity": {
            "adults": "%{count} adults > limit %{limit}",
            "children": "%{count} children > limit %{limit}",
            "total": "%{count} people total > capacity %{limit}"
          },
          "close": "Close",
          "empty": {
            "heading": "No availability for check-in on %{date}.",
            "nearest": "Nearest candidate dates: %{dates} (none of them have availability).",
            "none": "No plan x check-in date candidates in this range. Review the date range, region and conditions.",
            "show_excluded_hint": "Turn on \"Include preschools with no availability\" to see the excluded preschools and why.",
            "wday_separator": ", ",
            "wday_suffix": "%{wday}",
            "wdays": "Candidate plans check in on %{wdays}."
          },
          "equipment_labels": {
            "bedroom": "Bedding",
            "kitchen": "Kitchen",
            "laundry": "Laundry",
            "pets": "Pets",
            "wifi": "Wi-Fi"
          },
          "filter": {
            "add_row": "Add row",
            "adults": "Adults",
            "birthday": "Date of birth",
            "birthday_note": "The school year and class are derived per row from what you enter.",
            "children": "Class / Party size",
            "children_note": "Applies per preschool. Classes are resolved by the school year the check-in date falls in.",
            "class_label": "Class (school year)",
            "date_range": "Check-in date range",
            "date_separator": "-",
            "equipment": "Room amenities",
            "equipment_note": "Applies per accommodation. At least one room in the same preschool meets all conditions (AND).",
            "equipment_unset": "Not set: %{count} rooms (%{ratio}%)",
            "equipment_unset_title": "Filtering on this item excludes the %{count} rooms with no value (%{ratio}% of all %{total} rooms).",
            "features": "Preschool features",
            "features_note": "Applies per preschool. Preschools meeting all selected conditions (AND).",
            "fiscal_year": "FY%{year}",
            "kids": "Children",
            "location": "Region / Preschool",
            "location_note": "Specifying a region or preschool also includes unpublished preschools (marked with an \"Unpublished\" badge).",
            "mode_birthday": "By date of birth",
            "mode_class": "By class",
            "nursery_count": "%{count} preschools",
            "nursery_placeholder": "Preschool ID or name",
            "party_note": "Party size is used to check room capacity (adult limit, child limit, total capacity).",
            "prefecture_all": "Prefecture (all)",
            "region_note": "Areas: any of the selected (OR). With a prefecture as well, preschools must match both (AND).",
            "remove_row": "Remove this row",
            "reset": "Reset",
            "room_count": "%{count} rooms",
            "room_environments": "Preschool and accommodation",
            "room_environments_note": "Applies per accommodation. At least one room in the same preschool meets all conditions (AND).",
            "scope": "Scope",
            "scope_domestic": "Domestic",
            "scope_jpe": "JPE",
            "set_plan_note": "Set plans (preschool + elementary) require dates of birth.",
            "show_excluded": "Include preschools with no availability",
            "stay_day": "Duration of stay",
            "stay_day_note": "Applies per plan. Plans matching any selected duration (OR).",
            "stay_day_options": {
              "14": "2 weeks",
              "21": "3 weeks",
              "27": "1 month~",
              "6": "Within a week",
              "7": "1 week"
            },
            "submit": "Search",
            "title": "Search conditions"
          },
          "flash": {
            "disabled": "This account is suspended. Please contact an administrator.",
            "domain_not_allowed": "This Google account cannot be used. Sign in with your company Google account.",
            "email_unverified": "The email address on this Google account is not verified.",
            "generic_error": "Sign-in failed. Please try again.",
            "invalid_response": "Sign-in failed. Please try again.",
            "omniauth_failure": "Sign-in failed. Please try again.",
            "provisioning_failed": "Could not create the account. Please contact an administrator.",
            "signed_out": "Signed out."
          },
          "reason_titles": {
            "accepted_class": "The selected class is not among the classes this preschool accepts (derived from its base conditions).",
            "nursery_class_capacity": "The preschool does not have enough capacity on %{dates} of the occupied period (including per-class remaining slots and the sibling rule).",
            "published": "This check-in date is unpublished (an operator hid it manually).",
            "room_capacity": "Over capacity (%{detail})",
            "room_deadline": "The booking deadline for check-in date %{dates} has passed.",
            "room_full": "The accommodation is fully booked on check-in date %{dates} (0 left).",
            "room_no_capacity": "The accommodation has 0 slots on check-in date %{dates}.",
            "set_plan_birthdays_required": "Set plans (preschool + elementary) cannot be judged from classes alone. Enter dates of birth.",
            "status": {
              "deadline_only": "Inventory exists but only the deadline blocks it (status = -). Lifting the booking deadline manually can make it bookable.",
              "nursery_ng": "The preschool does not have enough capacity on %{dates} of the stay (intake stopped, or capacity 0).",
              "nursery_no_capacity": "The daily preschool capacity rows for %{dates} have not been created. Please contact a developer.",
              "room_full": "%{dates} of the stay are fully booked (0 left).",
              "room_no_capacity": "The accommodation has no slots on %{dates} of the stay (0 slots).",
              "status_inconsistent": "The inventory snapshot (status = NG) disagrees with the current inventory, deadline and preschool classes. A recalculation is needed."
            }
          },
          "reasons": {
            "class_not_accepted": "Class not accepted",
            "deadline_only": "Deadline only (ask us)",
            "deadline_passed": "Past deadline",
            "nursery_ng": "Not enough capacity",
            "nursery_no_capacity": "Capacity not created",
            "room_full": "Fully booked",
            "room_no_capacity": "No inventory",
            "room_over_capacity": "Over room capacity",
            "set_plan_birthdays_required": "Dates of birth required",
            "set_plan_composition": "Needs both a preschooler and an elementary student",
            "status_inconsistent": "Status inconsistent (needs recalculation)",
            "unpublished": "Unpublished"
          },
          "results": {
            "available_count": "%{count} available",
            "excluded_count": "%{count} excluded",
            "list_separator": ", ",
            "loading": "Loading...",
            "matching_rooms": "Rooms meeting the conditions: %{rooms}",
            "none": "No dates match these conditions.",
            "nursery_count": "%{count} preschools",
            "order": "Sorted by: recommended",
            "planner_status_open": "Open source sheet",
            "planner_status_source": "Planner status: last imported %{date}. Check the source sheet for the latest state.",
            "price_estimate_note": "Estimate for %{adults} adults and %{children} child",
            "price_from": "%{price}~",
            "refined_limit": "Reached the examination limit (%{max} preschools); lower-ranked preschools were not checked. Narrow by region or date range.",
            "summary": " - %{available} available / %{excluded} excluded (%{candidates} candidates, %{refined} preschools examined)"
          },
          "rows": {
            "available": "Available",
            "check_in_date": "Check-in date",
            "check_in_dates_link": "CheckInDate list",
            "class_remaining": "%{remaining} left",
            "count_summary": "%{total} dates (%{available} available / %{excluded} excluded)",
            "derived": "%{birthday} -> FY%{year}: %{class_name}",
            "derived_class": "Derived class",
            "derived_none": "Not eligible",
            "links": "Links",
            "lp_full": "LP: Full",
            "lp_full_title": "Bookable, but the customer LP shows it as full.",
            "lp_inquiry": "LP: Inquiry",
            "lp_inquiry_title": "Not bookable, but the customer LP shows \"Inquiry\", so families can ask.",
            "lp_open": "LP: Available",
            "lp_open_title": "The customer LP shows it as available, but it cannot be booked (see the reasons in this cell).",
            "lp_unpublished": "LP unpublished",
            "lp_unpublished_title": "No published LP, so the availability page cannot be opened (it returns 404).",
            "no_limit": "No limit",
            "nursery_calendar": "Preschool capacity calendar",
            "plan_hidden": "Unpublished plan",
            "plan_hidden_title": "This plan does not appear on the LP, and its page cannot be opened.",
            "plan_limited": "Limited plan",
            "plan_limited_title": "This plan is not listed or searchable on the LP (its page opens only via a direct link).",
            "planner_status": "FY%{year}: %{status}",
            "price": "Price",
            "price_unavailable": "-",
            "remaining": "Remaining",
            "room": "Accommodation",
            "room_remaining": "Room %{remaining}/%{slot} left",
            "roomless": "No accommodation",
            "slug_missing": "URL not set",
            "slug_missing_title": "The preschool URL (prefecture / municipality / preschool) is not set, so the availability page URL cannot be built.",
            "status": "Status",
            "stay": "Stay",
            "stay_label": "%{days} days / %{nights} nights",
            "stay_label_named": "%{name} (%{days} days / %{nights} nights)",
            "unpublished_domestic": "Unpublished (Domestic)",
            "unpublished_jpe": "Unpublished (JPE)"
          },
          "sign_in": {
            "button": "Sign in with Google",
            "lead": "Sign in with your company Google account (@kitchhike.com)."
          },
          "sign_out": "Sign out",
          "title": "Planner Search Beta"
        }
      },
      "certificate_of_participation": {
        "description": "You can download a Certificate of Participation for each child who participated in the program.",
        "download": "Download",
        "title": "Download Certificate of Participation"
      },
      "check_in_month_label": "Estimate for %{adult_count} adults and %{children_count} child",
      "confirmation": {
        "address": "Address",
        "basic_information": "Basic Information",
        "billing_information": "Billing Information",
        "birth_date": "Date of birth",
        "children_information": "Participating Child(ren)",
        "confirmation": "Review Your Information",
        "contact_information": "Contact Information",
        "emergency_contact_during_stay": "Stay Emergency Contact",
        "exercise_section": "Other (For Ages 0-1 Only)",
        "family_confirmation": "Register Family Information",
        "family_information": "Other Accompanying Guest(s)",
        "full_name": "Full Name (in Chinese, if any)",
        "full_name_reading": "Full Name",
        "gender": "Gender",
        "interview_question": "Interview/Survey",
        "living_conditions": "Health and Lifestyle",
        "meal_and_allergy_information": "Meal and Allergy Information",
        "money_unit": "JPY",
        "no_input": "Not Entered",
        "occupation": "Occupation",
        "option": "Option",
        "people_unit": "Guest",
        "primary_contact_information": "Primary Contact",
        "reservation_information": "Reservation Information",
        "school_information": "The school your child currently attends"
      },
      "edit": "Edit",
      "family_master": {
        "confirmed": "confirmed",
        "headings": {
          "address": "Address",
          "allergy_information": "Allergy Information",
          "basic_information": "Basic Information",
          "contact_information": "Contact Information",
          "exercise_section": "Please fill in the following information only if the child is 0 to 1 year old.",
          "living_conditions": "Health and Lifestyle",
          "school_information": "School Information",
          "stay_with": "Person staying with",
          "work": "Occupation"
        },
        "messages": {
          "legacy_answer": "Previous answer: %{value}",
          "medical_history_details_note": "※ Please provide details on the disease, frequency, age at onset, and any current medication. (e.g., Febrile seizures, twice, onset at 18 months, current medication: none).",
          "medical_history_note": "※ Examples: febrile convulsions, elbow dislocation, epilepsy, asthma, Kawasaki disease, history of hospitalization or surgery, etc.",
          "special_requests": "※ For reasons other than food allergies (e.g., religious reasons or Halal requirements)",
          "symptoms_note": "Please be sure to provide the severity of allergies, any necessary considerations, details about anaphylactic symptoms, and any medications if applicable."
        },
        "select": "Please select"
      },
      "flash": {
        "alert": {
          "conditional_requirement_answer": "Please answer the question.",
          "family_confirmation": {
            "no_input": "There are fields that have not been filled in."
          },
          "nursery_meeting": {
            "full": "All interview dates are full.",
            "select": "Please select a date."
          },
          "todo_uploads": "Please upload any file."
        }
      },
      "handbook": {
        "breadcrumb": {
          "top": "TOP"
        },
        "contact": {
          "guest_house": {
            "table": {
              "contact": "Contact",
              "name": "Inquire to"
            },
            "title": "For inquiries regarding your stay"
          },
          "image": "Contact network",
          "note": "Upon making an inquiry, please inform of your name and check-in day. If you are not sure which to contact, email Preschool Exchange Operation Desk at",
          "nursery": {
            "table": {
              "contact": "Contact",
              "name": "Inquire to"
            },
            "title": "For inquiries regarding things to bring, attire, etc.",
            "title_for_nursery_1": "For inquiries of Educational Facility 1 regarding things to bring, attire, etc.",
            "title_for_nursery_2": "For inquiries of Educational Facility 2 regarding things to bring, attire, etc."
          },
          "program": {
            "table": {
              "contact": "Contact",
              "contact_value": "support@hoikuen-ryugaku.zendesk.com",
              "name": "Inquire to",
              "name_value": "Preschool Exchange Operation Desk"
            },
            "title": "For inquiries regarding fees, payments, or general procedures"
          },
          "support_email": "support@hoikuen-ryugaku.zendesk.com",
          "title": "Contact Information"
        },
        "family_notice": {
          "nursery_1": "Educational Facility 1",
          "nursery_2": "Educational Facility 2",
          "title": "Information from the Destination"
        },
        "guest_house": {
          "additional_services": {
            "title": "Additional Services and Paid Options"
          },
          "check_in": {
            "check_in_day_info": "About Check-in",
            "check_in_items": "Check-in belongings",
            "check_in_procedure": "About Check-out",
            "description_html": "<b>For those who selected the option of accompanying guests staying for only a few nights</b>\nOnce you receive the reservation confirmation email, please inform the accommodation of the check-in and check-out dates for the guests joining for only a few days.\nIf you add this option after making your reservation, please contact them at that time.\n\n<b>For those who wish to change their check-in time</b>\nYou can change your check-in time as follows:\nLog in to <a href=\"https://reserve.preschool-exchange.com/mypage\" class=\"underline\" target=\"_blank\" rel=\"noopener noreferrer\">MyPage</a> > Click “Upcoming” > Select your reservation > Go to “Reservation Information” > Update “Arrival Time at the Accommodation.”\n<span class=\"text-red-600\">If your check-in time changes from the original schedule on the day of check-in, please be sure to contact the accommodation directly.</span>\nChanges to the number of guests can be made up to one week before the start of your stay. Please note that no changes can be made after this period.",
            "table": {
              "check_in_method": "Check-in process",
              "check_in_time": "Check-in",
              "check_out_time": "Check-out"
            },
            "title": "Check-in / Check-out"
          },
          "facilities": {
            "description": "Please note that moving furniture, beds, mattresses, or other items in the guest room may cause unexpected damage or injury.\nIf you wish to change the room layout or move any items, please consult the accommodation staff in advance.",
            "from_guest_house_title": "Information from the accommodation",
            "parking": {
              "available_value": "Available",
              "table": {
                "available": "Parking availability",
                "comments": "Notes"
              },
              "title": "Parking",
              "unavailable_value": "Not available"
            },
            "table": {
              "amenities": "Other amenities",
              "bathroom": "Bathroom",
              "bedroom": "Bedroom",
              "free_rental_items": "Rental items",
              "kids_facilities": "Children's amenities",
              "kitchen_facilities": "Kitchen",
              "laundry": "Laundry",
              "living_facilities": "Living area",
              "other_facilities": "Other",
              "paid_rental_items": "Paid Rental Items (paid at the accommodation)",
              "remote_work_facilities": "Work"
            },
            "title": "Facilities and Equipment"
          },
          "house_rules": {
            "cleaning": {
              "table": {
                "amenity_supply": "Amenity Replenishment",
                "cleaning_frequency": "Cleaning",
                "waste_disposal": "Garbage Disposal"
              },
              "title": "Cleaning"
            },
            "facility_usage": {
              "title": "Other Important Information"
            },
            "title": "House Rules"
          },
          "luggage": {
            "description": "Please specify a time when you can pick up them. The accommodation will not be able to pick up your luggage on your behalf.\nMake sure to write your name as the recipient and the sender.",
            "shipping_address": {
              "title": "Shipping Address"
            },
            "title": "Luggage Shipping"
          },
          "top": {
            "cards": {
              "additional_services": "Additional Services and Paid Options",
              "check_in": "Check-in / Check-out",
              "facilities": "Facilities and Equipment",
              "house_rules": "House Rules",
              "luggage": "Luggage Shipping"
            },
            "google_map": "Google Map",
            "title": "Accommodation"
          }
        },
        "local_info": {
          "medical": {
            "note": "Please check Google Maps or visit the location for the latest information.",
            "table": {
              "address": "Address",
              "name": "Name",
              "url": "URL"
            },
            "title": "Medical Institutions"
          },
          "top": {
            "cards": {
              "medical": "Medical Institutions",
              "transportation": "Transportation"
            },
            "description": "Please find below a map of the area surrounding the accommodation, featuring supermarkets, convenience stores, and local recommendations for gourmet spots, activities, sightseeing, and workspaces.\nWe hope you find it useful during your stay.",
            "title": "Local Information"
          },
          "transportation": {
            "car_rental": "Car Rental",
            "other": "Other Transportation",
            "taxi": "Taxi",
            "title": "Transportation"
          }
        },
        "nursery": {
          "attire": {
            "belongings": {
              "common": "All Classes",
              "daily_items": "<Daily Items>",
              "elementary": "Elementary School Class",
              "infant": "0-2 Year Old Class",
              "items": "Items",
              "kept_items": "<Items Left at Nursery (Bring on First Day Only)>",
              "notes": "Notes",
              "target_class": "Class",
              "toddler": "3-5 Year Old Class"
            },
            "belongings_document": "Belongings Information (PDF)",
            "belongings_document_open": "Open the PDF in a new tab",
            "clothing": "Attire",
            "daily_belongings": "Items to Bring Daily",
            "note": "Make sure to write the child’s name on every item.",
            "rental_items": "Items Available for Borrowing at the Educational Facility",
            "title": "Attire & Things to Bring"
          },
          "childcare_hours": {
            "first_day_info": {
              "title": "First Day"
            },
            "hours": {
              "table": {
                "childcare_time": "Available Hours",
                "childcare_time_note": "Other Notes",
                "extending_time": "Extended Hours",
                "gradual_entry": "Transition Period"
              }
            },
            "note": "Please be punctual for the pick-up and drop-off times.Please ensure you do not arrive early or late, as this affects the school’s staffing and activities. If you are unable to arrive on time for any reason, please contact the Educational facility.\nPlease contact your educational facility directly if your child will be late or absent.",
            "title": "Hours and Attendance"
          },
          "health": {
            "note": "If your child needs to be absent due to a fever, please follow the guidance from the educational facility.\nNote that, in principle, we do not provide refunds for program fees, such as facility usage fees, in the event of educational facility closures, class cancellations, or early pick-ups/absences due to the participant’s own circumstances.",
            "table": {
              "absence_conditions": "Case of deferring attendance",
              "fever": "Fever",
              "fever_value": "Children with a temperature of %{temperature}°C or above will need to be picked up.",
              "medication": "Medication",
              "sick_care": "Care for sick children"
            },
            "title": "Health Precautions"
          },
          "other_info": {
            "notice": {
              "title": "Information from the Educational Facility"
            },
            "school_bus_available": "Available",
            "school_bus_unavailable": "Not Available",
            "table": {
              "communication_note": "Contact Book",
              "school_bus": "School Bus"
            },
            "title": "Other Information"
          },
          "top": {
            "cards": {
              "attire": "Attire and Things to Bring",
              "childcare_hours": "Childcare / Education",
              "health": "Health Precautions",
              "other_info": "Other Information"
            },
            "title": "Educational Facility"
          }
        },
        "top": {
          "cards": {
            "contact": "Contact Information",
            "family_notice": "Information from the Destination",
            "guest_house": "Accommodation Information",
            "local_info": "Local Information",
            "nursery": "Educational Facility Information",
            "nursery_1": "Educational Facility ① Information",
            "nursery_2": "Educational Facility ② Information"
          },
          "heading": "Japan Elementary School Exchange Program Handbook",
          "title": "Handbook"
        }
      },
      "modal_message": {
        "back": "Back",
        "complete": "Complete",
        "final_confirm": "Final Confirmation",
        "final_confirm_message": "Proceed with submission?",
        "final_confirm_message_2": "Have you completed the task? Press 'Complete' to update the status.",
        "final_confirm_message_3": "Proceed with submission?  No further revisions allowed.",
        "submission": "Submit",
        "submit": "Submit"
      },
      "mypage": {
        "cancel_fee": "Cancel Fee : ",
        "cancelled": "Cancelled",
        "form": {
          "children_form": "Participating Child(ren)",
          "completions": {
            "done": "Submitted",
            "photo_sharing": {
              "benefit_text": "We would be honored to feature them in our advertisements or on our website to inspire future families.",
              "note_text": "Note: Since other children may appear in the background, we will only use the footage after confirming with the school that there are no privacy concerns.",
              "text": "We would love to see the wonderful moments you captured during your stay in Japan, or any photos/videos from the preschool!",
              "title": "Share Your Memories with Us",
              "url": "https://forms.gle/YZ51RjmTidU4zuX79",
              "url_text": "Upload your memories"
            },
            "review_form_done": "Review Submitted",
            "review_thank_you": "Thank you very much for your cooperation in the survey.",
            "thank_you": "Task completed. Well done!",
            "top": "To-Do List Top"
          },
          "exist_information": "Information You Have Previously Registered",
          "family_form": "Other Accompanying Guest(s)",
          "questionnaire_form": {
            "absent_days": {
              "unit": "Days",
              "validation": "(Please enter a number)"
            },
            "completed": "The post-stay survey has already been submitted.",
            "create": {
              "error": "There are errors in your submission. Please check your answers."
            },
            "heading": "Your JPE Experience Feedback",
            "modal_message": "Are you sure you want to submit your answers?\nNo revisions can be made after submission.",
            "modal_submit": "Submit",
            "note": "We would like your cooperation in answering this survey to help us sustainably develop this initiative. The survey results will be shared between KitchHike Co., Ltd. and the local representatives, and will be used to improve our services in the future.",
            "scale": {
              "very_dissatisfied": "Dissatisfied",
              "very_satisfied": "Satisfied"
            },
            "submit": "Answer the survey"
          },
          "reservations_form": "Reservation Information",
          "review_form": {
            "activity_details": {
              "label_html": "Please share how often each activity took place, any additional details, and any activities your child experienced that aren't listed above.",
              "optional": "Optional",
              "placeholder": "Example:\n- We happened to have good timing and were able to join a school bus trip to the beach for sea play just once.\n- The preschool kept a pet rabbit, so our child helped care for it every day, and we heard they also got to meet a neighbor's goat during a walk."
            },
            "completed": "The post-stay review has already been submitted.",
            "create": {
              "error": "There are errors in your submission. Please check your answers."
            },
            "drag_and_drop": "You can also drag & drop",
            "experienced_activities": {
              "hint": "Please select all that apply",
              "label_html": "Which activities did your child experience <strong class=\"font-bold\">as part of the preschool program</strong> during your stay?",
              "options": [
                "Sea",
                "Forest",
                "Mud",
                "Snow",
                "Animals",
                "English available",
                "Mixed age",
                "Harvest",
                "Art",
                "Cooking",
                "Unknown"
              ]
            },
            "head": "Images",
            "heading": "Thoughts and Messages about Japan Preschool Exchange",
            "image_count_error": "You can upload a maximum of 10 images. Please check the number of images.",
            "image_size_error": "The maximum size of one file is 5MB. Please resize any oversized images and upload them again.",
            "modal_message": "Submit your review and\nproceed to the survey?",
            "modal_submit": "Submit & Proceed to Survey",
            "nickname_blank": "Nickname is required",
            "nickname_description": "This will be used as your display name on our website.",
            "nickname_label": "Nickname",
            "nickname_placeholder": "Example: Tanaka",
            "published_no": "No",
            "published_yes": "Yes",
            "submit_next": "Answer and proceed to the next step.",
            "upload_image": "Upload Images",
            "uploading_notice": "Images are being uploaded. Please wait until the upload is complete.",
            "validation": "When posting a review, please check our review guidelines.(Maximum 5MB per image, up to 10 images)"
          },
          "todo_uploads": {
            "attachment": "Attachment",
            "file_size_error": "The maximum size of one file is 20MB.",
            "upload_file": "File Upload",
            "uploaded_file_1": "Attachment1"
          }
        },
        "next_plan": "Haven't decided on your next destination yet?",
        "next_plan_message": "Every season offers unique experiences across each region. Let's start planning your next adventure!",
        "nursery_meeting": {
          "no_available_slots": "There are no meeting slots available to book right now. Please check again once the booking period opens."
        },
        "planned_visit": "Upcoming",
        "reservation_status": {
          "cancelled": "Cancelled",
          "completed": "Completed",
          "processing": "Processing",
          "upcoming": "Upcoming"
        },
        "search_study_destination": "Find a destination",
        "visited": "Completed"
      },
      "reservation_request": {
        "certificate_of_participation_download": "Download Certificate of Participation >",
        "confirmation_of_reservation": "See Reservation Details >",
        "confirmed": "confirmed",
        "dashboard_title": "Your Upcoming Journey",
        "errors": {
          "form_validation_error": "There are issues with your responses. Please check the content you entered.",
          "route_others_required": "Please enter the details."
        },
        "handbook_banner_alt": "Preschool Exchange Handbook",
        "headings": {
          "emergency_contact_during_stay": "Emergency Contact",
          "information_during_your_stay": "Information during your stay",
          "interview_question": "Media Coverage",
          "reservation_information": "Reservation Information"
        },
        "messages": {
          "check_in_time_note": "※ If your check-in time changes on the day of your arrival, please be sure to contact the accommodation directly.",
          "emergency_contact_during_stay_note": "In case we need to contact you in an emergency during your stay, we will call this number.",
          "emergency_contact_note": "* Please enter a reachable contact number during your stay. This number will be shared with the accommodation and the childcare/educational facility."
        },
        "plans": {
          "accommodation": "Accommodation : %{room_name}",
          "adult": {
            "one": "%{count} Adult,",
            "other": "%{count} Adults,"
          },
          "child": {
            "one": "%{count} Child",
            "other": "%{count} Children"
          },
          "people": "Number of Guests : ",
          "period": "Period : %{start_date} - %{end_date}",
          "preschool": "Childcare/Educational Facility : %{nursery_name}",
          "preschool_2": "Childcare/Educational Facility 2 : %{nursery_name}",
          "reservation_number": "Reservation number : %{reservation_request_id}"
        },
        "todo_list": "To-Do List"
      },
      "reservation_request_todo": {
        "arrange_an_interview_date": "Please schedule an interview.",
        "asap": "ASAP",
        "date": "Date : %{date}",
        "done": "Done",
        "soon": "Soon",
        "submission_due_date": "Due : %{date}"
      },
      "todo": {
        "review_not_found": "The survey TODO could not be found. Please contact our office.",
        "submission_deadline": "Submission By : %{date}"
      },
      "todo_form_header": {
        "back": "Back",
        "back_to_mypage": "Back to MyPage"
      }
    }
  },
  "ja": {
    "account": {
      "line_links": {
        "already_linked": "このLINEアカウントは、すでに別のアカウントと連携されています。",
        "failed": "LINE連携に失敗しました。お手数ですが、もう一度お試しください。",
        "linked": "LINEと連携しました。",
        "not_configured": "LINE連携は現在ご利用いただけません。",
        "unlink_confirm": "LINE連携を解除しますか？",
        "unlinked": "LINE連携を解除しました。"
      },
      "password": {
        "edit": {
          "current_password": "現在のパスワード",
          "current_password_note": "変更を確認するために現在のパスワードが必要です",
          "minimum_length": "（%{count}文字以上）",
          "new_password": "パスワード",
          "new_password_note": "変更しない場合は空欄のままにしてください",
          "password_confirmation": "パスワード（確認用）",
          "submit": "変更する",
          "title": "パスワード変更"
        },
        "update": {
          "success": "パスワードを更新しました。"
        }
      },
      "profile": {
        "edit": {
          "first_name": "名",
          "first_name_reading": "名（ふりがな）",
          "last_name": "姓",
          "last_name_reading": "姓（ふりがな）",
          "nickname": "表示名（ニックネーム）",
          "phone_number_note_1": "ハイフン（-）を入れず、数字のみで入力してください。",
          "phone_number_note_2": "(例：123-456-7890 → 1234567890)",
          "postal_code_note_1": "ハイフン（-）を入れず、数字のみで入力してください。",
          "postal_code_note_2": "(例：123-4567 → 1234567)",
          "submit": "変更を保存する",
          "title": "プロフィール編集"
        },
        "show": {
          "address": "住所",
          "basic_information": "基本情報",
          "change_password": "パスワードを変更する",
          "contact_information": "連絡先",
          "edit": "編集する",
          "full_name": "姓名（漢字）",
          "full_name_japanese": "姓名（ふりがな）",
          "line_link": "LINE連携",
          "line_link_after": "※LINE連携後は、LINE内のメニューからマイページへアクセスできます。",
          "line_link_contact": "事務局へのお問い合わせは、下記メールアドレスまでお願いいたします。",
          "line_link_contact_label": "お問い合わせ：",
          "line_link_lead_html": "LINEとマイページを連携すると、<strong>LINEからかんたんにマイページへアクセス</strong>できるようになります。ご予約内容の確認にぜひご利用ください。",
          "line_linked_status": "連携済み",
          "line_not_linked_status": "未連携",
          "link_line": "LINEと連携する",
          "logout": "ログアウトする",
          "occupation": "職業",
          "password": "パスワード",
          "primary_contact_information": "代表者情報",
          "support_email": "support@hoikuen-ryugaku.zendesk.com",
          "title": "アカウント設定",
          "unlink_line": "連携を解除する"
        },
        "update": {
          "success": "プロフィールを更新しました。"
        }
      }
    },
    "account_confirmation": {
      "email": "メールアドレス",
      "submit": "確認メールを再送信する",
      "title": "確認メール再送信"
    },
    "account_confirmation_email": {
      "letter_block_1": {
        "text_1": "このメールアドレスは配信専用となっております。",
        "text_2": "お問い合わせはこちら▼"
      },
      "letter_block_2": {
        "text_1": "ご登録いただいたメールアドレスでのアカウント作成が完了しました。",
        "text_10": "※このURLの有効期限は24時間です。",
        "text_11": "期限を過ぎた場合は、%{confirmation_resend_link}から本人確認メールの再送信をしてください。",
        "text_12": "こちら",
        "text_2": "ご予約の確認や手続きを進めるためには、以下のURLにアクセスし本人確認を完了させてください。",
        "text_3": "本人確認が完了すると、マイページにログインできるようになります。",
        "text_4": "本人確認用URL",
        "text_5": "次のステップ",
        "text_6": "1. 上記のURLにアクセスし、本人確認を完了してください。",
        "text_7": "2. マイページにログインし、予約内容を確認いただけます。",
        "text_8": "3. 予約リクエストが承認されましたら、マイページのやることリストから必要な手続きをご確認いただけます。",
        "text_9": "ご不明な点などありましたら、保育園留学運営事務局にお問い合わせください。",
        "text_password_label": "初期パスワード",
        "text_password_note": "※セキュリティ保護のため、ログイン後にパスワードの変更をお願いいたします。"
      },
      "letter_block_3": {
        "text_1": "保育園留学・小学生留学 運営事務局",
        "text_2": "HP. %{hoikuen_ryugaku_url}",
        "text_3": "mail. %{support_email}",
        "text_4": "※返信には3-4営業日いただく場合がございます（土日祝除く）",
        "text_5": "運営会社：株式会社キッチハイク",
        "text_6": "北海道檜山郡厚沢部町上里92-1"
      }
    },
    "account_confirmation_instructions_email": {
      "letter_block_1": {
        "text_1": "このメールアドレスは配信専用となっております。",
        "text_2": "お問い合わせはこちら▼"
      },
      "letter_block_2": {
        "text_1": "以下のURLにアクセスし本人確認を完了させてください。",
        "text_2": "本人確認が完了すると、マイページにログインできるようになります。",
        "text_3": "本人確認用URL",
        "text_4": "ご不明な点などありましたら、保育園留学運営事務局にお問い合わせください。"
      },
      "letter_block_3": {
        "text_1": "保育園留学・小学生留学 運営事務局",
        "text_2": "HP. %{hoikuen_ryugaku_url}",
        "text_3": "mail. %{support_email}",
        "text_4": "※返信には3-4営業日いただく場合がございます（土日祝除く）",
        "text_5": "運営会社：株式会社キッチハイク",
        "text_6": "北海道檜山郡厚沢部町上里92-1"
      }
    },
    "account_confirmation_mailer": {
      "confirmation_instructions": {
        "from": "保育園留学・小学生留学 運営事務局 <no-reply@kitchhike.com>",
        "subject": "アカウント認証を完了してください【保育園留学・小学生留学 運営事務局】"
      },
      "custom_welcome_instructions": {
        "from": "保育園留学・小学生留学 運営事務局 <no-reply@kitchhike.com>",
        "subject": "本人確認をし、アカウント登録を完了してください【保育園留学・小学生留学 運営事務局】"
      }
    },
    "account_reset_password_email": {
      "letter_block_1": {
        "text_1": "このメールアドレスは配信専用となっております。",
        "text_2": "お問い合わせはこちら▼"
      },
      "letter_block_2": {
        "text_1": "パスワード変更のリクエストを受け付けました。",
        "text_2": "以下のリンクから新しいパスワードを設定してください。",
        "text_3": "パスワードを変更する"
      },
      "letter_block_3": {
        "text_1": "保育園留学・小学生留学 運営事務局",
        "text_2": "HP. %{hoikuen_ryugaku_url}",
        "text_3": "mail. %{support_email}",
        "text_4": "※返信には3-4営業日いただく場合がございます（土日祝除く）",
        "text_5": "運営会社：株式会社キッチハイク",
        "text_6": "北海道檜山郡厚沢部町上里92-1"
      }
    },
    "activemodel": {
      "attributes": {
        "kintone/family_master": {
          "allergenic_foods": "アレルギーの原因となる食品",
          "allergy_causes": "アレルギーの原因となるもの",
          "allergy_elimination": "除去食の対応・その他特別な対応が必要な場合の確認",
          "appetite_food": "食欲",
          "baby_food": "離乳食",
          "birth_date": "生年月日",
          "breastfeeding": "授乳",
          "business": "職業",
          "company_name": "勤務先",
          "country": "国名",
          "development_concerns": "気になっていること",
          "development_current_support": "現在の園・学校での対応状況",
          "development_professional_support": "専門機関の利用状況",
          "developmentaldisorder": "今までに発達障がいと診断されたことはありますか",
          "diagnosis": "診断名を教えてください",
          "dietary_restriction_elimination_level": "除去レベル",
          "dietary_restriction_other_text": "その他の場合、内容を記入してください",
          "dietary_restriction_type": "制限の種類",
          "email_address": "メールアドレス",
          "exercise": "運動",
          "family_relationship": "保育園留学をするお子さまとの続柄",
          "family_relationship_other": "続柄がその他の場合はご関係をご記入ください",
          "favorite_playing": "好きな遊び",
          "first_name": "名",
          "first_name_reading": "めい",
          "food_allergies_yes_or_no": "食物アレルギーはありますか？",
          "food_allergy_anaphylaxis_history": "アナフィラキシーを起こしたことがありますか",
          "food_allergy_elimination_level": "除去レベル",
          "food_allergy_epipen": "エピペンを所持していますか",
          "food_allergy_guardian_visit": "保護者の来園・来校対応について",
          "food_allergy_medication_required": "服薬が必要ですか",
          "food_allergy_severity": "重症度",
          "foodrequest": "食事についてスペシャルリクエスト",
          "foodrequest_yes_or_no": "食事に関して、宗教上の理由、またはプラントベースの食生活(ベジタリアンなど)に関する特別な配慮が必要ですか",
          "full_name": "姓名（漢字）",
          "full_name_reading": "姓名（ふりがな）",
          "gender": "性別",
          "language": "お子さまの使用言語",
          "last_name": "姓",
          "last_name_reading": "せい",
          "medical_condition_name": "病名・状態名",
          "medical_current_status": "現在の状態",
          "medical_history": "これまでに経験した病気や手術、怪我、治療歴がありますか",
          "medical_history_details": "既往歴の詳細",
          "medical_support_level": "園・学校での対応レベル",
          "municipalities": "市区町村",
          "name_of_building": "建物名など",
          "napping": "お昼寝",
          "nonfood_allergies": "食物以外のアレルギーはありますか",
          "nonfood_allergy_causes": "原因",
          "nonfood_allergy_epipen": "エピペンを所持していますか",
          "nonfood_allergy_other_text": "その他の場合、内容を記入してください",
          "nonfood_allergy_precautions": "園・学校での活動で避けてほしいこと・対応してほしいこと",
          "nonfood_allergy_severity": "重症度",
          "opportunitynurseryschool": "今まで、週３日以上の通園経験はありますか",
          "other_food_name": "その他の場合、食材を記入してください",
          "personality": "良いと思う性質・気になる性質",
          "phone_number": "電話番号",
          "planned_participation": "留学先",
          "postal_code": "郵便番号",
          "prefecture": "都道府県",
          "question1": "除去食の対応・その他特別な対応が必要となる場合は、必ず面談時に先生へ直接相談し、各施設の必要な手続きを行ってください。なお、対応の可否や対応レベルは各施設によって異なりますので、予めご了承ください。",
          "same_as_representative_address": "代表者と同じ",
          "same_as_representative_phone_number": "代表者と同じ",
          "school_name": "在籍学校名",
          "school_type": "学校の種類",
          "symptoms": "アレルギーの症状",
          "things_that_need_attention": "発達の遅れや集団生活を送る上で配慮が必要なこと",
          "toilet": "排泄",
          "town_area_street_address": "町域・番地",
          "underwear": "下着"
        },
        "kintone/representative_user_master": {
          "birth_date": "生年月日",
          "building": "建物名など",
          "business": "職業",
          "co_workers": "共働きか",
          "company_name": "勤務先",
          "country": "国名",
          "email_address": "代表者メールアドレス",
          "family_relationship": "留学するお子さまとの続柄",
          "first_name": "名",
          "first_name_reading": "めい",
          "gender": "性別",
          "last_name": "姓",
          "last_name_reading": "せい",
          "municipalities": "市区町村",
          "other": "続柄がその他の場合",
          "phone_number": "電話番号",
          "postal_code": "郵便番号",
          "prefecture": "都道府県",
          "prefecture_text": "都道府県",
          "town": "町域・番地"
        },
        "kintone/reservation_request": {
          "billing_fee": "請求合計",
          "billing_fee_total": "請求合計",
          "cancel_fee": "キャンセル料",
          "cancel_processed_date": "キャンセル日",
          "charge_date": "決済日",
          "check_in_time": "宿泊施設への到着予定時刻",
          "consideration_term": "保育園留学を知ってから予約までの期間はどのくらいでしたか？",
          "discount_amount": "ディスカウント料金",
          "emergency_contact1": "緊急連絡先①",
          "emergency_contact2": "緊急連絡先②",
          "end_of_stay": "滞在終了日",
          "expectation": "保育園留学で期待していることは何ですか？（3つ以内）",
          "expectation_others": "その他を選択した場合",
          "guardian_name": "送迎をする保護者の氏名",
          "id": "予約番号",
          "interview": "滞在中・体験後インタビューやメディアの取材に応じていただけますか？",
          "number_of_adults": "大人人数合計",
          "number_of_preschoolers": "未就学児人数(留学あり)",
          "number_of_preschoolers_1": "未就学児人数(留学なし)",
          "number_of_students": "小学生人数(留学なし)",
          "number_of_students_1": "小学生人数(留学あり)",
          "nursery_name": "留学施設",
          "nursery_name_0": "留学施設②",
          "option_count": "オプション数量",
          "option_name": "オプション名",
          "option_price": "オプション料金",
          "option_total": "オプション合計(税込)",
          "plan_name": "プラン名",
          "prtrait_right": "地域の広報や保育留学の公式サイト、雑誌やテレビ等のメディアに、お子さまの写真を掲載することについて、ご了解いただけますか？",
          "room_name": "宿泊施設",
          "route": "最初にこのサービスを知ったきっかけを教えてください",
          "route_others": "その他を選択した場合",
          "start_of_stay": "滞在開始日",
          "total_number_of_people": "滞在人数合計"
        },
        "questionnaire": {
          "absent_days": "今回の滞在期間中、留学先の保育園をお休み・早退した日がある場合は、お休み・早退した日数を教えてください",
          "feedback_on_omutei": "（「はい」と回答された方）おむかえテイクアウトのご感想を聞かせてください",
          "food_cost": "現地での食費",
          "other_cost": "その他の費用",
          "reason_for_moving_interest": "(移住に関心がある旨の回答をされた方）移住に関心を持った理由をお答えください",
          "reason_for_recommendation": "上記質問で回答した点数の理由を聞かせてください",
          "reason_for_using_nouzei": "（「はい」と回答された方）留学先納税を利用した理由を教えてください",
          "reason_for_using_omutei": "（「はい」と回答された方）おむかえテイクアウトを利用した理由を教えてください",
          "region_suggestion": "今回留学した地域で改善してほしい点やご要望があれば聞かせてください",
          "satisfaction": "保育園留学全体の満足度を教えてください",
          "service_request": "今後、保育園留学の中で、こういうこともできたらいいと思うリクエストはありますか？",
          "service_suggestion": "保育園留学サービスとして改善してほしい点やご要望を聞かせてください",
          "transportation_cost": "現地での交通費",
          "used_nouzei": "留学前に、留学先納税をご利用されましたか",
          "used_omutei": "滞在中におむかえテイクアウトをご利用されましたか",
          "want_to_move": "今回留学した地域に移住したいと思いましたか",
          "want_to_move_other": "（「その他」と回答された方）具体的な内容を教えてください",
          "want_to_recommend": "保育園留学をお子さんがいる親しい友人や家族にすすめたいと思いますか",
          "want_to_repeat": "また保育園留学に行きたいと思いますか",
          "want_to_repeat_nouzei": "（「はい」と回答された方）次回留学する際も、留学先納税を使いたいと思いますか？理由と合わせて教えてください",
          "want_to_repeat_other": "（「その他」と回答された方）具体的な内容を教えてください"
        }
      },
      "errors": {
        "messages": {
          "blank": "を入力してください",
          "inclusion": "を選択してください",
          "too_long": "は%{count}文字以内で入力してください"
        }
      },
      "models": {
        "kintone": {
          "family_master": "家族マスター",
          "representative_user_master": "代表者マスター"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "default_class_capacity": {
          "start_date": "開始日"
        },
        "nursery": {
          "absence_conditions": "その他登園を控えていただく場合",
          "absence_conditions_en": "その他登園を控えていただく場合（JPE）",
          "alias": "通称",
          "alias_en": "通称（JPE）",
          "allergies": "アレルギー対応",
          "allergies_en": "アレルギー対応（JPE）",
          "allergy_possibility_comments": "アレルギーがある場合の受け入れ可否：備考",
          "badge": "JPE用バッジ",
          "belongings_document": "持ち物資料",
          "childcare_end_time": "預かり終了時間",
          "childcare_start_time": "預かり開始時間",
          "childcare_time_note": "預かり時間の補足",
          "childcare_time_note_en": "預かり時間の補足（JPE）",
          "clothing": "服装",
          "clothing_comments": "服装：備考",
          "clothing_comments_en": "服装：備考（JPE）",
          "common_belongings_comments": "全クラス共通の持ち物：備考",
          "common_belongings_comments_en": "全クラス共通の持ち物：備考（JPE）",
          "communication_note": "連絡帳",
          "communication_note_comments": "連絡帳：備考",
          "communication_note_comments_en": "連絡帳：備考（JPE）",
          "condition_match_confirmation_possibility": "受入条件に合致し、配慮事項のないお子さまの受け入れ確認",
          "description_en": "園の説明（JPE）",
          "developmental_anxiety": "発達に不安のある子どもの受入",
          "developmental_anxiety_detail": "発達に不安のある子どもの受入 詳細",
          "elementary_belongings": "小学校の持ち物",
          "elementary_belongings_comments": "小学校の持ち物：備考",
          "elementary_belongings_comments_en": "小学校の持ち物：備考（JPE）",
          "extending_the_end_time_of_childcare": "延長保育の終了時間",
          "extending_the_end_time_of_childcare_en": "延長保育の終了時間（JPE）",
          "extending_the_start_time_of_childcare": "延長保育の開始時間",
          "extending_the_start_time_of_childcare_en": "延長保育の開始時間（JPE）",
          "feature": "園の特徴",
          "fever_care_temperature": "発熱の対応",
          "from_tokyo": "都内からのアクセス",
          "gradual_entry": "慣らし保育：有無",
          "gradual_entry_age": "慣らし保育：年齢",
          "gradual_entry_note": "慣らし保育：補足",
          "gradual_entry_note_en": "慣らし保育：補足（JPE）",
          "guidebook": "しおり",
          "guidebook_en": "しおり（JPE）",
          "infant_belongings_comments": "0〜2歳児クラスの持ち物：備考",
          "infant_belongings_comments_en": "0〜2歳児クラスの持ち物：備考（JPE）",
          "jpe_acceptance_note": "海外在住のご家族（JPE）の受け入れに関する補足",
          "key_visual_images": "キービジュアル（複数）",
          "lp_url": "LP URL",
          "lp_url_en": "LP URL（JPE）",
          "lunch": "給食",
          "lunch_en": "給食（JPE）",
          "mapurl": "保育園MapURL",
          "medical_history_possibility": "既往歴のある子どもの受入",
          "medical_history_possibility_detail": "既往歴のある子どもの受入 詳細",
          "medication_policy": "与薬の対応",
          "municipality": "市区町村",
          "municipality_en": "市区町村（JPE）",
          "municipality_reading": "市区町村のふりがな",
          "name": "留学施設名称",
          "name_reading": "留学施設名称のふりがな",
          "nursery_size": "園の規模",
          "photo_share_available": "写真共有・販売の有無",
          "planner_recommendation_text_1": "プランナーのおすすめポイント1",
          "planner_recommendation_text_2": "プランナーのおすすめポイント2",
          "planner_recommendation_text_3": "プランナーのおすすめポイント3",
          "postal_code": "郵便番号",
          "prefecture": "都道府県",
          "published": "公開設定（国内）",
          "published_en": "公開設定（JPE）",
          "rental_items": "留学施設で借りられる物",
          "rental_items_comments": "留学施設で借りられる物：備考",
          "rental_items_comments_en": "留学施設で借りられる物：備考（JPE）",
          "school_bus_available": "園バスの利用可否",
          "school_bus_available_comments": "園バスの利用可否：備考",
          "school_bus_available_comments_en": "園バスの利用可否：備考（JPE）",
          "sick_care_policy": "病児保育の対応",
          "toddler_belongings_comments": "3〜5歳児クラスの持ち物：備考",
          "toddler_belongings_comments_en": "3〜5歳児クラスの持ち物：備考（JPE）",
          "zero_year_old_months": "0歳児月齢"
        },
        "nursery_room_connection": {
          "nursery_room_environment": "滞在環境（留学施設別）",
          "routing_url": "経路URL"
        },
        "plan_duration": {
          "program_days": "留学日数",
          "stay_nights": "宿泊日数"
        },
        "review": {
          "activity_details": "活動を行った頻度や詳細、また上記選択肢にない活動があれば教えてください",
          "comment": "保育園留学のご感想",
          "comment_en": "Your Review",
          "experienced_activities": "留学中にお子さんが園の活動として体験したこと",
          "message_to_locals": "宿・地域の方へのメッセージ",
          "message_to_locals_en": "Message to the Host & Local Community",
          "message_to_teacher": "園の先生方へのメッセージ",
          "message_to_teacher_en": "Message to the Nursery Staff",
          "published": "いただいた感想と先生・地域の方へのメッセージをホームページ等でご紹介してもよろしいですか",
          "title": "保育園留学のご感想タイトル",
          "title_en": "Your Review Title"
        },
        "room": {
          "address": "所在地",
          "address_en": "所在地（JPE）",
          "adult_max_count": "大人の最大人数",
          "alias": "LP表示用の部屋名",
          "amenities": "アメニティ・備品",
          "amenities_comments": "アメニティ・備品：備考",
          "amenity_supply": "アメニティ補充",
          "base_room_environment": "滞在環境（共通）",
          "bathroom": "バスルーム",
          "bedroom": "ベッドルーム",
          "check_in_start_time": "チェックイン開始時間",
          "check_in_time": "チェックイン時間",
          "check_out_start_time": "チェックアウト開始時間",
          "check_out_time": "チェックアウト時間",
          "children_max_count": "子供の最大人数",
          "cleaning_frequency": "清掃頻度",
          "coworking_space_en": "コワーキングスペース（JPE）",
          "description": "説明",
          "description_en": "説明（JPE）",
          "display_on_lp": "LPに表示するかどうか",
          "facility_usage": "施設使用上の注意",
          "floor_images": "間取り図",
          "food": "食事の説明",
          "food_en": "食事の説明（JPE）",
          "free_rental_items": "無料貸出品",
          "from_station": "最寄りの主要駅や空港から宿泊施設までの距離",
          "g_photo_url": "GフォトURL",
          "kids_facilities": "子ども用品",
          "kids_facilities_comments": "子ども用品：備考",
          "kintone_id": "Kintone ID",
          "kitchen": "キッチン",
          "kitchen_facilities": "キッチンの設備",
          "kitchen_facilities_comments": "キッチンの設備：備考",
          "laundry": "ランドリー",
          "living_facilities": "リビングの設備",
          "living_facilities_comments": "リビングの設備：備考",
          "meal_service": "食事サービス",
          "name": "部屋名",
          "name_en": "部屋名（JPE）",
          "other_facilities": "その他備品",
          "other_facilities_comments": "その他備品：備考",
          "paid_rental_items": "有料貸出品",
          "parking_available": "駐車場の有無",
          "parking_comments": "駐車場：備考",
          "parking_comments_en": "駐車場：備考（JPE）",
          "pets": "ペット",
          "postal_code": "郵便番号",
          "remote_work_facilities": "リモートワークの設備",
          "remote_work_facilities_comments": "リモートワークの設備：備考",
          "reservation_deadline": "予約の締切日",
          "room_max_count": "部屋の最大人数",
          "room_type": "部屋タイプ",
          "separate_room": "夫婦別室ワーク",
          "total_units": "棟数/室数",
          "waste_disposal": "ゴミ出し方法",
          "wifi": "Wi-Fi"
        },
        "user": {
          "confirmation_sent_at": "パスワード確認送信時刻",
          "confirmation_token": "パスワード確認用トークン",
          "confirmed_at": "パスワード確認時刻",
          "created_at": "作成日",
          "current_password": "現在のパスワード",
          "current_sign_in_at": "現在のログイン時刻",
          "current_sign_in_ip": "現在のログインIPアドレス",
          "email": "メールアドレス",
          "encrypted_password": "暗号化パスワード",
          "failed_attempts": "失敗したログイン試行回数",
          "last_sign_in_at": "最終ログイン時刻",
          "last_sign_in_ip": "最終ログインIPアドレス",
          "locked_at": "ロック時刻",
          "password": "パスワード",
          "password_confirmation": "パスワード（確認用）",
          "remember_created_at": "ログイン記憶時刻",
          "remember_me": "ログインを記憶する",
          "representative_building": "建物名など（任意）",
          "representative_business": "職業",
          "representative_co_workers": "共働きかどうか",
          "representative_company_name": "勤務先（任意）",
          "representative_country": "国",
          "representative_day": "日",
          "representative_family_relationship": "留学する子どもとの続柄 ",
          "representative_first_name": "名",
          "representative_first_name_reading": "名（フリガナ）",
          "representative_gender": "性別",
          "representative_last_name": "姓",
          "representative_last_name_reading": "姓（フリガナ）",
          "representative_month": "月",
          "representative_municipalities": "市町村",
          "representative_other": "その他の続柄の詳細",
          "representative_phone_number": "電話番号",
          "representative_postal_code": "郵便番号",
          "representative_prefecture": "都道府県",
          "representative_town": "町域・番地",
          "representative_year": "年",
          "reset_password_sent_at": "パスワードリセット送信時刻",
          "reset_password_token": "パスワードリセット用トークン",
          "sign_in_count": "ログイン回数",
          "unconfirmed_email": "未確認Eメール",
          "unlock_token": "ロック解除用トークン",
          "updated_at": "更新日"
        }
      },
      "errors": {
        "messages": {
          "invalid_image_content_type": "は画像ファイル（%{formats}）のみアップロード可能です",
          "planner_recommendation_en_required_for_publish_en": "JPE公開するには、プランナーのおすすめポイント（JPE）を1件以上入力してください",
          "planner_recommendation_required_for_publish": "公開するには、プランナーのおすすめポイント（国内）を1件以上入力してください",
          "record_invalid": "バリデーションに失敗しました: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "%{record}が存在しているので削除できません",
            "has_one": "%{record}が存在しているので削除できません"
          }
        },
        "models": {
          "review": {
            "attributes": {
              "published": {
                "inclusion": "は true か false を入力してください"
              }
            }
          },
          "room": {
            "attributes": {
              "floor_images": {
                "too_many": "は%{count}枚までです"
              }
            }
          },
          "user": {
            "attributes": {
              "nickname": {
                "too_long": "は50文字以内で入力してください"
              },
              "password": {
                "complexity": "は半角8文字以上で、小文字、数字をそれぞれ1文字以上含む必要があります。記号も使用できます（スペースを除く）。",
                "invalid_characters": "に使用できない文字が含まれています。半角スペース・全角文字・アクセント記号付きの文字・絵文字は使用できません",
                "too_long": "の文字数が制限を超えています"
              }
            }
          }
        }
      },
      "models": {
        "user": "ユーザー"
      }
    },
    "address": {
      "formats": {
        "postal_code": "〒%{postal_code}"
      }
    },
    "admin": {
      "application": {
        "login_required": "ログインしてください。"
      },
      "auth": {
        "authentication_failed": "ユーザーのパスワード認証に失敗しました。"
      },
      "blacklist_words": {
        "create": {
          "success": "不適切ワード「%{word}」を追加しました"
        },
        "destroy": {
          "success": "不適切ワード「%{word}」を削除しました"
        }
      },
      "bulk_check_in_dates": {
        "create": {
          "alert_date_range": "終了日は開始日以降の日付を指定してください",
          "alert_failed": "Check In Date の作成に失敗しました",
          "alert_invalid_dates": "開始日・終了日を正しく指定してください"
        },
        "new": {
          "alert_no_plans": "一括作成するプランが選択されていません",
          "alert_not_found": "指定されたプランが見つかりませんでした"
        }
      },
      "check_in_calendars": {
        "update": {
          "alert": "ステータスを OK にする場合は必ずシーズンを選択してください"
        }
      },
      "common": {
        "dev_only": "この操作は開発・STG環境でのみ実行できます。"
      },
      "lp": {
        "calendar": {
          "no_data_to_update": "更新対象のデータがありません",
          "update_success": "データを登録・更新しました。"
        },
        "delete_image": {
          "alert": "対象の画像が見つかりませんでした。",
          "delete_fail": "画像を削除できませんでした。%{error}",
          "notice": "画像を削除しました。"
        },
        "generate_preview": {
          "alert": "プレビューするドラフトがありません。",
          "notice": "プレビューURLを発行しました。\n%{url}"
        },
        "nursery_photo": {
          "blob_not_found": "アップロード情報を確認できませんでした。画像を取り除いて再度アップロードしてください",
          "bulk_delete_success": "選択した%{count}枚の写真を削除しました",
          "create_fail": "写真を追加できませんでした",
          "create_success": "写真を追加しました",
          "delete_fail": "写真を削除できませんでした",
          "delete_success": "写真を削除しました",
          "file_not_uploaded": "画像ファイルのアップロードが完了していません。リトライしてください",
          "max_files_error": "%{max_files}枚までアップロードできます",
          "max_size_error": "ファイルサイズは%{max_size}MBまでです",
          "publish_fail": "写真を公開できませんでした",
          "publish_success": "公開中のLPに反映しました！",
          "update_fail": "写真を更新できませんでした",
          "update_success": "写真を更新しました"
        },
        "photo_category": {
          "create_success": "写真カテゴリを作成しました",
          "delete_fail": "写真カテゴリを削除できませんでした",
          "delete_success": "写真カテゴリを削除しました",
          "delete_with_photos": "写真が紐づいているため削除できません",
          "update_fail": "写真カテゴリを更新できませんでした",
          "update_success": "写真カテゴリを更新しました"
        },
        "publish": {
          "alert": "%{name}の下書きデータがありません。",
          "error_no_published_plan": "公開されているプランが無いか、部屋タイプが設定されていないため公開できません。",
          "error_record": "LPの公開に失敗しました。再度入力内容をお確かめください。: %{message}",
          "error_validation": "入力内容が公開基準を満たしていないため公開できません。再度入力内容をお確かめください。\n\n＜%{name}：公開エラー＞\n・%{errors}",
          "notice_index": "%{name}のLPを公開しました！",
          "notice_other": "公開中のLPに反映しました！"
        },
        "unpublish": {
          "error": "%{name}に公開されているLPデータがありません。",
          "notice": "%{name}のLPを非公開にしました。"
        },
        "update_path": {
          "error": "URLを正しく設定できませんでした。",
          "notice": "%{name} のURLを設定しました。"
        },
        "update_step1": {
          "notice": "基本情報セクションのコンテンツを保存しました。"
        },
        "update_step2": {
          "notice": "ご家族の声セクションのコンテンツを保存しました。"
        },
        "update_step3": {
          "notice": "空き日程セクションのコンテンツを保存しました。"
        },
        "update_step4": {
          "notice": "優待セクションのコンテンツを保存しました。"
        },
        "update_step5": {
          "notice": "留学施設セクションのコンテンツを保存しました。"
        },
        "update_step6": {
          "notice": "地域の魅力セクションのコンテンツを保存しました。"
        },
        "update_step7": {
          "notice": "仕事環境セクションのコンテンツを保存しました。"
        },
        "update_step8": {
          "notice": "アクセスセクションのコンテンツを保存しました。"
        },
        "update_step_photos": {
          "notice": "写真セクションのコンテンツを保存しました。"
        }
      },
      "nurseries": {
        "create": {
          "notice": "留学施設データを追加しました。"
        },
        "export": {
          "belongings_categories": {
            "common": "全クラス共通",
            "infant": "0〜2歳児クラス",
            "toddler": "3〜5歳児クラス"
          },
          "belongings_columns": {
            "category": "カテゴリ",
            "comments": "備考",
            "id": "ID",
            "kept_at_nursery": "園に預けるかどうか",
            "name": "持ち物の名前",
            "nursery_id": "留学施設ID"
          },
          "nursery_columns": {
            "absence_conditions": "その他登園を控えていただく場合",
            "airport_name": "空港名",
            "airport_transfer": "移動方法",
            "alias": "通称",
            "alias_en": "通称（JPE）",
            "allergies": "アレルギー対応",
            "allergies_en": "アレルギー対応（JPE）",
            "allergy_possibility_comments": "アレルギーがある場合の受け入れ可否：備考",
            "badge": "JPE用バッジ",
            "childcare_end_time": "預かり終了時間",
            "childcare_start_time": "預かり開始時間",
            "childcare_time_note": "預かり時間の補足",
            "clothing": "服装",
            "clothing_comments": "服装：備考",
            "common_belongings_comments": "全クラス共通の持ち物：備考",
            "communication_note": "連絡帳",
            "communication_note_comments": "連絡帳：備考",
            "description_en": "園の説明（JPE）",
            "developmental_anxiety": "発達に不安のある子どもの受入",
            "elementary_belongings": "小学校の持ち物",
            "elementary_belongings_comments": "小学校の持ち物：備考",
            "extending_the_end_time_of_childcare": "延長保育の終了時間",
            "extending_the_start_time_of_childcare": "延長保育の開始時間",
            "feature": "園の特徴",
            "fever_care_temperature": "発熱の対応",
            "from_airport": "所要時間",
            "from_tokyo": "都内からのアクセス",
            "gradual_entry": "慣らし保育",
            "gradual_entry_age": "慣らし保育の対象年齢",
            "gradual_entry_note": "慣らし保育の補足",
            "guidebook": "しおり",
            "guidebook_en": "しおり（JPE）",
            "id": "ID",
            "infant_belongings_comments": "0〜2歳児クラスの持ち物：備考",
            "kintone_id": "Kintone ID",
            "latitude": "緯度",
            "longitude": "経度",
            "lp_url": "LP URL",
            "lp_url_en": "LP URL（JPE）",
            "lunch": "給食",
            "lunch_en": "給食（JPE）",
            "mapurl": "保育園MapURL",
            "medication_policy": "与薬の対応",
            "municipality": "市区町村",
            "municipality_en": "市区町村（JPE）",
            "municipality_reading": "市区町村のふりがな",
            "name": "留学施設名称",
            "name_reading": "留学施設名称のふりがな",
            "photo_share_available": "写真共有・販売の有無",
            "planner_recommendation_text_1": "プランナーのおすすめポイント1",
            "planner_recommendation_text_1_en": "プランナーのおすすめポイント1（JPE）",
            "planner_recommendation_text_2": "プランナーのおすすめポイント2",
            "planner_recommendation_text_2_en": "プランナーのおすすめポイント2（JPE）",
            "planner_recommendation_text_3": "プランナーのおすすめポイント3",
            "planner_recommendation_text_3_en": "プランナーのおすすめポイント3（JPE）",
            "postal_code": "郵便番号",
            "prefecture": "都道府県",
            "published": "公開設定（国内）",
            "published_en": "公開設定（JPE）",
            "recommended_score": "おすすめ表示順点数",
            "rental_items": "留学施設で借りられる物",
            "rental_items_comments": "留学施設で借りられる物：備考",
            "school_bus_available": "園バスの利用可否",
            "school_bus_available_comments": "園バスの利用可否：備考",
            "sick_care_policy": "病児保育の対応",
            "toddler_belongings_comments": "3〜5歳児クラスの持ち物：備考",
            "zero_year_old_months": "0歳児月齢"
          },
          "room_columns": {
            "access_to_convenience_store_by_1": "コンビニまでの交通手段_1",
            "access_to_convenience_store_by_2": "コンビニまでの交通手段_2",
            "access_to_convenience_store_time_1": "コンビニまでの所要時間_1",
            "access_to_convenience_store_time_2": "コンビニまでの所要時間_2",
            "access_to_hospital_by_1": "病院までの交通手段_1",
            "access_to_hospital_by_2": "病院までの交通手段_2",
            "access_to_hospital_time_1": "病院までの所要時間_1",
            "access_to_hospital_time_2": "病院までの所要時間_2",
            "access_to_nursery_by_1": "園までの交通手段_1",
            "access_to_nursery_by_2": "園までの交通手段_2",
            "access_to_nursery_time_1": "園までの所要時間_1",
            "access_to_nursery_time_2": "園までの所要時間_2",
            "access_to_supermarket_by_1": "スーパーまでの交通手段_1",
            "access_to_supermarket_by_2": "スーパーまでの交通手段_2",
            "access_to_supermarket_time_1": "スーパーまでの所要時間_1",
            "access_to_supermarket_time_2": "スーパーまでの所要時間_2",
            "address": "所在地",
            "address_en": "所在地（JPE）",
            "adult_max_count": "大人の最大人数",
            "alias": "LPでの表示名",
            "amenities": "アメニティ・備品",
            "amenities_comments": "アメニティ・備品：備考",
            "amenity_supply": "アメニティ補充",
            "base_room_environment": "滞在環境（共通）",
            "bathroom": "バスルーム",
            "bedroom": "寝室",
            "check_in_start_time": "チェックイン開始時間",
            "check_in_time": "チェックイン時間",
            "check_out_start_time": "チェックアウト開始時間",
            "check_out_time": "チェックアウト時間",
            "children_max_count": "子供の最大人数",
            "cleaning_frequency": "清掃頻度",
            "coworking_space_en": "コワーキングスペース（JPE）",
            "description": "宿泊施設の説明",
            "description_en": "宿泊施設の説明（JPE）",
            "display_on_lp": "表示設定",
            "display_order": "表示順",
            "facility_usage": "施設使用上の注意",
            "food": "食事の説明",
            "food_en": "食事の説明（JPE）",
            "free_rental_items": "無料貸出品",
            "from_station": "駅からのアクセス",
            "g_photo_url": "GフォトURL",
            "id": "ID",
            "kids_facilities": "子ども用品",
            "kids_facilities_comments": "子ども用品：備考",
            "kintone_id": "Kintone ID",
            "kitchen": "キッチン",
            "kitchen_facilities": "キッチンの設備",
            "kitchen_facilities_comments": "キッチンの設備：備考",
            "laundry": "ランドリー",
            "living_facilities": "リビングの設備",
            "living_facilities_comments": "リビングの設備：備考",
            "meal_service": "食事サービス",
            "name": "部屋名",
            "name_en": "部屋名（JPE）",
            "nursery_room_environment": "滞在環境（留学施設別）",
            "other_facilities": "その他備品",
            "other_facilities_comments": "その他備品：備考",
            "paid_rental_items": "有料貸出品",
            "parking_available": "駐車場の有無",
            "parking_comments": "駐車場：備考",
            "parking_comments_en": "駐車場：備考（JPE）",
            "pets": "ペット",
            "postal_code": "郵便番号",
            "remote_work_facilities": "リモートワークの設備",
            "remote_work_facilities_comments": "リモートワークの設備：備考",
            "reservation_deadline": "予約の締切日",
            "room_max_count": "定員",
            "room_type": "宿タイプ",
            "routing_url": "経路URL",
            "separate_room": "夫婦別室ワーク",
            "waste_disposal": "ゴミ出し方法",
            "wifi": "Wi-Fi"
          }
        },
        "guest_house_contacts": {
          "update": {
            "notice": "宿泊施設のお問い合わせ先を更新しました"
          }
        },
        "handbook": {
          "update": {
            "notice": "しおり情報を更新しました"
          }
        },
        "import": {
          "create": {
            "blank_spreadsheet_id": "スプレッドシートIDを入力してください",
            "notice": "インポートが完了しました。"
          },
          "errors": {
            "belonging_wrong_nursery": "この留学施設に属していません",
            "file_too_large": "ファイルサイズが大きすぎます（最大10MB）",
            "id_not_found": "存在しないIDです",
            "invalid_array_value": "不正な値が含まれています（不正: %{invalid_values} / 有効値: %{valid_values}）",
            "invalid_category": "不正な値です（有効値: %{valid_values}）",
            "invalid_format": "ファイル形式が不正です。xlsxファイルを選択してください",
            "invalid_integer_format": "数値を入力してください",
            "invalid_select_value": "不正な値です（有効値: %{valid_values}）",
            "invalid_time_format": "時刻はHH:MM形式で入力してください（例: 09:00）",
            "invalid_token": "インポートトークンが無効または期限切れです。再度プレビューを実行してください",
            "kintone_id_column_mismatch": "DBの値と一致しません",
            "kintone_id_mismatch": "Kintone IDが一致しません（期待: %{expected}, ファイル内: %{actual}）",
            "missing_sheets": "必須シートがありません: %{sheets}",
            "no_file": "ファイルが選択されていません",
            "nursery_id_column_mismatch": "IDが一致しません（期待: %{expected}）",
            "nursery_id_mismatch": "このファイルは別の留学施設（ID: %{file_id}）からエクスポートされたものです。インポート対象: %{target_name}（ID: %{target_id}）",
            "nursery_name_blank": "施設名が取得できませんでした",
            "nursery_name_duplicate": "「%{name}」は既に登録されています",
            "nursery_row_missing": "留学施設シートの行は削除はできません。シートの内容を確認して再度インポートしてください。",
            "parse_error": "ファイルの読み込みに失敗しました: %{message}",
            "required": "必須項目です",
            "room_id_blank": "IDが空欄です",
            "room_name_blank": "部屋名が取得できませんでした",
            "room_name_duplicate": "「%{name}」は既に登録されています",
            "room_not_linked": "この留学施設に紐づいていません",
            "room_rows_missing": "部屋シートの行は削除はできません。シートの内容を確認して再度インポートしてください。",
            "unexpected": "予期しないエラーが発生しました。管理者にお問い合わせください"
          },
          "new": {
            "button": "ヒアリングシートインポート",
            "label": "スプレッドシートID",
            "submit": "インポート実行",
            "title": "ヒアリングシートから留学施設をインポート"
          },
          "success": "インポートが完了しました"
        },
        "labels": {
          "planner_recommendation": "プランナーのおすすめポイント",
          "planner_recommendation_domestic": "プランナーのおすすめポイント（国内）",
          "planner_recommendation_jpe": "プランナーのおすすめポイント（JPE）"
        },
        "placeholders": {
          "planner_recommendation_text_1": "おすすめポイント1",
          "planner_recommendation_text_2": "おすすめポイント2",
          "planner_recommendation_text_3": "おすすめポイント3"
        },
        "update": {
          "notice": "留学施設データを更新しました。"
        }
      },
      "plan_durations": {
        "create": {
          "notice": "Plan Duration を作成しました"
        },
        "destroy": {
          "alert_failed": "Plan Duration の削除に失敗しました",
          "alert_in_use": "このプラン期間は %{count} 件のプランで使用中のため削除できません",
          "notice": "Plan Duration を削除しました"
        },
        "update": {
          "notice": "Plan Duration を更新しました"
        }
      },
      "plans": {
        "update": {
          "notice": "プランを更新しました"
        },
        "update_publish_settings": {
          "invalid": "不正な公開設定です",
          "notice": "%{count}件のプランの公開設定を「%{settings}」に変更しました"
        }
      },
      "prices": {
        "create": {
          "kintone_error": "Railsには保存されましたが、kintone同期に失敗しました: %{error}",
          "notice": "価格マスタを作成しました"
        },
        "sync": {
          "started": "kintone同期を開始しました。完了まで少々お待ちください"
        },
        "update": {
          "notice": "価格マスタを更新しました"
        }
      },
      "reviews": {
        "photos": {
          "create": {
            "success": "写真を追加しました"
          },
          "destroy": {
            "success": "写真を削除しました"
          }
        },
        "publication": "レビューを公開しました",
        "unpublication": "レビューを非公開にしました",
        "update": {
          "success": "レビューを更新しました"
        }
      },
      "rooms": {
        "create": {
          "notice": "部屋を追加しました。"
        },
        "delete_image": {
          "alert": "対象の画像が見つかりませんでした。",
          "notice": "画像を削除しました。"
        },
        "handbook": {
          "update": {
            "notice": "しおり情報を更新しました"
          }
        },
        "import": {
          "create": {
            "blank_spreadsheet_id": "スプレッドシートIDを入力してください",
            "notice": "インポートが完了しました。"
          },
          "new": {
            "label": "スプレッドシートID",
            "submit": "インポート実行",
            "title": "%{nursery_name} にヒアリングシートから部屋をインポート"
          },
          "nursery_not_found": "留学施設が見つかりません"
        },
        "link_nursery": {
          "already_linked": "%{room_name}は既に%{nursery_name}に紐づいています。",
          "kintone_error": "Kintone接続テーブルへの登録に失敗しました。管理者に連絡してください。",
          "kintone_room_not_found": "KintoneからゲストハウスIDを取得できませんでした。Kintone上の部屋データを確認してください。",
          "not_found": "入力されたKintone IDに対応する部屋が見つかりませんでした。",
          "notice": "%{room_name}を%{nursery_name}に紐づけました。"
        },
        "unlink_nursery": {
          "not_found": "紐づけが見つかりませんでした。",
          "notice": "%{room_name}と%{nursery_name}の紐づけを解除しました。"
        },
        "update": {
          "notice": "部屋を更新しました。"
        }
      },
      "seasonalities": {
        "create": {
          "notice": "シーズナリティ設定を保存しました"
        },
        "new": {
          "alert_no_plans": "一括設定するプランが選択されていません",
          "alert_not_found": "指定されたプランが見つかりませんでした"
        }
      },
      "todos": {
        "flash": {
          "import_started": "非同期処理を開始しました。成功結果はSlackの #h_ope_chatops に通知されます。"
        }
      }
    },
    "common": {
      "foot_consultation": {
        "button": "留学の相談をする",
        "day": "日",
        "lead_1": "留学先選びや留学に関するお悩みは、",
        "lead_2": "保育園留学プランナーにご相談ください。",
        "month": "月",
        "notes": "ご家族のご予定やご希望に合わせた留学先選び、留学に関するお悩み相談など、「保育園留学プランナー」がサポートいたします。チャットでお気軽にご相談ください。",
        "url": "https://hoikuen-ryugaku.com/planner",
        "year": "年",
        "year_suffix": "生年"
      },
      "footer": {
        "consult": {
          "link": "プランナーに相談をする",
          "notes": "ご家族さまのご希望に合わせてプランナーがご対応いたします。",
          "title": "アレルギー対応や特別支援が必要なご家族へ",
          "url": "https://hoikuen-ryugaku.com/planner"
        },
        "fee": {
          "link": "表示料金に含まれるもの",
          "notes": "表示されている料金については以下からご確認ください。",
          "title": "表示料金について",
          "url": "https://hoikuen-ryugaku.com/plan"
        },
        "landing_page": {
          "about": "保育園留学とは",
          "company_info": "会社情報",
          "conditions": "取引条件書",
          "contact_about_banner": "留学プランナーに相談",
          "contact_modal": {
            "after_booking": "ご予約後",
            "before_booking": "ご予約前",
            "go_to_line": "LINEへ遷移します",
            "go_to_mail": "メールへ遷移します",
            "title": "ご予約状況によりお問い合わせ方法が変わります"
          },
          "contact_via_line": "LINEで留学先診断",
          "elementary_school": "小学生留学",
          "faq": "よくある質問",
          "inquiries": "お問い合わせ",
          "invite_friend": "お友だち紹介プログラム",
          "kitchhike_company": "株式会社 キッチハイク",
          "mypage_button": "留学ご家族専用 マイページ",
          "operation_company": "運営会社",
          "plan_contact": "留学先に迷ったら",
          "plan_hint": "留学先選びのヒント集",
          "plan_list": "留学先一覧",
          "price_plan": "料金プラン",
          "privacy_policy": "プライバシーポリシー",
          "recruit": "採用情報",
          "related_service": "関連サービス",
          "responsibility": "地域・自治体の皆様へ",
          "search_plan": "留学先を探す",
          "stipulation": "旅行業約款",
          "study_abroad_experience": "留学体験談",
          "study_abroad_tax": "留学先納税",
          "terms_of_use": "サービス利用規約",
          "title": "保育園留学",
          "travel_deal_details": "旅行取引の詳細",
          "your_nursery": "おとなの保育園留学"
        },
        "request": {
          "link_1": "留学ご家族へのお願い",
          "link_2": "キャンセルポリシー",
          "notes_1": "保育園留学は、保育園・宿・地域のみなさまの協力のもと成り立っている事業です。",
          "notes_2": "留学時に守ってほしいお願いを記載したので、ご一読ください。",
          "policy_text": "プログラムの内容により適用されるキャンセルポリシーが異なります。",
          "title": "予約前にご確認ください",
          "url_1": "https://hoikuen-ryugaku.com/plan#request"
        },
        "sitemap": {
          "link_text_1": "運営会社",
          "link_text_2": "お問い合わせ",
          "link_text_3": "旅行取引の詳細",
          "link_text_4": "旅行業約款",
          "link_text_5": "取引条件書",
          "url_1": "https://kitchhike.jp/",
          "url_2": "mailto:support@hoikuen-ryugaku.zendesk.com",
          "url_3": "https://hoikuen-ryugaku.com/travel-deal-details",
          "url_4": "https://hoikuen-ryugaku.com/stipulation",
          "url_5": "https://hoikuen-ryugaku.com/jokensho"
        }
      },
      "google_tag_manager": {
        "id": "GTM-KMLC3MB"
      },
      "header": {
        "back_path_text": "サービスサイトへ戻る",
        "logo": "/images/logo_image_ja.png",
        "menu": {
          "mypage": "マイページ",
          "mypage_top": "マイページTOP",
          "service_top": "サービスTOP"
        },
        "title": "予約サイト",
        "url": "https://hoikuen-ryugaku.com/"
      },
      "message_bar": {
        "holiday": "ーーーー年末年始休業のお知らせーーーー\n休業期間：2025年12月30日（火）～2026年1月4日（日）\n※予約リクエスト結果につきましては、年明けの1月5日より順次確認しご連絡させていただきます。\nご迷惑をおかけいたしますが、何卒ご理解とご協力を賜りますようお願い申し上げます。\n",
        "maintenance": "現在システムメンテナンス中のため、動作が不安定になる可能性があります。操作がうまくいかない場合は時間を空けて再度お試し下さい。",
        "new_booking_notice": {
          "resumption": {
            "body": "令和8年熊本地震により被害に遭われた皆様に、改めて心よりお見舞い申し上げます。\n\nこのたび、熊本県内エリアの新規お申込み受付を、2026年9月1日より再開いたします。実際の保育園留学の受け入れは2026年10月上旬（10月4日の週）以降を予定しており、現地の園・宿泊施設と丁寧に調整を進めてまいります。\n\nご不便・ご心配をおかけいたしましたこと、改めてお詫び申し上げます。温かいお言葉をお寄せくださった皆様にも、心より感謝申し上げます。\n\nまた熊本の地で皆様をお迎えできる日を、楽しみにしております。\n",
            "title": "【熊本県内エリアの新規募集再開のお知らせ】"
          }
        }
      }
    },
    "csv_upload": {
      "created": {
        "one": "%{count}件を作成しました。",
        "other": "%{count}件を作成しました。"
      },
      "error": "CSVファイルのアップロードに失敗しました。",
      "error_detail": {
        "all_records_skipped": "すべてのレコードは既に登録済みのためスキップされました。",
        "kintone_sync_failed": "Kintoneとの同期に失敗しました。",
        "no_valid_records": "有効なレコードがありません。",
        "save_failed": "データベースへの保存に失敗しました。",
        "transaction_failed": "トランザクション処理に失敗しました。",
        "validation_failed": "CSVのバリデーションに失敗しました。"
      },
      "more_errors": "他%{count}件のエラー",
      "no_file": "CSVファイルが選択されていません。",
      "row": "行%{number}",
      "skipped": {
        "one": "%{count}件をスキップしました（既存データ）。",
        "other": "%{count}件をスキップしました（既存データ）。"
      },
      "success": "CSVファイルをアップロードしました。",
      "with_errors": {
        "one": "%{count}件のエラーがありました。",
        "other": "%{count}件のエラーがありました。"
      }
    },
    "date": {
      "abbr_day_names": [
        "日",
        "月",
        "火",
        "水",
        "木",
        "金",
        "土"
      ],
      "abbr_month_names": [
        null,
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      "day_names": [
        "日曜日",
        "月曜日",
        "火曜日",
        "水曜日",
        "木曜日",
        "金曜日",
        "土曜日"
      ],
      "formats": {
        "date_full_with_weekday": "%Y年%m月%d日 (%a)",
        "date_full_with_weekday_and_year": "%Y/%m/%d (%a)",
        "default": "%Y/%m/%d",
        "long": "%Y年%m月%d日(%a)",
        "month_and_day_simple": "%m/%d",
        "month_and_day_with_weekday": "%-m/%-d(%a)",
        "short": "%m/%d",
        "weekday": "%a",
        "year_and_month_and_day": "%Y/%-m/%-d"
      },
      "month_names": [
        null,
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "約%{count}時間",
        "about_x_months": "約%{count}ヶ月",
        "about_x_years": "約%{count}年",
        "almost_x_years": "%{count}年弱",
        "half_a_minute": "30秒前後",
        "less_than_x_minutes": "%{count}分未満",
        "less_than_x_seconds": "%{count}秒未満",
        "over_x_years": "%{count}年以上",
        "x_days": "%{count}日",
        "x_minutes": "%{count}分",
        "x_months": "%{count}ヶ月",
        "x_seconds": "%{count}秒",
        "x_years": "%{count}年"
      },
      "prompts": {
        "day": "日",
        "hour": "時",
        "minute": "分",
        "month": "月",
        "second": "秒",
        "year": "年"
      }
    },
    "day": {
      "formats": {
        "short": {
          "friday": "金",
          "monday": "月",
          "saturday": "土",
          "sunday": "日",
          "thursday": "木",
          "tuesday": "火",
          "wednesday": "水"
        }
      }
    },
    "devise": {
      "confirmations": {
        "account_verified": "アカウントが確認されました。",
        "already_confirmed": "このメールアドレスは既に認証済みです。",
        "confirmation_sent": "確認用のメールを送信しました。",
        "confirmed": "メールアドレスが確認できました。",
        "failed": "メールアドレスの確認に失敗しました。確認リンクが無効か、既に確認済みの可能性があります。",
        "new": {
          "resend_confirmation_instructions": "アカウント確認メール再送"
        },
        "send_instructions": "アカウントの有効化について数分以内にメールでご連絡します。",
        "send_paranoid_instructions": "メールアドレスが登録済みの場合、本人確認用のメールが数分以内に送信されます。"
      },
      "failure": {
        "already_authenticated": "すでにログインしています。",
        "inactive": "アカウントが有効化されていません。メールに記載された手順にしたがって、アカウントを有効化してください。",
        "invalid": "%{authentication_keys}またはパスワードが違います。",
        "last_attempt": "もう一回誤るとアカウントがロックされます。",
        "locked": "アカウントはロックされています。",
        "not_found_in_database": "%{authentication_keys}またはパスワードが違います。",
        "timeout": "セッションがタイムアウトしました。もう一度ログインしてください。",
        "unauthenticated": "ログインもしくはアカウント登録してください。",
        "unconfirmed": "メールアドレスの本人確認が完了していません。下部の「本人確認がお済みでない方はこちら」から確認メールを再送信し、メール内のリンクから本人確認を完了してください。"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "メールアドレスの確認",
          "greeting": "%{recipient}様",
          "instruction": "以下のリンクをクリックし、メールアドレスの確認手続を完了させてください。",
          "subject": "メールアドレス確認メール"
        },
        "email_changed": {
          "greeting": "こんにちは、%{recipient}様。",
          "message": "メールアドレスの（%{email}）変更が完了したため、メールを送信しています。",
          "message_unconfirmed": "メールアドレスが（%{email}）変更されたため、メールを送信しています。",
          "subject": "メール変更完了"
        },
        "password_change": {
          "greeting": "%{recipient}様",
          "message": "パスワードが再設定されました。",
          "subject": "パスワードの変更について"
        },
        "reset_password_instructions": {
          "action": "パスワード変更",
          "greeting": "%{recipient}様",
          "instruction": "パスワード再設定の依頼を受けたため、メールを送信しています。下のリンクからパスワードの再設定ができます。",
          "instruction_2": "パスワード再設定の依頼をしていない場合、このメールを無視してください。",
          "instruction_3": "パスワードの再設定は、上のリンクから新しいパスワードを登録するまで完了しません。",
          "subject": "パスワードの再設定について"
        },
        "unlock_instructions": {
          "action": "アカウントのロック解除",
          "greeting": "%{recipient}様",
          "instruction": "アカウントのロックを解除するには下のリンクをクリックしてください。",
          "message": "ログイン失敗が繰り返されたため、アカウントはロックされています。",
          "subject": "アカウントのロック解除について"
        }
      },
      "omniauth_callbacks": {
        "failure": "%{kind} アカウントによる認証に失敗しました。理由：（%{reason}）",
        "success": "%{kind} アカウントによる認証に成功しました。"
      },
      "passwords": {
        "edit": {
          "change_my_password": "パスワードを変更する",
          "change_your_password": "パスワードを変更",
          "confirm_new_password": "確認用新しいパスワード",
          "new_password": "新しいパスワード"
        },
        "new": {
          "forgot_your_password": "パスワードを忘れましたか？",
          "send_me_reset_password_instructions": "パスワードの再設定方法を送信する"
        },
        "no_token": "このページにはアクセスできません。パスワード再設定メールのリンクからアクセスされた場合には、URL をご確認ください。",
        "send_instructions": "パスワードの再設定について数分以内にメールでご連絡いたします。",
        "send_paranoid_instructions": "メールアドレスが登録済みの場合、パスワード再設定用のメールが数分以内に送信されます。",
        "token_expired_html": "パスワード再設定用のリンクの有効期限が切れています。<br> お手元に複数のパスワード再設定メールが届いている場合は、 <strong>最新のメールに記載されたリンク</strong>から再度お試しください。<br> 必要であれば、再度パスワード再設定をお試しください。\n",
        "token_invalid_html": "無効なパスワード再設定リンクです。<br> すでに使用済み、もしくは誤ったURLにアクセスしている可能性があります。<br> 再度パスワード再設定をお試しください。\n",
        "updated": "パスワードが正しく変更されました。",
        "updated_not_active": "パスワードが正しく変更されました。"
      },
      "registrations": {
        "destroyed": "アカウントを削除しました。またのご利用をお待ちしております。",
        "edit": {
          "are_you_sure": "本当によろしいですか？",
          "cancel_my_account": "アカウント削除",
          "currently_waiting_confirmation_for_email": "%{email} の確認待ち",
          "leave_blank_if_you_don_t_want_to_change_it": "空欄のままなら変更しません",
          "title": "%{resource}編集",
          "unhappy": "気に入りません",
          "update": "更新",
          "we_need_your_current_password_to_confirm_your_changes": "変更を反映するには現在のパスワードを入力してください"
        },
        "invalid_credentials": "無効なメールアドレスまたはパスワードです。",
        "new": {
          "sign_up": "アカウント登録"
        },
        "signed_up": "アカウント登録が完了しました。",
        "signed_up_but_inactive": "ログインするためには、アカウントを有効化してください。",
        "signed_up_but_locked": "アカウントがロックされているためログインできません。",
        "signed_up_but_unconfirmed": "本人確認用のメールを送信しました。メール内のリンクからアカウントを有効化させてください。",
        "update_needs_confirmation": "プロフィールを更新しました。変更されたメールアドレスの本人確認のため、本人確認用メールより確認処理をおこなってください。",
        "updated": "アカウント情報を変更しました。",
        "updated_but_not_signed_in": "あなたのアカウントは正常に更新されましたが、パスワードが変更されたため、再度ログインしてください。"
      },
      "sessions": {
        "already_signed_out": "既にログアウト済みです。",
        "new": {
          "sign_in": "ログイン"
        },
        "signed_in": "ログインしました。",
        "signed_out": "ログアウトしました。"
      },
      "shared": {
        "links": {
          "back": "戻る",
          "didn_t_receive_confirmation_instructions": "アカウント確認のメールを受け取っていませんか？",
          "didn_t_receive_unlock_instructions": "アカウントのロック解除方法のメールを受け取っていませんか？",
          "forgot_your_password": "パスワードを忘れましたか？",
          "sign_in": "ログイン",
          "sign_in_with_provider": "%{provider}でログイン",
          "sign_up": "アカウント登録"
        },
        "minimum_password_length": "（%{count}字以上）"
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "アカウントのロック解除方法を再送する"
        },
        "send_instructions": "アカウントのロック解除方法を数分以内にメールでご連絡します。",
        "send_paranoid_instructions": "アカウントが見つかった場合、アカウントのロック解除方法を数分以内にメールでご連絡します。",
        "unlocked": "アカウントをロック解除しました。"
      }
    },
    "discount_code_mailer": {
      "discount_code_email": {
        "subject": "紹介コード発行完了のお知らせ 【保育園留学・小学生留学 運営事務局】"
      },
      "discount_code_email_after_questionnaire": {
        "discount_code_url": "https://guide.hoikuen-ryugaku.com/code",
        "note": "ご利用条件",
        "note_text_1": "※1家族1回のみご利用いただけます",
        "note_text_2": "※次回ご予約時に前回の留学と同じメールアドレスをご入力ください",
        "note_text_3": "※ほかのディスカウントとの併用はできません",
        "note_text_4": "※対象地域、ご利用方法、除外期間については、こちらをご確認ください",
        "subject": "【保育園留学・小学生留学｜アンケート回答のお礼】次回ご利用いただけるディスカウントコードのご案内",
        "text1": "この度はアンケートにご協力いただき、誠にありがとうございました。",
        "text2": "いただいたお声は、園の先生方や地域のみなさまにとって大きな励みとなるだけでなく、\nこれから参加されるご家族にとっても大切な後押しとなります。",
        "text3": "また、今後の受け入れ環境の改善や、\n地域とご家族にとってより良い仕組みづくりに活かしてまいります。",
        "text4": "改めて、貴重なご意見をお寄せいただきましたことに心より感謝申し上げます。",
        "text5": "アンケートにご協力いただいたお礼として、\n次回の留学予約時にご利用いただける<strong>「1万円分のディスカウントコード」</strong>をご案内いたします。",
        "text6": "ディスカウントコード：hoikuenryugaku_again",
        "text7": "これからも、子育て家族がより安心して地域とつながり、\nご家族の時間が豊かに広がる未来を目指して取り組んでまいります。",
        "text8": "この度はアンケートへご協力いただき、誠にありがとうございました。\nどうぞこれからも、よろしくお願いいたします。",
        "title": "■ 次回の留学でご利用いただけるディスカウントコードのご案内"
      }
    },
    "enumerize": {
      "kintone/family_master": {
        "allergenic_foods": {
          "buckwheat": "そば",
          "crab": "カニ",
          "egg": "卵",
          "fruit": "果物",
          "meat_fish": "肉・魚",
          "milk": "牛乳・乳製品",
          "others": "その他",
          "peanut": "ピーナッツ",
          "shellfish": "甲殻類",
          "shrimp": "エビ",
          "soy": "豆・穀・種実類",
          "soybean": "大豆",
          "walnut": "くるみ",
          "wheat": "小麦"
        },
        "allergy_elimination": {
          "no_answer": "いいえ",
          "yes_answer": "はい"
        },
        "appetite_food": {
          "high": "旺盛",
          "low": "あまりない",
          "normal": "ふつう"
        },
        "baby_food": {
          "before_start": "開始前",
          "complete": "完了期",
          "early": "初期",
          "late": "後期",
          "middle": "中期",
          "toddler": "幼児食"
        },
        "breastfeeding": {
          "breast_milk": "母乳",
          "formula": "粉ミルク",
          "mixed": "混合",
          "weaned": "卒乳済み"
        },
        "business": {
          "company_employee_1": "会社員（総合職）",
          "company_employee_2": "会社員（一般職）",
          "contract_employee": "契約社員・派遣社員",
          "housewife": "専業主婦・主夫",
          "manager": "経営者・役員",
          "medical_personnel": "医療関係者",
          "other": "その他",
          "part_timer": "パート・アルバイト",
          "professional": "士業（公認会計士・弁護士・税理士・司法書士）",
          "public_employee": "公務員（教職員除く）",
          "retired": "定年退職",
          "self_employed": "自営業・自由業",
          "student": "学生",
          "teacher": "教職員",
          "unemployed": "無職"
        },
        "development_concerns": {
          "attention": "注意の持続・多動傾向",
          "communication": "言葉の理解・コミュニケーション",
          "group_rules": "集団の中での過ごし方・ルール",
          "instruction": "一斉指示への反応・理解",
          "motor": "手先の操作・身体の動かし方",
          "sensory": "感覚の過敏・鈍麻",
          "transition": "活動の切り替え・かんしゃく"
        },
        "development_current_support": {
          "none": "特別なサポートは受けていない",
          "not_attending": "園・学校に通っていない",
          "teacher_care": "担任が個別配慮している（加配なし）",
          "with_aide": "加配・支援員がついている"
        },
        "development_professional_support": {
          "not_using": "利用していない",
          "using": "利用している（療育・医療機関）"
        },
        "developmentaldisorder": {
          "concern": "診断はないが気になる点がある",
          "diagnosed": "診断を受けたことがある",
          "no_answer": "無",
          "none": "特になし",
          "yes_answer": "有"
        },
        "dietary_restriction_elimination_level": {
          "complete": "完全除去 ｜ その食材は使わない（微量混入は許容）",
          "conditional": "条件許容 ｜ 加熱・加工された形なら食べられる",
          "legacy_no": "除去食の対応希望なし",
          "legacy_yes": "除去食の対応希望",
          "strict": "厳密除去 ｜ だし・エキスや微量の混入も不可"
        },
        "dietary_restriction_type": {
          "halal": "ハラール",
          "kosher": "コーシャ",
          "other": "その他",
          "pescatarian": "ペスカタリアン",
          "vegan": "ヴィーガン",
          "vegetarian": "ベジタリアン"
        },
        "exercise": {
          "crawling": "ハイハイ",
          "rolling_over": "寝返り",
          "standing_with_support": "つかまり立ち",
          "walking": "歩く"
        },
        "family_relationship": {
          "brother": "兄弟/姉妹",
          "father": "父親",
          "grandfather": "祖父",
          "grandmother": "祖母",
          "member": "本人",
          "mother": "母親",
          "other": "その他"
        },
        "food_allergies_yes_or_no": {
          "no_answer": "無",
          "yes_answer": "有"
        },
        "food_allergy_anaphylaxis_history": {
          "no_answer": "ない",
          "yes_answer": "ある"
        },
        "food_allergy_elimination_level": {
          "complete": "完全除去 ｜ その食材は使わない（微量混入は許容）",
          "conditional": "条件許容 ｜ 加熱・加工された形なら食べられる",
          "legacy_no": "除去食の対応希望なし",
          "legacy_yes": "除去食の対応希望",
          "strict": "厳密除去 ｜ だし・エキスや微量の混入も不可"
        },
        "food_allergy_epipen": {
          "have": "所持している（園・学校での対応要）",
          "not_have": "所持していない"
        },
        "food_allergy_guardian_visit": {
          "can_visit": "保護者が園・学校に来て服薬対応できる",
          "cannot_visit": "保護者が来ることは難しい"
        },
        "food_allergy_medication_required": {
          "not_required": "不要",
          "required": "必要（抗ヒスタミン薬など）"
        },
        "food_allergy_severity": {
          "mild": "軽度（皮膚症状のみ）",
          "moderate": "中度（複数症状あり）",
          "severe": "重度（アナフィラキシー歴あり）"
        },
        "foodrequest_yes_or_no": {
          "no_answer": "無",
          "yes_answer": "有"
        },
        "gender": {
          "female": "女",
          "male": "男",
          "other": "その他"
        },
        "medical_current_status": {
          "observing": "経過観察中",
          "remission": "寛解・完治",
          "treating": "治療中・服薬中"
        },
        "medical_history": {
          "no_answer": "無",
          "yes_answer": "有"
        },
        "medical_support_level": {
          "daily": "毎日対応が必要（服薬管理・日常ケア等）",
          "on_symptom": "症状が出たときのみ対応が必要",
          "share_only": "情報共有のみ（特別な対応は不要）"
        },
        "napping": {
          "alone": "ひとりで",
          "carried": "おんぶ",
          "cuddle": "添い寝",
          "held": "だっこ"
        },
        "nonfood_allergies": {
          "no_answer": "無",
          "yes_answer": "有"
        },
        "nonfood_allergy_causes": {
          "animal": "動物",
          "house_dust": "ハウスダスト",
          "insect": "昆虫",
          "medicine": "薬剤",
          "metal": "金属",
          "other": "その他",
          "pollen": "花粉",
          "sunlight": "日光"
        },
        "nonfood_allergy_epipen": {
          "have": "所持している（園・学校での対応要）",
          "not_have": "所持していない"
        },
        "nonfood_allergy_severity": {
          "mild": "軽度（情報共有のみ・対応不要）",
          "moderate": "中度（活動制限が必要）",
          "severe": "重度（アナフィラキシー歴あり）"
        },
        "opportunitynurseryschool": {
          "no_answer": "無",
          "yes_answer": "有"
        },
        "planned_participation": {
          "daycare": "保育園留学",
          "elementary": "小学生留学"
        },
        "question1": {
          "answer": "確認しました"
        },
        "same_as_representative_address": {
          "same_as_representative_address": "代表者と同じ"
        },
        "same_as_representative_phone_number": {
          "same_as_representative_phone_number": "代表者と同じ"
        },
        "school_type": {
          "national": "国立",
          "private": "私立",
          "public": "公立"
        },
        "toilet": {
          "fail": "トイレでできない",
          "success": "トイレでできる",
          "training": "練習中"
        },
        "underwear": {
          "cloth_diaper": "布おむつ",
          "cloth_pants": "布パンツ",
          "disposable_diaper": "紙おむつ",
          "training_pants": "トレーニングパンツ"
        }
      },
      "kintone/representative_user_master": {
        "business": {
          "company_employee_1": "会社員（総合職）",
          "company_employee_2": "会社員（一般職）",
          "contract_employee": "契約社員・派遣社員",
          "housewife": "専業主婦・主夫",
          "manager": "経営者・役員",
          "medical_personnel": "医療関係者",
          "other": "その他",
          "part_timer": "パート・アルバイト",
          "professional": "士業（公認会計士・弁護士・税理士・司法書士）",
          "public_employee": "公務員（教職員除く）",
          "retired": "定年退職",
          "self_employed": "自営業・自由業",
          "student": "学生",
          "teacher": "教職員",
          "unemployed": "無職"
        },
        "co_workers": {
          "no_answer": "いいえ",
          "yes_answer": "はい"
        },
        "family_relationship": {
          "brother": "兄弟/姉妹",
          "father": "父親",
          "grandfather": "祖父",
          "grandmother": "祖母",
          "member": "本人",
          "mother": "母親",
          "other": "その他"
        },
        "gender": {
          "female": "女性",
          "male": "男性",
          "other": "その他"
        }
      },
      "kintone/reservation_request": {
        "consideration_term": {
          "1_month": "1ヶ月以内",
          "1_week": "1週間以内",
          "1_year": "1年以内",
          "3_months": "3ヶ月以内",
          "6_months": "6ヶ月以内",
          "more_than_1_year": "それ以上"
        },
        "expectation": {
          "education": "他の保育・教育の質や雰囲気を体験したい",
          "experience": "違う環境で子育てする体験をしてみたい",
          "growth": "子どもの成長や変化を感じたい",
          "nature": "子どもに自然体験をさせたい",
          "new_place": "新しい交流や場所を増やしたい",
          "other": "その他",
          "parent": "親のリフレッシュ・ワーケーションしたい",
          "travel": "旅行や観光をしたい",
          "two_points": "二拠点生活先や移住先の候補をみつけたい"
        },
        "interview": {
          "cooperation": "協力します",
          "no_cooperation": "協力しません"
        },
        "prtrait_right": {
          "limited_permission": "留学施設の関係者・保護者の個人利用のみ許可する（連絡帳など）",
          "no_permission": "写真の掲載を許可しません",
          "yes_permission": "写真の掲載を許可します"
        },
        "route": {
          "facebook": "Facebook",
          "family": "両親・家族からの紹介",
          "flyers": "チラシ",
          "friends": "友だち・同僚からの紹介",
          "instagram": "Instagram",
          "line": "LINE",
          "newspapers": "新聞",
          "other": "その他",
          "preschool": "通っている園からの紹介",
          "search": "検索",
          "tv": "テレビ",
          "web_news": "Webニュース・web記事",
          "x": "X",
          "youtube": "Youtube"
        }
      },
      "kintone/todo_master": {
        "requirement_status": {
          "conditionally_required": "条件付き必須",
          "required": "必須"
        },
        "ryugaku_type": {
          "all": "すべて",
          "domestic": "国内のみ",
          "jpe": "JPEのみ"
        },
        "time_limit_entry_point": {
          "end_of_stay": "滞在終了日",
          "end_of_stay_on_the_day": "滞在終了日実施",
          "interview_date": "面談日",
          "interview_date_on_the_day": "面談日実施",
          "reservation_accepted_date": "予約承認日",
          "reservation_accepted_date_on_the_day": "予約承認日実施",
          "start_of_stay": "滞在開始日",
          "start_of_stay_on_the_day": "滞在開始日実施"
        },
        "todo_type": {
          "common_todo": "全予約共通todo",
          "guest_house_todo": "宿に紐づくtodo",
          "nursery_todo": "留学施設に紐づくtodo"
        },
        "url_categories": {
          "family_form": "家族情報登録フォーム",
          "nursery_meeting_form": "面談日程調整",
          "reservation_form": "事前質問フォーム",
          "review_form": "留学後アンケートフォーム",
          "todo_uploads_form": "汎用フォームページ",
          "todos_form": "汎用情報ページ"
        }
      }
    },
    "error_page": {
      "back_path": "予約可能な留学先一覧へ戻る"
    },
    "errors": {
      "format": "%{attribute}%{message}",
      "messages": {
        "accepted": "を受諾してください",
        "already_confirmed": "は既に登録済みです。ログインしてください。",
        "blank": "を入力してください。",
        "confirmation": "とパスワードの入力が一致しません。",
        "confirmation_period_expired": "の期限が切れました。%{period} までに確認する必要があります。 新しくリクエストしてください。",
        "empty": "を入力してください",
        "equal_to": "は%{count}にしてください",
        "even": "は偶数にしてください",
        "exclusion": "は予約されています",
        "expired": "の有効期限が切れました。新しくリクエストしてください。",
        "greater_than": "は%{count}より大きい値にしてください",
        "greater_than_or_equal_to": "は%{count}以上の値にしてください",
        "in": "は%{count}の範囲に含めてください",
        "inclusion": "は一覧にありません",
        "invalid": "が正しくありません。",
        "less_than": "は%{count}より小さい値にしてください",
        "less_than_or_equal_to": "は%{count}以下の値にしてください",
        "model_invalid": "バリデーションに失敗しました: %{errors}",
        "not_a_number": "は数値で入力してください",
        "not_an_integer": "は整数で入力してください",
        "not_found": "は見つかりませんでした。",
        "not_locked": "はロックされていません。",
        "not_saved": {
          "one": "エラーが発生したため %{resource} は保存されませんでした。",
          "other": "%{count} 件のエラーが発生したため %{resource} は保存されませんでした。"
        },
        "odd": "は奇数にしてください",
        "only_numbers_allowed": "は数字のみを入力してください",
        "other_than": "は%{count}以外の値にしてください",
        "password_invalid": "パスワードが正しくありません。",
        "password_too_long": "が長すぎます",
        "present": "は入力しないでください",
        "required": "を入力してください",
        "taken": "はすでに存在します",
        "too_long": "は%{count}文字以内で入力してください",
        "too_short": "が短すぎます（最小 %{count} 文字）",
        "wrong_length": "は%{count}文字で入力してください"
      },
      "rate_limit_exceeded": "リクエスト回数の上限に達しました。しばらく時間をおいて再度お試しください。",
      "template": {
        "body": "次の項目を確認してください",
        "header": "%{model}に%{count}個のエラーが発生しました"
      }
    },
    "helpers": {
      "select": {
        "prompt": "選択してください"
      },
      "submit": {
        "complete": "完了にすすむ",
        "create": "登録する",
        "save": "保存する",
        "submit": "提出にすすむ",
        "update": "更新する"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "jpe_reservation_lp": {
      "basic_info": {
        "school_lunch_not_provided": "School lunch: Not provided",
        "school_lunch_provided": "School lunch: Provided"
      }
    },
    "landing_page": {
      "avaiability": {
        "room": {
          "access_way": "園との距離",
          "bathroom": "浴室",
          "check_floor_plan": "間取り図を確認する",
          "drawer_title": "宿の詳細",
          "environment": "特徴",
          "food": "食事",
          "food_text": "食事%{food}",
          "max_capacity": "定員%{count}人(大人最大%{adult_count}人)",
          "max_capacity_text": "%{count}人",
          "work_environment": "仕事環境"
        }
      },
      "availability_status": {
        "available": "空きあり",
        "contact": "お問い合わせ",
        "legend_aria": "空き状況の凡例",
        "limited_availability": "残りわずか",
        "sold_out": "満枠"
      },
      "search_calendar": {
        "adults": "おとな",
        "children": "こども",
        "stay_period": "滞在期間",
        "title": "滞在期間と人数を変えて料金確認",
        "txt_change": "変更"
      }
    },
    "last_minute_inquiry_mailer": {
      "confirmation_email": {
        "subject": "【保育園留学】お問い合わせを受け付けました"
      }
    },
    "login": {
      "email": "メールアドレス",
      "password": "パスワード",
      "resend_confirmation": "本人確認がお済みでない方はこちら",
      "reset_password": "パスワードを忘れた方はこちら",
      "submit": "ログインする",
      "title": "ログイン"
    },
    "mailer": {
      "from": "保育園留学・小学生留学 運営事務局 <no-reply@kitchhike.com>"
    },
    "message": {
      "error": {
        "address": {
          "load": "住所の取得に失敗しました。手動で入力してください。"
        },
        "card": {
          "expiration_date": {
            "expired": "カードの有効期限が過ぎています。",
            "incorrect": "カードの有効期限に不備があります。"
          },
          "number": {
            "incorrect": "カード番号に不備があります。"
          },
          "security_code": {
            "incorrect": "カードのセキュリティコードに不備があります。"
          }
        },
        "code": {
          "e_000": "予期せぬエラーが発生しました。運営事務局へお問い合わせください。",
          "e_001": "開始日が無効であるか、チェックイン日がすでに予約されています。予約可能な日程であるか再度ご確認ください。",
          "e_002": "入力パラメータが正しくありません。選択した留学先やプラン、日程を再度ご確認ください。",
          "e_003": "ご入力いただいたメールアドレスですでにこの期間に予約されています。メールに送信された予約内容をご確認ください。",
          "e_004": "留学先が見つかりません。選択した留学先を再度ご確認ください。",
          "e_005": "プランが見つかりません。選択したプランを再度ご確認ください。",
          "e_006": "宿泊施設が見つかりません。選択したプラン、日程を再度ご確認ください。",
          "e_007": "宿泊施設が見つかりません。選択したプラン、日程を再度ご確認ください。",
          "e_008": "販売可能な日付の数が滞在日数と一致しません。選択したプラン、日程を再度ご確認ください。",
          "e_010": "お探しのページは見つかりませんでした。"
        },
        "email": {
          "load": "メールアドレスが登録可能か否かの取得に失敗しました。"
        },
        "field": {
          "date": "日付"
        },
        "input": {
          "check": "%{field_name}にチェックを付けてください",
          "email_exists_login_required": "このメールアドレスは既に登録されています。ログインしてください。",
          "enter": "%{field_name}を入力してください",
          "full_capacity": "この日程は満席のため、ご予約いただけません。別の日程をお選びください。",
          "password_invalid_characters": "%{field_name}に使用できない文字が含まれています。半角スペース・全角文字・アクセント記号付きの文字・絵文字は使用できません",
          "password_mismatch": "パスワードが一致しません。",
          "password_too_long": "パスワードの文字数が制限を超えています",
          "select": "%{field_name}を選択してください",
          "valid_enter": "有効な%{field_name}を入力してください"
        },
        "please_try_again": "時間をおいてもう一度お試しください",
        "promotion": {
          "already_used": "すでに利用済みのコードです。",
          "invalid_code": "このコードは無効です。",
          "invalid_period": "このコードは利用期間外です。",
          "invalid_plan": "このプランには対象外のコードです。",
          "own_code": "本人の紹介コードは利用できません。"
        }
      },
      "error_404": "404 ページが見つかりません",
      "error_422": "422 処理できないエンティティ",
      "error_500": "500 内部サーバーエラー"
    },
    "month": {
      "abbr_month_names": {
        "1": "1月",
        "10": "10月",
        "11": "11月",
        "12": "12月",
        "2": "2月",
        "3": "3月",
        "4": "4月",
        "5": "5月",
        "6": "6月",
        "7": "7月",
        "8": "8月",
        "9": "9月"
      },
      "month_name_from_en": {
        "april": "4月",
        "august": "8月",
        "december": "12月",
        "february": "2月",
        "january": "1月",
        "july": "7月",
        "june": "6月",
        "march": "3月",
        "may": "5月",
        "november": "11月",
        "october": "10月",
        "september": "9月"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u %n",
          "negative_format": "-%u%n",
          "precision": 0,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "円"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "十億",
            "million": "百万",
            "quadrillion": "千兆",
            "thousand": "千",
            "trillion": "兆",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n%u",
          "units": {
            "byte": "バイト",
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "nursery_meeting_email": {
      "to_nursery": {
        "subject": "ご家族の面談予約を承りました【保育園留学・小学生留学 運営事務局】"
      },
      "to_user": {
        "meeting_date_time": "%{meeting_date_time}",
        "nursery_name": "%{nursery_name}",
        "subject": "面談予約を承りました【保育園留学・小学生留学 運営事務局】",
        "text1": "面談予約を承りました。\nご登録ありがとうございます。",
        "text2": "※面談日より3日前以内のご予約の場合、先生方の保育業務の都合により面談日の調整の依頼をさせていただくことがございます。\n何卒ご了承ください。",
        "text3": "ご予約のお時間が近づいてまいりましたら、\nご家族マイページのやることリストの面談項目をご確認ください。",
        "text4": "やることリストを確認する",
        "text5": "予約の変更・キャンセルは基本的に承っておりませんが、\n万が一ご都合が悪くなった場合は、直接滞在先の園へキャンセルされる旨お伝えいただき、\n再予約につきましては、運営事務局へお問い合わせください。",
        "text6": "※本メールにお心当りのない場合は、お手数ですが下記メール宛に\n返信いただけますようお願い申し上げます。",
        "user_full_name": "%{last_name} %{first_name}さま",
        "user_name": "%{user_name} さま"
      }
    },
    "ogp": {
      "account": {
        "password": {
          "edit": {
            "title": "保育園留学 | パスワード変更"
          }
        }
      },
      "confirmation": {
        "new": {
          "title": "保育園留学 | 確認メール再送信"
        }
      },
      "error": {
        "show": {
          "title": "エラー"
        }
      },
      "landing_page": {
        "title": "保育園留学 | %{nursery_name}"
      },
      "mypage": {
        "index": {
          "title": "保育園留学 | マイページ"
        }
      },
      "plan": {
        "index": {
          "description": "保育園留学の留学先 %{alias} のプラン一覧を確認できます。",
          "title": "保育園留学 %{alias} プラン一覧 予約"
        },
        "show": {
          "description": "保育園留学の留学先 %{name} のプラン内容を確認できます。",
          "title": "保育園留学 %{name} 予約"
        }
      },
      "profile": {
        "show": {
          "title": "保育園留学 | プロフィール"
        }
      },
      "referral_code": {
        "complete": {
          "title": "保育園留学 | 紹介コード発行完了"
        },
        "new": {
          "title": "保育園留学 | 紹介コード発行の情報入力"
        }
      },
      "registration": {
        "edit": {
          "title": "保育園留学 | メールアドレス変更"
        }
      },
      "reservation": {
        "complete": {
          "title": "保育園留学 | 予約リクエスト完了"
        },
        "confirm": {
          "title": "保育園留学 | 予約内容確認"
        },
        "new": {
          "title": "保育園留学 | 予約情報入力"
        }
      },
      "reset_password": {
        "new": {
          "title": "保育園留学 | パスワード再設定"
        }
      },
      "reviews": {
        "index": {
          "description": "保育園留学の留学先 %{alias} に滞在したご家族の声を確認できます。",
          "title": "保育園留学 %{alias} ご家族の声一覧"
        }
      },
      "session": {
        "new": {
          "title": "保育園留学 | ログイン"
        }
      },
      "site_name": "保育園留学 | 留学先一覧 予約サイト",
      "top": {
        "index": {
          "description": "保育園留学の留学先の空き枠状況や料金を一覧で確認できます。",
          "image": "/images/nursery_OGP_image_ja.jpg",
          "title": "保育園留学 | 留学先一覧 予約"
        }
      }
    },
    "password": {
      "confirm_password": "パスワード（確認用）",
      "email": "メールアドレス",
      "notes_1": "入力されたメールアドレス宛にパスワード再設定のURLを送信します。",
      "password": "パスワード",
      "reset_button": "パスワードを設定する",
      "reset_email_submit": "送信する",
      "title": "パスワード再設定"
    },
    "plan_detail": {
      "access": {
        "address": "住所：〒%{postal_code}",
        "title": "アクセス"
      },
      "accommodation": {
        "title": "宿泊施設",
        "type": "宿タイプ：%{type}、 定員%{capacity}名"
      },
      "back_path": "一覧へ戻る",
      "carousel": {
        "more": "もっと写真を見る"
      },
      "check_in_out": {
        "check_in": "チェックイン",
        "check_out": "チェックアウト",
        "title": "チェックイン・チェックアウト"
      },
      "childcare": {
        "notes": "持ち物や服装を確認",
        "title": "保育時間",
        "weekdays": "平日：%{start_time}〜%{end_time}（%{hours}時間）"
      },
      "eligibility": "受入条件：%{eligibility}",
      "extended": {
        "title": "延長保育時間"
      },
      "facility": {
        "notes": "部屋ごとの設備を確認",
        "title": "設備・備品"
      },
      "label": {
        "aboard_accept_class": "年齢",
        "access": "アクセス",
        "address": "住所",
        "allergy": "アレルギー対応",
        "childcare_time": "時間",
        "elementary_accept_class": "学年",
        "entry_requirement": "登園経験のない子どもの受入",
        "extending_time": "延長保育",
        "google_map": "Google mapはこちら",
        "lunch": "給食"
      },
      "local": {
        "button": "留学先案内サイトを見る",
        "text": "留学施設の魅力や特徴、暮らし環境、ワークスペース、周辺マップや週末アクティビティなど、より詳細な現地情報はこちらの留学先案内サイトからご確認いただけます。",
        "title": "現地情報"
      },
      "navigation": {
        "accommodation": "宿泊施設",
        "available_plan": "留学プラン",
        "family_voice": "ご家族の声",
        "nursery_info": "留学施設"
      },
      "preschool": "留学施設",
      "remote_work": {
        "title": "リモートワーク環境"
      },
      "reservation": {
        "breakdown": "内訳",
        "button": "予約にすすむ",
        "date_range": {
          "select": "日付をえらぶ"
        },
        "modal": {
          "breakdown": {
            "adult_rate": "大人料金（税込・合計）※中学生以上",
            "basic_price": "基本料金",
            "child_rate": "子ども料金（税込・合計）",
            "elementary_aboard": "小学生留学：￥%{unit_price} ×",
            "not_and_elementary": "留学なし（小学生）：￥%{unit_price} ×",
            "not_and_toddler": "留学なし（未就学児）：￥%{unit_price} ×",
            "nursery_aboard": "保育園留学：￥%{unit_price} ×",
            "option_price": "オプション料金（税込）",
            "plan_price": "プラン料金（税込）",
            "title": "料金の内訳",
            "total": "料金合計（税込）"
          },
          "clear": "クリア",
          "close": "閉じる",
          "people": {
            "adult": "大人",
            "birthdate_notice": "滞在時のクラスを確認するために、お子さまの生年月日を入力してください。",
            "child": "子ども",
            "elementary_aboard": "小学生留学",
            "first_child_birthdate": "登園あり%{count}人目の生年月日",
            "min_children_notice": "こども人数を1名以上にしてください。",
            "not_and_elementary": "留学なし（小学生）",
            "not_and_toddler": "留学なし（未就学児）",
            "notes_1": "留学開始日での年齢をもとに入力ください。プランにより受け入れ対象外の場合があります。",
            "notes_3": "数日のみ同伴する家族（大人）がいる場合は、次の画面の「オプション選択」で人数と宿泊日数をご入力ください。",
            "nursery_aboard": "保育園留学",
            "nursery_elementary_aboard": "保育園留学・小学生留学",
            "sold_out_notice": "ご希望のクラス・該当の日程は、現在定員に達しております。",
            "study_abroad": "留学あり",
            "study_abroad_birthdate": "%{count}人目の生年月日",
            "title": "人数"
          },
          "save": "保存"
        },
        "people": {
          "select": ""
        },
        "sold_out": "売り切れ",
        "total": "料金合計"
      },
      "reviews": {
        "read_more": "続きを読む",
        "read_others": "%{count}件をすべて表示"
      },
      "room_info": {
        "accommodation_info": "滞在先情報",
        "accommodation_type": "宿タイプ",
        "address": "住所",
        "bathroom": "バスルーム",
        "bedroom": "寝室",
        "capacity": {
          "number": "最大%{count}名",
          "title": "定員"
        },
        "kitchen": "キッチン",
        "laundry": "ランドリー",
        "meal_service": "食事サービス",
        "parking_available": "駐車場の有無",
        "parking_comments": "駐車場：備考",
        "parking_comments_en": "駐車場：備考（JPE）",
        "pets": "ペット",
        "separate_room": "夫婦別室ワーク",
        "transportation": "移動手段",
        "wifi": "Wi-Fi"
      },
      "same_region_plan": "この地域の他のプラン",
      "section": {
        "accommodation": "宿泊施設",
        "accommodation_access_aboard": "アクセス(宿泊施設↔︎留学施設)",
        "accommodation_access_nursery": "アクセス(宿泊施設↔︎留学施設)",
        "accommodation_info": "滞在先情報",
        "available_plan": "留学プラン",
        "educational_facility": "留学施設",
        "family_voice": "ご家族の声",
        "preschool_facility": "留学施設"
      },
      "view_detail": "留学先サイトを見る"
    },
    "plan_list": {
      "back_path": "留学先一覧へ戻る",
      "component": {
        "accept_class": "留学できるクラス",
        "button": {
          "available_date": "空き日程",
          "select": "プラン選択",
          "sold_out": "売り切れ"
        },
        "capacity": {
          "all": "定員%{count}名",
          "one": "Max. %{count} Person",
          "other": "Max. %{count} People"
        },
        "currency": "￥",
        "estimate": "大人2名・子ども1名の目安",
        "inquire_whatapp": "WhatsAppへの導線する",
        "loading": "ロード中...",
        "lp_check_availability": "空き日程を見る",
        "lp_see_more": "この留学先をもっと見る",
        "see_more": "もっと見る",
        "slot": {
          "full": "満枠",
          "left": "あと%{count}枠"
        },
        "time": "時間",
        "year_section": "%{year}年"
      },
      "empty": {
        "text_1": "現在、この留学先が募集しているプランはありません。",
        "text_2": "他の留学先からお探しください。"
      },
      "filtering": {
        "content": {
          "count": "しぼりこみ結果：%{count}/%{total}件",
          "count_result": "しぼりこみ結果：%{count}件",
          "title": "募集プラン一覧"
        },
        "period": {
          "form": "期間を選択",
          "title": "年月で絞り込み"
        },
        "title": "しぼりこみ"
      }
    },
    "plan_search_service": {
      "accept_class_code_map": {
        "0": "0歳児",
        "1": "1歳児",
        "10": "5年生",
        "11": "6年生",
        "2": "2歳児",
        "3": "3歳児",
        "4": "4歳児",
        "5": "5歳児",
        "6": "1年生",
        "7": "2年生",
        "8": "3年生",
        "9": "4年生"
      }
    },
    "preschool": {
      "change_request_mailer": {
        "decided": {
          "comment": "運営からのコメント:",
          "effective_from": "適用開始日: %{date}",
          "greeting": "%{partner_name} のご担当者さま",
          "lead": {
            "approved": "%{nursery_name} の「%{label}」の変更申請が承認され、設定に反映されました。",
            "approved_future": "%{nursery_name} の「%{label}」の変更申請が承認されました。%{date} から反映されます。",
            "rejected": "%{nursery_name} の「%{label}」の変更申請は却下されました。",
            "revision_requested": "%{nursery_name} の「%{label}」の変更申請が差し戻されました。"
          },
          "next": {
            "approved": "変更後の内容は園管理画面で確認できます。",
            "rejected": "必要な場合は、内容を見直して新しく申請してください。",
            "revision_requested": "園管理画面のダッシュボードから内容を確認し、修正して再申請してください。"
          },
          "requested_at": "申請日時: %{at}",
          "subject": {
            "approved": "変更申請が承認されました【保育園留学・小学生留学 運営事務局】",
            "rejected": "変更申請が却下されました【保育園留学・小学生留学 運営事務局】",
            "revision_requested": "変更申請が差し戻されました【保育園留学・小学生留学 運営事務局】"
          },
          "target_classes": "対象クラス: %{classes}",
          "target_period": "対象期間: %{from} 〜 %{to}"
        }
      },
      "staff_mailer": {
        "approval_requested": {
          "action": "アカウント管理画面から内容を確認のうえ、「承認する」を押してください。承認すると、このスタッフは管理画面を利用できるようになります。",
          "applicant": "メールアドレス: %{email}",
          "greeting": "%{partner_name} のご担当者さま",
          "lead": "招待した以下のスタッフがアカウント登録を完了し、承認待ちの状態です。",
          "note": "心当たりのないメールアドレスの場合は、承認せずにアカウントを削除してください。",
          "subject": "新しいスタッフアカウントの承認をお願いします【保育園留学・小学生留学 運営事務局】"
        },
        "common": {
          "action": "下記の URL を開き、アカウントの登録を完了してください。",
          "expired_note": "※ 有効期限を過ぎた場合は、招待した担当者に再送信を依頼してください。",
          "expires_at": "※ この URL の有効期限は %{expires_at} です。",
          "no_reply": "本メールは送信専用です。ご不明な点は下記までお問い合わせください。"
        },
        "invitation_issued": {
          "lead": "%{partner_name} の園管理画面のアカウントに招待されました。",
          "subject": "本人確認をし、アカウント登録を完了してください【保育園留学・小学生留学 運営事務局】"
        },
        "partner_added": {
          "lead": "%{partner_name} の園管理画面のアカウントに追加されました。",
          "note": "お使いのメールアドレスは既に登録済みのため、パスワードの再設定は不要です。",
          "subject": "アカウント認証を完了してください【保育園留学・小学生留学 運営事務局】"
        },
        "setup_completed": {
          "action": "下記のログイン URL よりご利用いただけます。",
          "greeting": "%{name} さま",
          "lead": "保育園留学 園管理画面のアカウント登録が完了しました。",
          "subject": "アカウント登録が完了しました【保育園留学・小学生留学 運営事務局】"
        }
      }
    },
    "price_text": "￥%{price}",
    "referral_code": {
      "cannot_be_used_for_the_referrers_own": "紹介コードは紹介者さまご自身の予約にはご利用いただけません。",
      "cannot_be_used_in_conjunction": "紹介コードは他のプロモーションコードと併用してご利用いただけません。",
      "click_the_button": "ご紹介者のお名前とメールアドレスを入力し、紹介コードを発行するボタンを押してください。",
      "complete": {
        "title": "保育園留学 | 紹介コード発行完了"
      },
      "copied_text": "紹介コード【%{code_value}】\n\n割引金額：%{amount_value}円\n\n※ご利用は１人１回まで\n\n「保育園留学」は、地域と子育て家族をつなぎ、未来を作る留学プログラム。\nhttps://hoikuen-ryugaku.com/",
      "copy_completed": "コピーが完了しました",
      "copy_the_referral_code": "紹介コードをコピーする",
      "email_address": "メールアドレス",
      "errors": {
        "not_valid": "ご登録情報と一致しません。内容を確認のうえ、再度お試しください。"
      },
      "first_name": "名（漢字）",
      "guide_link_html": "<span>対象地域、ご利用方法や除外期間などは<a href='https://guide.hoikuen-ryugaku.com/code' target='_blank' class='underline'>こちら</a>をご参照ください。</span>",
      "information_entry": "紹介者情報の入力",
      "issuance_of_referral_code": "紹介コードの発行",
      "issue_the_referral_code": "紹介コードを発行する",
      "last_name": "姓（漢字）",
      "new": {
        "title": "保育園留学 | 紹介コード発行の情報入力"
      },
      "no_expiration_date": "紹介コードのご利用に有効期限はありません。",
      "please_check_it": "あなたの紹介コードを発行いたしました。ご入力メールアドレス宛に、紹介コードのお控えメールをお送りしたので合わせてご確認ください。",
      "settings_to_allow_receipt_html": "<span>携帯メールアドレスを入力する場合は、届かない場合がありますので、</span><span class='underline'>no-reply@kitchhike.com</span><span>の指定受信設定をお願いいたします。</span>",
      "the_same_code_will_be_displayed": "紹介コードの発行は1人1つまでとなります。発行のお手続きを2度行っても同じコードが表示されますのでご了承ください。",
      "usage_guidelines": "ご利用の注意事項",
      "use_the_referral_code_only_once": "紹介された側が紹介コードを利用できるのは、1人1回までです。",
      "you_can_share": "紹介コードは何人にでもお配り貼りいただけます。",
      "your_referral_code": "あなたの紹介コード"
    },
    "registration": {
      "edit": {
        "email": "代表者メールアドレス",
        "password": "パスワード",
        "submit": "変更する",
        "title": "メールアドレス変更"
      }
    },
    "reservation": {
      "children_info": {
        "count": "%{count}人目",
        "title": "留学する子ども情報"
      },
      "daycare_experience_modal": {
        "button_contact": "プランナーに相談する",
        "button_continue": "他の留学先を探す",
        "text_1": "お選びいただいた留学施設は、安全面や体制上の理由により、通園経験がないお子さまのお預かりが難しい施設です。",
        "title": "お預かりに関するお知らせ",
        "validation_text": "お選びいただいた留学施設は、通園経験が3日以上ないとお預かりできないため、予約を進めることができません。"
      },
      "food_allergy_modal": {
        "button_contact": "プランナーに相談する",
        "button_continue": "他の留学先を探す",
        "text_1": "お選びいただいた留学施設は、食物アレルギーをお持ちのお子さまのお預かりが難しい施設です。ご予約リクエストいただいてもお受け入れができない可能性があります。",
        "text_2": "条件に合った留学施設のご提案が可能です。",
        "title": "お預かりに関するお知らせ"
      },
      "full_capacity_modal": {
        "button_contact": "プランナーに相談する",
        "button_contact_url": "https://hoikuen-ryugaku.com/concierge#concierge2",
        "button_continue": "他の留学先を探す",
        "text_1": "ご希望のクラス・該当の日程は、現在定員に達しております。",
        "text_2": "恐れ入りますが、ほかの日程・留学先からお選びください。",
        "title": "定員に達しました"
      },
      "heart_modal": {
        "check_text": "上記、「留学家族のこころえ」の内容に同意する",
        "holiday_check_text": "祝日は留学施設がお休みであることを了承しました。",
        "mission": "私たちのミッションとして、「子育て世代がより人生を謳歌でき、素晴らしい地域が持続していく未来をつくる」を掲げております。この事業を持続可能なものとするために、ご家族には、いくつかの心得を身につけていただき、地域滞在をお楽しみいただくようお願いしています。",
        "rule_1": "「地域にお邪魔する」気持ちで滞在し、お礼を言葉や行動で表します。",
        "rule_2": "各留学先の方針を理解し、尊重します。",
        "rule_3": "マナーの良い行動を心がけ、送り迎えの時間を守ります。",
        "rule_4": "こどもの成長を第一に考えた行動を、心がけます。",
        "rule_5": "宿の利用ルールを守ります。",
        "rule_6": "地域の方針に沿って、暮らしのルールを守ります。",
        "sub_subscription": "保育園留学・小学生留学",
        "sub_title": "留学家族のこころえ",
        "submit": "予約内容の入力へ進む",
        "subscription": "お申し込みいただく前に、以下のご確認をお願いしています。",
        "text_1": "保育園留学・小学生留学は、“観光”ではなく“地域の暮らし”体験をお届けしています。地域コミュニティの一員として、気持ちのよい振る舞いをお願いしています。",
        "text_2": "保育園留学・小学生留学では、留学先の施設で日々行われている活動をそのまま体験していただきます。ご家庭の考え方と違う場合でも、異なる価値観を親子で考える機会と捉えることをお願いしています。",
        "text_3": "留学先によっては延長対応がある場合もありますが、決められた時間内での送り迎えを厳守してください。過度な要望がある場合、受け入れをお断りすることもありますのでご了承ください。",
        "text_4": "保育園留学・小学生留学の目的は、お子さまが地域の中で健やかに成長し、豊かな経験を積むことにあります。留学先や宿泊施設、自治体の方、まち全体が、「こどものため・地域のため」としてご家族を歓迎しております。リフレッシュを主目的とする場合には、他サービスのご利用をご検討ください。",
        "text_5": "宿泊施設にはホテルや旅館だけでなく、自治体が運営する移住体験施設もあります。過度なサービスを求めず、各施設の利用時間やルールを尊重し、地域で受け入れてくれる方へ迷惑をかけないようお願いしています。",
        "text_6": "ごみの分別や交通ルールを遵守し、地域の暮らしに配慮した行動を心がけてください。地域の施設やサービスを利用する際は、時間やルールを守り、気持ちよくご利用いただけるようご協力をお願いしています。",
        "title": "予約条件の確認"
      },
      "progress": {
        "complete": "完了",
        "confirm": "確認",
        "enter": "入力"
      },
      "representative": {
        "occupation": {
          "company_employee": "会社員（総合職）",
          "company_employee_support": "会社員（一般職）",
          "contract_temporary": "契約社員・派遣社員",
          "default": "職業を選択",
          "employer": "勤務先（任意）",
          "house": "専業主婦・主夫",
          "income": "共働きかどうか",
          "item": "職業",
          "manager": "経営者・役員",
          "medical": "医療関係者",
          "no_answer": "いいえ",
          "other": "その他",
          "part_time": "パート・アルバイト",
          "professional": "士業（公認会計士・弁護士・税理士・司法書士）",
          "public_employee": "公務員（教職員除く）",
          "retired": "定年退職",
          "self_employ": "自営業・自由業",
          "student": "学生",
          "teacher": "教職員",
          "title": "仕事",
          "unemploy": "無職",
          "yes_answer": "はい"
        }
      },
      "room_capacity_modal": {
        "button_contact": "プランナーに相談する",
        "button_contact_url": "https://hoikuen-ryugaku.com/concierge#concierge2",
        "button_continue": "他の留学先を探す",
        "capacity_adults": "大人%{count}名",
        "capacity_children": "こども%{count}名",
        "capacity_separator": "・",
        "capacity_total": "合計%{count}名",
        "text_1": "ご指定の人数（大人%{adults}名・こども%{children}名）は、お選びの宿泊施設の定員を超えています。",
        "text_2": "この宿泊施設の定員は%{capacity}です。恐れ入りますが、人数を変更するか、ほかの宿泊施設・留学先からお選びください。",
        "title": "宿泊施設の定員を超えています"
      },
      "summary": {
        "accommodation": "宿泊施設：%{accommodation}",
        "adult": "大人%{count}人",
        "button": "プラン内容を見る",
        "child": "子ども%{count}人",
        "people": "人数：",
        "period": "留学期間：%{start_date}〜%{end_date}",
        "preschool": "留学施設：%{preschool}"
      }
    },
    "reservation_complete": {
      "back_path": "予約可能な留学先一覧へ戻る",
      "heading": "予約リクエスト完了",
      "notes_1": "ご予約をお受けできないこともございます。あらかじめご了承ください。",
      "notes_10": "お客様のアカウントが作成されました。",
      "notes_11": "アカウント認証のメールをお送りしていますので、",
      "notes_12": "ご確認ください。",
      "notes_2": "移動手段の確保やその他の手続きは、必ず予約確定後に行ってください。",
      "notes_3": "この後、運営側にて保育園と宿泊施設の受け入れ最終確認をいたします。最終確認が取れ次第、予約が確定となります。",
      "notes_4": "ご登録のメールアドレス宛に予約後のご案内をお送りしますので、お待ちください。（3営業日以内にご連絡いたします。）",
      "notes_5": "移動手段の確保やその他の手続きは、必ず予約確定後に行ってください。",
      "notes_6": "飛行機/新幹線",
      "notes_7": "レンタカー",
      "notes_8": "キャンセル保険の加入",
      "notes_9": "留学先納税　など",
      "title": "まだ予約は確定していません。"
    },
    "reservation_confirm": {
      "3dsecure": {
        "button": "3Dセキュアについて",
        "modal": {
          "body": "セキュリティの強化に伴い、ご利用のクレジットカードで3Dセキュア認証が必須となりました。\n予約リクエスト時に3Dセキュア認証が行われ、正常にご利用可能なカードかを確認させて頂きます。\n\nまた、3Dセキュア実施に伴い、3Dセキュア認証画面にて取引金額が「0円」と表示される事がございますが、認証や決済処理は正常に処理されております。\n\n引き続き安心してサービスをご利用いただくため、ご確認をお願いいたします。",
          "title": "3Dセキュア対応について"
        }
      },
      "account": {
        "password": "パスワード",
        "title": "アカウント情報"
      },
      "card_3ds_error": "3Dセキュア認証が失敗しました。もう一度お試し頂くか、カードを変更してお試しください。",
      "caution": {
        "notes": "運営側がリクエストを承認するまで予約は確定されません。\nお支払いは滞在初日に発生します。\nキャンセル料についてはキャンセルポリシーをご確認ください。",
        "title": "予約リクエストについて"
      },
      "heading": "予約内容の入力",
      "information": {
        "agree": {
          "check_box": "",
          "notes": ""
        },
        "cancellation": {
          "cancellation_policy_text": "キャンセルポリシー",
          "notes_1": "予約リクエスト送信後にキャンセル・日程変更する場合は、日数に応じてキャンセル料金が発生します。",
          "notes_2": "プログラムの内容により適用されるキャンセルポリシーが異なりますので、詳しくは",
          "notes_3": "をご確認ください。",
          "title": "【キャンセルについて】"
        },
        "confirmation": {
          "notes": "予約リクエスト送信時点では予約確定ではありません。登園されるお子さまの年齢や受け入れ先の状況を確認後、予約確定のご連絡をメールにてお送りさせていただきます。受け入れ先の状況によってご案内できない場合がございますので予めご了承ください。",
          "title": "【予約の確定】"
        },
        "local_taxes": {
          "notes": "地域により宿泊税・入湯税等の諸税が別途発生します。表示料金には含まれませんので、対象地域では現地にてお支払いをお願いいたします。",
          "title": "【諸税に関するご案内】"
        },
        "other_item": {
          "cancel_text": "キャンセルポリシー",
          "conditions_text": "取引条件書",
          "conditions_url": "https://hoikuen-ryugaku.com/stipulation",
          "family_text": "ご家族向けの基本ルール",
          "family_url": "https://hoikuen-ryugaku.com/family-rules",
          "note": "※取引条件説明書面は、電磁的方法で交付させていただきます。必ず、お客様ご自身で内容を確認し保存してください。",
          "privacy_policy_text": "プライバシーポリシー",
          "privacy_policy_url": "https://kitchhike.jp/privacy_policy",
          "terms_text": "サービス利用規約",
          "terms_url": "https://hoikuen-ryugaku.com/terms-of-use",
          "title": "予約に伴う確認事項"
        },
        "request_to_family": {
          "notes_1": "地域コミュニティの一員となるご家族のみなさまには、",
          "notes_2": "ご家族向けの基本ルール",
          "notes_3": "に従っていただくようお願いしています。",
          "title": "ご家族へのお願い",
          "url": "https://hoikuen-ryugaku.com/family-rules"
        },
        "title": "ご注意・ご案内"
      },
      "modal_booking": {
        "booking_info": "予約内容",
        "button": "予約リクエストにすすむ",
        "capacity_over": {
          "adults": "大人%{count}名",
          "children": "こども%{count}名",
          "message": "ご指定の人数は、この宿泊施設の定員（%{capacity}）を超えています。人数を変更するか、ほかの宿泊施設・留学先からお選びください。",
          "separator": "・",
          "total": "合計%{count}名"
        },
        "contact": "問合せ",
        "currency": "円",
        "currency_man": "万",
        "holiday_caption": "祝日はお休みの場合があります",
        "people": "名",
        "period": "留学期間：",
        "sold_out": "満枠",
        "storage_notice": {
          "allergy": "お選びの留学施設は、食物アレルギーをお持ちの方のお預かりが難しい可能性があります。",
          "school_experience": "お選びの留学施設は、週3日以上の通園経験がない場合、お預かりが難しい園となります。",
          "title": "お預かりに関する重要なお知らせ"
        },
        "title": {
          "text_1": "以下の内容で",
          "text_2": "予約リクエストへ進みますか？"
        }
      },
      "payment": {
        "card_info": "クレジットカード情報",
        "card_number": "クレジットカード番号",
        "error_invalid_email": "メールアドレスが一致していません。もう一度ご確認ください",
        "expiration_date": "有効期限",
        "security_code": "セキュリティコード",
        "title": "お支払い方法"
      },
      "price": {
        "breakdown": "内訳",
        "breakdown_button": "料金の内訳を見る",
        "button": "予約をリクエストする",
        "confirmation": "私は、旅行条件書、プライバシーポリシー、サービス利用規約、キャンセルポリシー、ご家族向けの基本ルールを読んだ上で、内容に同意したものとします。また、予約リクエストを運営側で承認した場合、表示の金額の合計額を支払うことにも同意したものとします。",
        "processing": "リクエスト中...",
        "total": "料金合計（税込）"
      },
      "promotion": {
        "amount": "-￥%{amount}",
        "applied": "%{code}が適用されました。",
        "button": "適用する",
        "code": "紹介コード / プロモコード（任意）",
        "discount": "プロモーション割引：",
        "title": "プロモーション"
      },
      "representative": {
        "address": {
          "country": "国名",
          "email": "メールアドレス",
          "phone_number": "電話番号",
          "postal_code": "郵便番号",
          "title": "住所"
        },
        "date_of_birth": "生年月日",
        "gender": "性別",
        "name": "姓名（ふりがな）",
        "name_cn": "姓名",
        "relationship": "留学する子どもとの続柄",
        "title": "代表者情報"
      }
    },
    "reservation_email": {
      "letter_block_1": {
        "text_1": "このメールアドレスは配信専用となっております。",
        "text_2": "お問い合わせはこちら▼",
        "text_4": "この度は、保育園留学にお申し込みいただき誠にありがとうございます。",
        "text_5": "予約リクエストを受け付けました。",
        "text_6": "※現時点では予約が確定しておりません。",
        "text_7": "予約の確定は、【予約確定】のメールにてご連絡させていただきます。",
        "text_8": "登園されるお子さまの年齢や受け入れ先の状況により、",
        "text_9": "ご案内できない場合がございますので予めご了承ください。"
      },
      "letter_block_2": {
        "text_1": "【予約リクエスト内容】",
        "text_2": "プラン名：%{name}",
        "text_3": "滞在開始日：%{start_date}",
        "text_4": "滞在終了日：%{end_date}",
        "text_5": "代表者名：%{representative_name}",
        "text_6": "合計金額：￥%{total_fee}"
      },
      "letter_block_3": {
        "text_1": "これより、予約内容を受け入れ先宿泊施設と園に確認し、最終調整をさせていただきます。",
        "text_10": "※アカウント登録の本人確認が完了されていない方は、別途お送りしているメールで本人確認を完了してください。",
        "text_11": "ログインURL. %{login_url}",
        "text_12": "【キャンセル・変更について】",
        "text_13": "ご予約後にお客様のご都合によりキャンセルする場合には、キャンセル料を申し受けます。",
        "text_14": "プログラムの内容により適用されるキャンセルポリシーが異なります。詳しくは<a href=\"https://hoikuen-ryugaku.com/cancel-policy\">キャンセルポリシー</a>をご確認ください",
        "text_15": "保育園留学が、お子様やご家族皆様にとって素敵な体験になることを心より願っております。",
        "text_2": "予約の可否につきましては、5営業日前後でご登録のメールアドレスへご連絡いたします。",
        "text_3": "恐れ入りますが今しばらくお待ちください。",
        "text_4": "※園の先生方の負担を減らし保育に時間をかけられるよう、",
        "text_5": "まとめて確認いただいておりますので、結果のお知らせが5営業日を超える場合がありますが",
        "text_6": "何卒ご了承ください。",
        "text_7": "【マイページについて】",
        "text_8": "お客様のアカウントにログインしていただくと、マイページから予約内容をご確認いただけます。",
        "text_9": "予約リクエストが承認されましたら、マイページのやることリストから必要な手続きをご確認いただけます。"
      },
      "letter_block_4": {
        "text_1": "保育園留学・小学生留学 運営事務局",
        "text_2": "HP. %{hoikuen_ryugaku_url}",
        "text_3": "mail. %{support_email}",
        "text_4": "※返信には3-4営業日いただく場合がございます（土日祝除く）",
        "text_5": "運営会社：株式会社キッチハイク",
        "text_6": "北海道檜山郡厚沢部町上里92-1",
        "text_8": "一緒に働く仲間を募集しています",
        "text_9": "https://kitchhike.jp/recruit"
      }
    },
    "reservation_input": {
      "accordion": {
        "icon_message": "項目に不備があります",
        "icon_message_missing": "未入力の項目があります",
        "message_no_selected": "選択なし",
        "message_not_input": "未入力"
      },
      "children_info": {
        "allergy": {
          "allergenic_foods": {
            "beans_grains_nuts": "豆・穀・種実類",
            "buckwheat": "そば",
            "crab": "カニ",
            "default": null,
            "egg": "卵",
            "fruits": "果物",
            "meat_fish": "肉・魚",
            "milk": "牛乳・乳製品",
            "other": "その他",
            "peanut": "ピーナッツ",
            "shellfish": "甲殻類",
            "shrimp": "エビ",
            "soybean": "大豆",
            "title": "アレルギーの原因となる食品",
            "validation_title": "アレルギーの原因となる食品",
            "walnut": "くるみ",
            "wheat": "小麦"
          },
          "allergy_causes": {
            "default": null,
            "title": "アレルギーの原因となるもの",
            "validation_title": "アレルギーの原因となるもの"
          },
          "allergy_elimination": {
            "default": "選択してください",
            "no_answer": "いいえ",
            "title": "留学先で除去食の対応を希望しますか",
            "validation_title": "留学先で除去食の対応",
            "yes_answer": "はい"
          },
          "anaphylaxis": {
            "default": "選択してください",
            "no_answer": "ない",
            "title": "アナフィラキシーを起こしたことがありますか",
            "validation_title": "アナフィラキシーの有無",
            "yes_answer": "ある"
          },
          "availability": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "食物アレルギーはありますか",
            "validation_title": "食物アレルギーの有無",
            "yes_answer": "有"
          },
          "elimination_level": {
            "complete": "完全除去 ｜ その食材は使わない（微量混入は許容）",
            "conditional": "条件許容 ｜ 加熱・加工された形なら食べられる",
            "default": "選択してください",
            "legacy_no": "除去食の対応希望なし",
            "legacy_yes": "除去食の対応希望",
            "strict": "厳密除去 ｜ だし・エキスや微量の混入も不可",
            "title": "除去レベル",
            "validation_title": "除去レベル"
          },
          "epipen": {
            "default": "選択してください",
            "have": "所持している（園・学校での対応要）",
            "not_have": "所持していない",
            "title": "エピペンを所持していますか",
            "validation_title": "エピペンの所持"
          },
          "foodrequest": {
            "default": null,
            "title": "食事についてスペシャルリクエスト",
            "validation_title": "食事についてスペシャルリクエスト"
          },
          "foodrequest_yes_or_no": {
            "default": "選択してください",
            "description": "体質や医師の診断による食の制限は「既往歴」の項目に記入してください。ここでは宗教・思想・食習慣による制限のみ確認します。",
            "no_answer": "無",
            "title": "食事に関して、宗教上の理由、またはプラントベースの食生活(ベジタリアンなど)に関する特別な配慮が必要ですか",
            "validation_title": "食事に関して、宗教上の理由、またはプラントベースの食生活(ベジタリアンなど)に関する特別な配慮の有無",
            "yes_answer": "有"
          },
          "guardian_visit": {
            "can_visit": "保護者が園・学校に来て服薬対応できる",
            "cannot_visit": "保護者が来ることは難しい",
            "default": "選択してください",
            "description": "園・学校によっては、スタッフによる服薬対応ができない場合があります。受け入れ可否の確認時に個別にご案内します。",
            "title": "保護者の来園・来校対応について",
            "validation_title": "保護者の来園・来校対応"
          },
          "legacy_title": "アレルギー情報",
          "medication": {
            "default": "選択してください",
            "not_required": "不要",
            "required": "必要（抗ヒスタミン薬など）",
            "title": "服薬が必要ですか",
            "validation_title": "服薬の要否"
          },
          "nonfood_allergies": {
            "default": "選択してください",
            "description": "花粉・軽い鼻炎などの軽症は記入不要です。園・学校での活動に影響するものや、緊急対応が必要なものを記入してください。",
            "no_answer": "無",
            "title": "食物以外のアレルギーはありますか",
            "validation_title": "食物以外のアレルギーの有無",
            "yes_answer": "有"
          },
          "other_food_name": {
            "default": null,
            "title": "その他の場合、食材を記入してください",
            "validation_title": "その他食材"
          },
          "question1": {
            "confirmation": "確認しました",
            "title": "除去食の対応・その他特別な対応が必要となる場合は、必ず面談時に先生へ直接相談し、各施設の必要な手続きを行ってください。なお、対応の可否や対応レベルは各施設によって異なりますので、予めご了承ください。",
            "validation_title": "チェックボックス"
          },
          "severity": {
            "default": "選択してください",
            "mild": "軽度（皮膚症状のみ）",
            "moderate": "中度（複数症状あり）",
            "severe": "重度（アナフィラキシー歴あり）",
            "title": "重症度",
            "validation_title": "重症度"
          },
          "symptoms": {
            "default": null,
            "description": "アレルギーの程度や配慮が必要なこと、またアナフィラキシー症状、服薬がある場合もこちらに必ずご記入ください。",
            "title": "アレルギーの症状・詳細",
            "validation_title": "アレルギーの症状・詳細"
          },
          "title": "アレルギー情報"
        },
        "base": {
          "title": "基本情報"
        },
        "development": {
          "concerns": {
            "attention": "注意の持続・多動傾向",
            "communication": "言葉の理解・コミュニケーション",
            "group_rules": "集団の中での過ごし方・ルール",
            "instruction": "一斉指示への反応・理解",
            "motor": "手先の操作・身体の動かし方",
            "sensory": "感覚の過敏・鈍麻",
            "title": "気になっていること",
            "transition": "活動の切り替え・かんしゃく",
            "validation_title": "気になっていること"
          },
          "current_support": {
            "default": "選択してください",
            "none": "特別なサポートは受けていない",
            "not_attending": "園・学校に通っていない",
            "teacher_care": "担任が個別配慮している（加配なし）",
            "title": "現在の園・学校での対応状況",
            "validation_title": "現在の園・学校での対応状況",
            "with_aide": "加配・支援員がついている"
          },
          "description": "診断の有無にかかわらず、気になることがあれば安心してお知らせください。受け入れ先の先生が事前に準備するための質問です。",
          "professional_support": {
            "default": "選択してください",
            "not_using": "利用していない",
            "title": "専門機関の利用状況",
            "using": "利用している（療育・医療機関）",
            "validation_title": "専門機関の利用状況"
          },
          "title": "発達・集団生活について"
        },
        "diet": {
          "elimination_level": {
            "title": "除去レベル",
            "validation_title": "除去レベル"
          },
          "other_text": {
            "title": "その他の場合、内容を記入してください",
            "validation_title": "その他の内容"
          },
          "title": "食の制限（宗教・思想・食習慣）",
          "types": {
            "halal": "ハラール",
            "kosher": "コーシャ",
            "other": "その他",
            "pescatarian": "ペスカタリアン",
            "title": "制限の種類",
            "validation_title": "制限の種類",
            "vegan": "ヴィーガン",
            "vegetarian": "ベジタリアン"
          }
        },
        "enrollment_school": {
          "school_name": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "在籍している学校名",
            "validation_title": "在籍している学校名",
            "yes_answer": "有"
          },
          "school_type": {
            "default": "選択してください",
            "national": "国立",
            "private": "私立",
            "public": "公立",
            "title": "在籍学校の種類",
            "validation_title": "在籍学校の種類"
          },
          "title": "在籍学校について"
        },
        "gender": {
          "female": "女性",
          "male": "男性",
          "other": "その他"
        },
        "life_habit": {
          "developmentaldisorder": {
            "concern": "診断はないが気になる点がある",
            "default": "選択してください",
            "diagnosed": "診断を受けたことがある",
            "no_answer": "無",
            "none": "特になし",
            "title": "今までに発達障がいと診断されたことはありますか",
            "validation_title": "発達障がいの診断歴の有無",
            "yes_answer": "有"
          },
          "diagnosis": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "診断名",
            "validation_title": "診断名",
            "yes_answer": "有"
          },
          "language": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "お子さまの使用言語",
            "validation_title": "お子さまの使用言語",
            "yes_answer": "有"
          },
          "medical_history": {
            "default": "選択してください",
            "description": "※例：熱性痙攣・肘内障・てんかん・喘息・川崎病・入院手術歴の有無など",
            "no_answer": "無",
            "title": "これまでに経験した病気や手術、怪我、治療歴がありますか",
            "validation_title": "既往歴の有無",
            "yes_answer": "有"
          },
          "medical_history_details": {
            "default": "選択してください",
            "description": "※症状・回数・起こした年齢、現在服薬がある場合はご記入ください（例:熱性痙攣 〇回/時期 〇歳〇か月頃）",
            "no_answer": "無",
            "title": "既往歴の詳細",
            "validation_title": "既往歴の詳細",
            "yes_answer": "有"
          },
          "opportunitynurseryschool": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "今まで、週３日以上の通園経験はありますか",
            "validation_title": "過去3日以上の通園経験の有無",
            "yes_answer": "有"
          },
          "things_that_need_attention": {
            "title": "発達の遅れや集団生活を送る上で配慮が必要なこと",
            "validation_title": "発達の遅れや集団生活を送る上で配慮が必要なこと"
          },
          "title": "生活習慣・健康状態"
        },
        "medical": {
          "condition_name": {
            "placeholder": "例：熱性痙攣、肘内障、気管支喘息 など",
            "title": "病名・状態名",
            "validation_title": "病名・状態名"
          },
          "current_status": {
            "default": "選択してください",
            "observing": "経過観察中",
            "remission": "寛解・完治",
            "title": "現在の状態",
            "treating": "治療中・服薬中",
            "validation_title": "現在の状態"
          },
          "support_level": {
            "daily": "毎日対応が必要（服薬管理・日常ケア等）",
            "default": "選択してください",
            "on_symptom": "症状が出たときのみ対応が必要",
            "share_only": "情報共有のみ（特別な対応は不要）",
            "title": "園・学校での対応レベル",
            "validation_title": "園・学校での対応レベル"
          },
          "title": "既往歴・健康状態"
        },
        "nonfood": {
          "causes": {
            "animal": "動物",
            "house_dust": "ハウスダスト",
            "insect": "昆虫",
            "medicine": "薬剤",
            "metal": "金属",
            "other": "その他",
            "pollen": "花粉",
            "sunlight": "日光",
            "title": "原因",
            "validation_title": "原因"
          },
          "epipen": {
            "default": "選択してください",
            "have": "所持している（園・学校での対応要）",
            "not_have": "所持していない",
            "title": "エピペンを所持していますか",
            "validation_title": "エピペンの所持"
          },
          "other_text": {
            "title": "その他の場合、内容を記入してください",
            "validation_title": "その他の内容"
          },
          "precautions": {
            "title": "園・学校での活動で避けてほしいこと・対応してほしいこと",
            "validation_title": "避けてほしいこと・対応してほしいこと"
          },
          "severity": {
            "default": "選択してください",
            "mild": "軽度（情報共有のみ・対応不要）",
            "moderate": "中度（活動制限が必要）",
            "severe": "重度（アナフィラキシー歴あり）",
            "title": "重症度",
            "validation_title": "重症度"
          },
          "title": "食物以外のアレルギー"
        },
        "planned_participation": {
          "default": "選択してください",
          "elementary_school": "小学生留学",
          "nursery_school": "保育園留学",
          "title": "留学の種類",
          "validation_title": "留学の種類"
        },
        "pledge": {
          "acceptance_and_liability": "受け入れの可否判断、責任の帰属、および損害補償に関する上記の内容を理解し、同意します",
          "agreed": "同意済み",
          "declaration_is_true": "申告した内容はすべて事実であり、重要な情報を意図的に省略していないことを誓約します",
          "description": "受け入れの可否は、ご申告いただいた内容をもとに各園・学校が判断します。予約リクエストの承認後であっても、申告内容と実際の状況が異なる場合や、安全な受け入れが難しいと判断された場合には、受け入れをお断りすることがあります。",
          "error": "確認事項と誓約のすべてに同意してください。",
          "notify_on_change": "申告内容に変更が生じた場合、変更が発生した時点で速やかに運営事務局へ連絡することに同意します",
          "title": "確認事項と誓約",
          "validation_title": "確認事項と誓約"
        },
        "yes_no": {
          "no_label": "ない",
          "yes_label": "ある"
        }
      },
      "heading": "予約内容の入力",
      "holiday_alert": "選択された日程に祝日が含まれています。祝日は留学施設が休みとなりますので、予めご了承ください。",
      "modal": {
        "breakdown": {
          "adult_rate": "大人料金（税込・合計）※中学生以上",
          "basic_price": "基本料金",
          "child_rate": "子ども料金（税込・合計）",
          "elementary_aboard": "小学生留学：",
          "not_and_elementary": "留学なし（小学生）：",
          "not_and_toddler": "留学なし（未就学児）：",
          "nursery_aboard": "保育園留学：",
          "option_price": "オプション料金（税込）",
          "plan_price": "プラン料金（税込）",
          "price_number": "￥%{unit_price} × %{number}",
          "promotion": "プロモーション割引",
          "title": "料金の内訳",
          "total": "料金合計（税込）"
        },
        "close": "閉じる",
        "error": {
          "body": "この日程でのご予約を進めるためには、先のご予約の変更やキャンセルが必要です。詳しい手続きについては、ヘルプデスクにお問い合わせください。",
          "button": "問い合わせる",
          "title": "日程が重複しています"
        },
        "overlap_error": {
          "button": "戻る",
          "message": "同じ期間（%{start_date}〜%{end_date}）にすでに予約があります。重複する予約はできません。",
          "title": "予約重複エラー"
        },
        "plan_detail": {
          "accommodation": {
            "title": "宿泊施設",
            "type": "宿タイプ：%{type}"
          },
          "adult": "大人%{count}人、",
          "child": "子ども%{count}人",
          "people": "人数：",
          "period": "留学期間：%{start_date}〜%{end_date}",
          "preschool": {
            "eligibility": "受入条件：%{eligibility}",
            "title": "留学施設"
          },
          "preschoolers": "保育園留学%{count}人",
          "preschoolers_1": "留学なし（未就学児）%{count}人",
          "students": "小学生留学%{count}人",
          "students_1": "留学なし（小学生）%{count}人",
          "title": "プラン内容"
        }
      },
      "option_select": {
        "close": "閉じる",
        "label": "オプション説明",
        "notes": "オプションの詳細についてはオプション説明を確認してください。",
        "title": "オプション選択（任意）"
      },
      "price": {
        "breakdown": "内訳",
        "button": "確認へすすむ",
        "total": "料金合計"
      },
      "representative": {
        "account": {
          "account_notes_1": "予約リクエストが完了すると本人確認メールが届きます。",
          "account_notes_2": "確認完了後、マイページへのログイン用アカウントが作成されます。",
          "login": "ログインする",
          "login_link": "＞アカウントをお持ちの方はこちら",
          "login_title": "ログイン",
          "password": "パスワード",
          "password_confirmation": "パスワード（確認用）",
          "password_description": "パスワードは半角8文字以上で、小文字、数字をそれぞれ1文字以上含む必要があります。記号も使用できます（スペースを除く）。",
          "reset_password": "パスワードを忘れた方はこちら",
          "title": "アカウント情報"
        },
        "address": {
          "building": "建物名など（任意）",
          "city_town_village": "市町村",
          "country": "国名",
          "email": "メールアドレス",
          "email_notes_1": "本人確認メールが",
          "email_notes_2": "から届きます。携帯メールアドレスの場合は受信許可設定をお願いします。",
          "from_email": "no-reply@kitchhike.com",
          "phone_notes_1": "ハイフン（-）を入れず、数字のみで入力してください。　(例：123-456-7890 → 1234567890)",
          "phone_number": "電話番号",
          "postal_code": "郵便番号",
          "postal_code_notes_1": "ハイフン（-）を入れず、数字のみで入力してください。　(例：123-4567 → 1234567)",
          "prefecture": "都道府県",
          "prefecture_default": "都道府県を選択",
          "street_address": "町域・番地",
          "title": "住所"
        },
        "date_of_birth": "生年月日",
        "first_name": "名（ふりがな）",
        "first_name_cn": "名（漢字）",
        "gender": {
          "female": "女性",
          "male": "男性",
          "other": "その他",
          "title": "性別"
        },
        "last_name": "姓（ふりがな）",
        "last_name_cn": "姓（漢字）",
        "relationship": {
          "brother_sister": "兄弟/姉妹",
          "default": "続柄を選択",
          "father": "父親",
          "grand_father": "祖父",
          "grand_mother": "祖母",
          "mother": "母親",
          "other": "その他",
          "other_text": "「その他」を選択した場合はご記入ください",
          "other_text_label": "その他の続柄の詳細",
          "title": "留学する子どもとの続柄"
        },
        "sub_title": "基本情報",
        "title": "代表者情報"
      }
    },
    "reservation_lp": {
      "application_controller": {
        "invalid_preview_url": "プレビューURLが正しくありません。URLに間違いがないかをお確かめください。"
      },
      "price": {
        "adults_number": "大人%{count}名",
        "children_number": "子ども%{count}名"
      }
    },
    "reservation_mailer": {
      "reservation_email": {
        "from": "保育園留学・小学生留学 運営事務局 <no-reply@kitchhike.com>",
        "subject": "予約リクエストありがとうございます【保育園留学・小学生留学 運営事務局】"
      }
    },
    "reset_password_mailer": {
      "from": "保育園留学・小学生留学 運営事務局 <no-reply@kitchhike.com>",
      "subject": "パスワードの変更を受け付けました【保育園留学・小学生留学 運営事務局】"
    },
    "review": {
      "posted_date": "投稿日：%{date}",
      "usage_count": "%{count}回目の留学"
    },
    "review_index": {
      "activity_details": "体験の詳細",
      "back_path": "もどる",
      "children_age_text": "年齢",
      "empty": "ご家族の声は見つかりません。",
      "experienced_activities": "園で体験した活動",
      "guest_house": "宿泊",
      "message_locals": "%{municipality}の皆さんへのメッセージ",
      "message_preschool": "保育士先生へのメッセージ",
      "number_of_people": {
        "adult": "おとな%{count}人",
        "child": "こども%{count}人",
        "title": "人数",
        "total": "%{count}人"
      },
      "nursery": "場所",
      "read_more": "続きを読む",
      "stay_days": {
        "content": "%{count}週間（%{date}から）",
        "title": "期間"
      }
    },
    "search": {
      "sections": {
        "accommodation": {
          "id": "accommodation",
          "label": "宿泊施設のこだわり",
          "tags": {
            "bathroom_bathtub": {
              "key": "bathroom",
              "label": "バスタブあり",
              "value": "バスタブあり"
            },
            "bedroom_futon": {
              "key": "bedroom",
              "label": "布団あり",
              "value": "布団"
            },
            "kitchen_private": {
              "key": "kitchen",
              "label": "専用キッチンあり",
              "value": "専用キッチン"
            },
            "laundry_dryer": {
              "key": "laundry",
              "label": "洗濯乾燥機あり",
              "value": "洗濯乾燥機"
            },
            "laundry_machine": {
              "key": "laundry",
              "label": "洗濯機あり",
              "value": "洗濯機"
            },
            "meal_service_breakfast": {
              "key": "meal_service",
              "label": "朝食付き",
              "value": "朝食のみ"
            },
            "meal_service_breakfast_dinner": {
              "key": "meal_service",
              "label": "朝夕食付き",
              "value": "朝食/夕食"
            },
            "room_environment_monitor": {
              "key": "room_environment",
              "label": "モニター貸出あり",
              "value": "モニター貸与"
            },
            "room_environment_pet": {
              "key": "room_environment",
              "label": "ペット可",
              "value": "ペット可"
            },
            "room_type_whole": {
              "key": "room_type",
              "label": "一棟貸し",
              "value": "一棟貸し"
            }
          }
        },
        "area": {
          "id": "area",
          "label": "エリア",
          "tags": {
            "category_chugoku": {
              "key": "category_name",
              "label": "中国・四国",
              "value": "中国・四国"
            },
            "category_hokkaido": {
              "key": "category_name",
              "label": "北海道",
              "value": "北海道"
            },
            "category_hokuriku": {
              "key": "category_name",
              "label": "北陸・甲信越",
              "value": "北陸・甲信越"
            },
            "category_kanto": {
              "key": "category_name",
              "label": "関東",
              "value": "関東"
            },
            "category_kyushu": {
              "key": "category_name",
              "label": "九州・沖縄",
              "value": "九州・沖縄"
            },
            "category_tohoku": {
              "key": "category_name",
              "label": "東北",
              "value": "東北"
            },
            "category_tokai": {
              "key": "category_name",
              "label": "東海・近畿",
              "value": "東海・近畿"
            }
          }
        },
        "budget": {
          "id": "budget",
          "label": "予算",
          "tags": {
            "budget_150k": {
              "key": "budget",
              "label": "15万円以下の留学先",
              "value": "15万円以下の留学先"
            },
            "budget_200k": {
              "key": "budget",
              "label": "20万円以下の留学先",
              "value": "20万円以下の留学先"
            }
          }
        },
        "child": {
          "id": "child",
          "label": "お子さまの情報",
          "tags": {
            "allergies": {
              "key": "allergies",
              "label": "アレルギーあり",
              "value": "可"
            },
            "developmental_anxiety": {
              "key": "developmental_anxiety",
              "label": "特性あり・発達不安あり",
              "value": "受入OK"
            },
            "entry_requirements": {
              "key": "entry_requirements",
              "label": "登園経験なし",
              "value": "可"
            }
          }
        },
        "experience": {
          "alwaysOpen": true,
          "id": "experience",
          "label": "体験のテーマ",
          "tags": {
            "feature_development": {
              "key": "feature",
              "label": "療育プログラムあり",
              "value": "発達支援"
            },
            "feature_different_age": {
              "key": "feature",
              "label": "異年齢保育",
              "value": "異年齢保育"
            },
            "feature_english": {
              "key": "feature",
              "label": "英語教育あり（週1回以上）",
              "value": "英語教育"
            },
            "feature_forest": {
              "key": "feature",
              "label": "森遊び",
              "value": "森遊び"
            },
            "feature_harvest": {
              "key": "feature",
              "label": "収穫体験ができる",
              "value": "収穫体験"
            },
            "feature_mud": {
              "key": "feature",
              "label": "泥遊び",
              "value": "泥遊び"
            },
            "feature_sea": {
              "key": "feature",
              "label": "海遊び",
              "value": "海遊び"
            },
            "feature_snow": {
              "key": "feature",
              "label": "雪遊び",
              "value": "雪遊び"
            },
            "service_type_both": {
              "key": "service_type",
              "label": "小学生留学と保育園留学",
              "value": "小学生留学と保育園留学"
            },
            "service_type_elementary": {
              "key": "service_type",
              "label": "小学生留学",
              "value": "小学生留学"
            },
            "short_stay_program_3n4d": {
              "key": "short_stay_program",
              "label": "3泊4日プログラムあり",
              "value": "3泊4日"
            }
          }
        },
        "facility": {
          "id": "facility",
          "label": "留学施設の条件",
          "tags": {
            "after_5pm": {
              "key": "after_5pm",
              "label": "17時以降預かりできる",
              "value": "可"
            },
            "feature_bus": {
              "key": "feature",
              "label": "園バスあり",
              "value": "園バス"
            },
            "feature_photo_sharing": {
              "key": "feature",
              "label": "園からの写真共有あり",
              "value": "園から写真共有"
            },
            "room_environment_walking": {
              "key": "room_environment",
              "label": "徒歩登園できる",
              "value": "徒歩登園"
            }
          }
        },
        "life": {
          "id": "life",
          "label": "暮らしの情報",
          "tags": {
            "feature_community": {
              "key": "feature",
              "label": "地域の方・他の留学家族と交流できる",
              "value": "地域交流が充実"
            },
            "feature_historic": {
              "key": "feature",
              "label": "歴史的な街並み",
              "value": "歴史的な街並み"
            },
            "feature_sea_town": {
              "key": "feature",
              "label": "海まち暮らし",
              "value": "海まち暮らし"
            },
            "feature_snow_country": {
              "key": "feature",
              "label": "雪国体験",
              "value": "雪国体験"
            }
          }
        },
        "popular": {
          "alwaysOpen": true,
          "id": "popular",
          "label": "人気の条件",
          "tags": {
            "feature_bus": {
              "key": "feature",
              "label": "園バスあり",
              "value": "園バス"
            },
            "feature_furusato": {
              "key": "privilege",
              "label": "ふるさと納税が使える",
              "value": "ふるさと納税が使える"
            },
            "feature_snow": {
              "key": "feature",
              "label": "雪あそび",
              "value": "雪遊び"
            },
            "no_car": {
              "key": "room_environment",
              "label": "車なしで生活できる",
              "value": "車なしで移動可能"
            },
            "regional_monitor": {
              "key": "privilege",
              "label": "新地域モニター",
              "value": "新地域モニター"
            },
            "room_environment_walking": {
              "key": "room_environment",
              "label": "徒歩登園できる",
              "value": "徒歩登園"
            }
          }
        },
        "privilege": {
          "id": "privilege",
          "label": "優待",
          "tags": {
            "exchange_rental_car": {
              "key": "privilege",
              "label": "留学レンタカー",
              "value": "留学レンタカー"
            },
            "feature_furusato": {
              "key": "privilege",
              "label": "ふるさと納税が使える",
              "value": "ふるさと納税が使える"
            },
            "privilege_regional": {
              "key": "privilege",
              "label": "地域別優待あり",
              "value": "地域別優待あり"
            },
            "regional_monitor": {
              "key": "privilege",
              "label": "新地域モニター",
              "value": "新地域モニター"
            }
          }
        },
        "text_search": {
          "id": "text_search",
          "label": "地域・保育園名で検索"
        },
        "transport": {
          "id": "transport",
          "label": "移動のこだわり",
          "tags": {
            "from_station_1hour": {
              "key": "from_station",
              "label": "最寄りの主要駅や空港から車で1時間以内",
              "value": "車で1時間以内"
            },
            "from_station_20min": {
              "key": "from_station",
              "label": "最寄りの主要駅や空港から車で20分以内",
              "value": "車で20分以内"
            },
            "from_station_walking": {
              "key": "from_station",
              "label": "最寄りの主要駅や空港から徒歩圏内",
              "value": "徒歩圏内"
            },
            "from_tokyo_3hours": {
              "key": "from_tokyo",
              "label": "都内から車3時間以内",
              "value": "車で3時間以内"
            },
            "from_tokyo_shinkansen": {
              "key": "from_tokyo",
              "label": "都内から新幹線でいける",
              "value": "新幹線でいける"
            },
            "room_environment_pickup": {
              "key": "room_environment",
              "label": "最寄りの主要駅や空港から送迎あり",
              "value": "最寄りの主要駅や空港から送迎あり"
            }
          }
        }
      }
    },
    "stripe_3ds_request_update_card": {
      "confirm_box": {
        "body": "決済日（留学初日）の2週間前にクレジットカードの有効性チェックを行い、現在登録頂いているカードで有効性の確認が取れませんでした。\nお手数おかけ致しますが、5日以内に別のカードへの変更をお願いいたします。",
        "button": "クレジットカードを変更する",
        "title": "クレジットカード変更のご依頼"
      },
      "text_1": "いつもありがとうございます。\nクレジットカードの変更をお願いします。",
      "update_done": "クレジットカードの更新が完了しました。"
    },
    "support": {
      "array": {
        "last_word_connector": "、",
        "two_words_connector": "、",
        "words_connector": "、"
      }
    },
    "time": {
      "am": "午前",
      "formats": {
        "default": "%Y/%m/%d %H:%M",
        "long": "%Y/%m/%d %H:%M",
        "month": "%-m月",
        "only_time": "%-H:%M",
        "short": "%m/%d %H:%M",
        "year": "%Y年",
        "year_and_month": "%Y年%-m月",
        "year_and_month_and_day": "%Y年%-m月%-d日"
      },
      "pm": "午後"
    },
    "todo_reminder": {
      "send_one_day_later_reminder": {
        "friends_program": {
          "link_text": "お友だち紹介プログラムの詳細はこちらから",
          "link_url": "https://hoikuen-ryugaku.com/friends",
          "text1": "紹介されたお友だちはお得に留学ができ、 あなたが留学した園には紹介分の支援が届く。\n家族と地域の未来につながるプログラムです。",
          "text2": "留学した後も、先生や地域の方々とのつながりをよりあたため、\n希望の光を一緒に広げるプログラムになることを願っています。",
          "title": "5. お友だち紹介プログラムのご案内"
        },
        "instagram_program": {
          "link_text": "参加申し込みフォームはこちらから",
          "link_url": "https://forms.gle/J2w2kP9Zdv4MFypW6",
          "text1": "留学されたご家族だけにご案内している、非公開のInstagramアカウントです。",
          "text2": "こちらでは、地域の最新ニュース、保育園留学・小学生留学の最新情報、来年度の先行予約など公式アカウントにはない情報もお届けします。",
          "text3": "下記フォームよりお申し込みください。\nフォーム完了画面に非公開アカウントのリンクが表示されます。",
          "text4": "※本アカウントは留学されたご家族限定です。リンクの共有はご遠慮ください。",
          "title": "4. 留学ご家族限定のInstagramアカウント（β版）のご案内"
        },
        "posting_instagram": {
          "discount_code_url": "https://guide.hoikuen-ryugaku.com/code",
          "link_text": "Instagram投稿プログラムの詳細はこちらから",
          "link_url": "https://guide.hoikuen-ryugaku.com/Instagram-post/?realtimePreview=OissyTcAef7iFf9T2V0g",
          "text1": "保育園留学・小学生留学では、「ご家族の想い出」や「お子さまの成長」を大切にしています。",
          "text2": "みなさまの声は、これから参加を検討されるご家族にとって、未来への大きな後押しになります。",
          "text3": "よろしければ、今回の留学の想い出をInstagramでも残してみませんか。",
          "text4": "ご投稿いただいた方には、\n次回の留学でご利用いただける<strong>「1万円分のディスカウントコード」</strong>をお送りします。",
          "text5": "※ディスカウントコードには利用条件がございます。あらかじめご了承ください。",
          "title": "3. Instagramに、”留学の想い出”や”お子さまの成長”を残す"
        },
        "posting_review": {
          "discount_code_url": "https://guide.hoikuen-ryugaku.com/code",
          "link_text": "アンケート回答はこちらから",
          "text1": "園の先生方や地域のみなさまへのメッセージ、\nそして今回の留学で感じたことを、ぜひお聞かせください。",
          "text2": "みなさまからいただくお声をもとに、\n留学が地域とご家族の新たなつながりを築くきっかけとなるよう、一層取り組んでまいります。",
          "text3": "アンケートにご回答いただいた方には、\n次回の留学でご利用いただける<strong>「1万円分のディスカウントコード」</strong>をお送りします。",
          "text4": "※ディスカウントコードには利用条件がございます。あらかじめご了承ください。",
          "title": "1. 留学のご感想、園や地域の方へメッセージを届ける"
        },
        "ryugaku_album": {
          "link_text": "保育園留学アルバムの詳細はこちらから",
          "link_url": "https://hoikuen-ryugaku.com/item/album",
          "text1": "スマホに眠っている、保育園留学でのたくさんの素敵な写真たち。",
          "text2": "「形に残したいけれど、自分でアルバムを作るのは少し面倒…」",
          "text3": "そんな方にぴったりのサービスをご用意しました。",
          "text4": "面倒なレイアウトや入稿作業は一切不要。",
          "text5": "専用フォルダに写真をアップロードするだけで、保育園留学オリジナルデザインのフォトアルバムをご自宅にお届けします。",
          "title": "2. 留学先で撮った写真を世界で１冊のアルバムに"
        },
        "subject": "【保育園留学・小学生留学｜ご参加のお礼】想い出を未来につなぐ4つの特典・プログラムのご案内",
        "text1": "こんにちは。保育園留学・小学生留学運営事務局です。\n\nこの度は、保育園留学・小学生留学にご参加いただき、誠にありがとうございました。",
        "text2": "留学先で過ごした日々が、お子さまをはじめご家族にとってかけがえのない経験となり、\n地域のみなさんとの新たなつながりが生まれたことを、心より嬉しく思っております。",
        "text3": "本日は、<strong>留学されたご家族に”想い出を未来につなぐ” 4つの特典・プログラム</strong>をご案内いたします。",
        "text4": "どちらも数分でご参加いただけるものですので、ぜひご活用ください。",
        "text5": "これからも子育て世代がより人生を謳歌でき、\n素晴らしい地域がこれからも持続していく未来を目指して、今後とも尽力してまいります。",
        "text6": "改めて、この度のご参加に心からの感謝を申し上げます。\nどうぞこれからも、よろしくお願いいたします。"
      },
      "three_days_before_reminder": {
        "link": "やることリストを確認する",
        "subject": "期日が近づいているやることリストがあります【保育園留学・小学生留学 運営事務局】",
        "text1": "こんにちは。保育園留学運営事務局です。\nご滞在の準備は順調でしょうか？\nマイページのやることリストに、期日が近づいている項目があります。",
        "text2": "◾️期日が近づいている項目",
        "text3": "お忘れのないようご対応をお願いいたします。",
        "text4": "ご不明な点やサポートが必要な場合は、保育園留学運営事務局へお問い合わせください。",
        "text5": "よろしくお願いいたします。",
        "time_limit": "期日：%{time_limit}"
      },
      "time_limit_reminder": {
        "subject": "やることリストの期日が過ぎています【保育園留学・小学生留学 運営事務局】",
        "text1": "こんにちは。保育園留学運営事務局です。\n先日ご案内したやることリストの項目の期日が過ぎておりますが、まだ完了していないようです。",
        "text2": "◾️未完了の項目",
        "text3": "お手続きが完了していないと、次のステップに進むことができず、ご滞在の準備にも影響が出る可能性がありますので、\nお早めにマイページにてご確認の上、ご対応をお願いいたします。"
      }
    },
    "top": {
      "component": {
        "minimum_price": "￥%{minimum_price}〜",
        "people": "大人2名・子ども1名"
      },
      "empty": {
        "text_1": "お探しの条件に当てはまる留学先は見つかりません。",
        "text_2": "条件を変更してお探しください。"
      },
      "filtering": {
        "area": {
          "title": "留学先のエリア"
        },
        "button": {
          "apply": "適用する",
          "clear": "クリア"
        },
        "class": {
          "age": {
            "age_text": "%{age}歳児",
            "asterisk": "（※）",
            "birth_period": "%{start_date}〜%{end_date}",
            "birth_period_header": "生年月日",
            "caution": "（※）0歳は月齢によって受け入れできる地域が異なります。地域の詳細ページでご確認ください。",
            "class_header": "クラス",
            "label": "クラス年齢表",
            "notes": "以下の表から、お子様のクラスをご確認ください。",
            "period": "・留学時期：%{start}年4月1日〜%{end}年3月31日",
            "year": "【%{year}年度】"
          }
        },
        "content": {
          "count": "しぼりこみ結果：%{count}件",
          "title": "留学先一覧"
        },
        "criteria": "しぼりこみ条件：",
        "title": "しぼりこみ"
      },
      "heading": "予約可能な留学先",
      "modal_search": {
        "class": {
          "0_year_old_class": "0歳児クラス",
          "1_year_old_class": "1歳児クラス",
          "2_years_old_class": "2歳児クラス",
          "3_years_old_class": "3歳児クラス",
          "4_years_old_class": "4歳児クラス",
          "5_years_old_class": "5歳児クラス",
          "no_attendance": "登園なし"
        },
        "default_placeholder": "年齢・期間で検索",
        "header": "検索機能",
        "local_transportation": {
          "option_1": "車なしで移動可能",
          "title": "現地での移動手段",
          "value": "車なしで移動可能"
        },
        "month": "月",
        "month_number_from": "ヶ月〜",
        "plan_month": {
          "title": "予定している月を選択してください(最大3つまで)"
        },
        "region": {
          "title": "地域"
        },
        "search_region": {
          "chugoku_shikoku": "中国・四国",
          "hokkaido": "北海道",
          "hokuriku_koshinetsu": "北陸・甲信越",
          "kanto": "関東",
          "kyushu_okinawa": "九州・沖縄",
          "tohoku": "東北",
          "tokai_kinki": "東海・近畿"
        },
        "search_text": {
          "placeholder": "地域・保育園名で検索"
        },
        "stay_day": {
          "subtitle": "滞在期間を選択してください",
          "title": "日程"
        },
        "stay_period": "滞在期間",
        "title": "しぼりこみ",
        "value": {
          "0_year_old_class": "0歳児",
          "1_year_old_class": "1歳児",
          "2_years_old_class": "2歳児",
          "3_years_old_class": "3歳児",
          "4_years_old_class": "4歳児",
          "5_years_old_class": "5歳児"
        },
        "week": "週間",
        "within_a_week": "1週間未満",
        "year": " 年"
      },
      "subheading": "予約可能な留学先を表示しています。"
    },
    "update_card_email": {
      "body": "%{representative_name} さま\n\nいつも保育園留学をご利用いただき、ありがとうございます。\n滞在開始日の2週間前に実施しているご登録のクレジットカードの有効性チェックを行いましたが、\n承認が得られませんでした。\n\nお手数をおかけして申し訳ございませんが、\nクレジットカードのご利用状況をお確かめのうえ、\n下記のURLよりクレジットカード情報のご変更・更新をお願いいたします。\n\n▼ クレジットカード情報の更新はこちら\n%{update_card_url}\n\n主な原因として、以下の可能性が考えられます。\n・クレジットカードの有効期限が切れている\n・利用限度額を超えている\n・カード会社のセキュリティ設定により承認されなかった\n詳しい理由については、ご利用のカード発行会社へお問い合わせください。\n\nご対応いただけない場合、\nサービスのご提供が難しくなる可能性がございますので、お早めのご対応をお願いいたします。\nご不明な点やサポートが必要な場合は、\n保育園留学運営事務局へお問い合わせください。\nよろしくお願いいたします。\n━━━━━━━━━━━━━━━━━━━\n保育園留学・小学生留学 運営事務局\nHP. %{hoikuen_ryugaku_url}\nmail. %{support_email}\n※返信には3-4営業日いただく場合がございます（土日祝除く）\n───────────────────\n運営会社：株式会社キッチハイク\n北海道檜山郡厚沢部町上里92-1\n%{kitchhike_url}\n━━━━━━━━━━━━━━━━━━━",
      "subject": "※重要　クレジットカードの承認エラーについて【保育園留学・小学生留学 運営事務局】"
    },
    "url": {
      "cancel_policy": "https://hoikuen-ryugaku.com/cancel-policy",
      "conditions": "https://hoikuen-ryugaku.com/jokensho",
      "inquiries": "mailto:support@hoikuen-ryugaku.zendesk.com",
      "privacy_policy": "https://kitchhike.jp/privacy_policy",
      "stipulation": "https://hoikuen-ryugaku.com/stipulation",
      "terms_of_use": "https://hoikuen-ryugaku.com/terms-of-use",
      "travel_deal_details": "https://hoikuen-ryugaku.com/travel-deal-details"
    },
    "views": {
      "admin": {
        "address": "住所",
        "basic_information": "基本情報",
        "billing_information": "請求情報",
        "birth_date": "生年月日",
        "check_in_time": "宿泊施設への到着予定時刻",
        "children_information": "留学する子どもの情報",
        "contact_information": "連絡先",
        "emergency_contact_during_stay": "緊急連絡先",
        "exercise_section": "その他(0~1歳の場合のみ)",
        "family_confirmation": "家族情報の入力",
        "family_information": "一緒に滞在する方",
        "full_name": "姓名（漢字）",
        "full_name_reading": "姓名（ふりがな）",
        "gender": "性別",
        "interview_question": "取材・アンケート",
        "living_conditions": "生活習慣・健康状態",
        "meal_and_allergy_information": "食事・アレルギー情報",
        "money_unit": "円",
        "no_input": "未入力",
        "nurseries": {
          "belongings": {
            "common_title": "全クラス共通の持ち物",
            "infant_title": "0〜2歳児クラスの持ち物",
            "toddler_title": "3〜5歳児クラスの持ち物"
          },
          "feature": [
            "海遊び",
            "森遊び",
            "泥遊び",
            "雪遊び",
            "動物",
            "食育",
            "Farm体験",
            "英語教育",
            "発達支援",
            "留学レンタカー",
            "園から写真共有",
            "地域交流が充実",
            "歴史的な街並み",
            "English available",
            "プランナーおすすめ",
            "Top Picks",
            "異年齢保育",
            "収穫体験",
            "園バス",
            "海まち暮らし",
            "雪国体験",
            "Heritage",
            "Elementary OK"
          ],
          "gradual_entry_age": [
            "0歳児",
            "1歳児",
            "2歳児",
            "3歳児",
            "4歳児",
            "5歳児"
          ],
          "hints": {
            "condition_match_confirmation_possibility": "「不要」にすると、予約リクエストの時点で配慮事項（食物アレルギー・食物以外のアレルギー・食の制限・発達障がい・既往歴）が無いお子さまの予約を、施設での確認なしで「受入OK（条件一致で確認不要）」にします"
          },
          "values": {
            "allergies": {
              "available_bento": "可(弁当持参)",
              "available_exclusion": "可(除去食)",
              "not_accepted": "受入不可",
              "unanswered": "未回答"
            },
            "allergies_en": {
              "available_bento": "Available (bring your own bento)",
              "available_exclusion": "Available (exclusion meals)",
              "not_accepted": "Not Accepted",
              "unanswered": "Not Answered"
            },
            "clothing": [
              "私服",
              "貸出あり（制服・体操服）",
              "その他"
            ],
            "common_belongings": [
              "着替え（上下・下着）",
              "通園バッグ",
              "午睡用布団",
              "掛布団（毛布・バスタオル）",
              "水筒",
              "使い捨てビニール袋",
              "日除け帽子",
              "ハンカチ・タオル",
              "上靴・上履き"
            ],
            "communication_note_array": [
              "連絡帳（園が用意）",
              "連絡帳（家族が用意）",
              "キッズリー",
              "ルクミー",
              "コドモン",
              "その他アプリ",
              "その他",
              "なし（口頭のみ）"
            ],
            "condition_match_confirmation_possibility": {
              "not_required": "不要",
              "required": "必要"
            },
            "developmental_anxiety": {
              "accepted": "受入OK",
              "consultation_required": "要相談",
              "not_accepted": "受入NG"
            },
            "elementary_belongings": [
              "着替え（上下・下着）",
              "水筒",
              "ティッシュ",
              "ハンカチ・タオル",
              "筆記用具",
              "学習ノート",
              "歯ブラシ",
              "コップ",
              "箸・スプーン・フォークセット",
              "通学バッグ"
            ],
            "fever_care_temperature": [
              "37.0",
              "37.5",
              "38.0"
            ],
            "from_tokyo": {
              "car_3hours": "車で3時間以内",
              "car_3hours_and_shinkansen": "車で3時間以内かつ新幹線でいける",
              "shinkansen": "新幹線でいける"
            },
            "generic": {
              "available": "あり",
              "not_available": "なし"
            },
            "gradual_entry": {
              "available": "あり",
              "not_available": "なし",
              "on_nursery": "園の判断により実施する場合あり"
            },
            "infant_belongings": [
              "着替え（上下・下着）",
              "通園バッグ",
              "午睡用布団",
              "掛布団（毛布・バスタオル）",
              "水筒",
              "使い捨てビニール袋",
              "日除け帽子",
              "ハンカチ・タオル",
              "上靴・上履き",
              "おむつ",
              "おしり拭き",
              "食事用エプロン",
              "哺乳瓶",
              "スプーン・フォーク"
            ],
            "lunch": {
              "available": "あり",
              "available_rice": "あり(白米持参)",
              "not_available": "なし(弁当持参)",
              "unanswered": "未回答"
            },
            "lunch_en": {
              "available": "Available",
              "available_rice": "Available (Bring your own rice)",
              "not_available": "Not Available (Bring your own lunch)",
              "unanswered": "Not Answered"
            },
            "medical_history_possibility": {
              "consultation_required": "要相談",
              "impossible": "不可",
              "possible": "可"
            },
            "medication_policy": [
              "対応不可",
              "対応可",
              "対応可（病院処方の薬のみ）"
            ],
            "monitor": {
              "available": "あり",
              "not_available": "なし"
            },
            "nursery_size": [
              "小規模（30人以下）",
              "中規模（31〜50）",
              "標準規模（51〜100）",
              "大規模（101以上）"
            ],
            "photo_share_available": {
              "available": "有",
              "not_available": "無"
            },
            "pickup": {
              "available": "あり",
              "not_available": "なし"
            },
            "published": {
              "published": "公開",
              "unpublished": "非公開"
            },
            "rental_items": [
              "午睡用布団",
              "通園バッグ",
              "掛布団（毛布・バスタオル）",
              "制服",
              "体操服",
              "帽子",
              "上履き",
              "タオル",
              "おしぼり",
              "おむつ",
              "弁当箱",
              "コップ"
            ],
            "school_bus_available": {
              "available": "利用可",
              "not_available": "利用不可"
            },
            "sick_care_policy": [
              "対応不可",
              "対応可"
            ],
            "toddler_belongings": [
              "着替え（上下・下着）",
              "通園バッグ",
              "午睡用布団",
              "掛布団（毛布・バスタオル）",
              "水筒",
              "使い捨てビニール袋",
              "日除け帽子",
              "ハンカチ・タオル",
              "上靴・上履き",
              "歯ブラシ",
              "コップ",
              "箸・スプーン・フォークセット"
            ]
          }
        },
        "occupation": "職業",
        "option": "オプション",
        "people_unit": "人",
        "planner_search": {
          "capacity": {
            "adults": "大人%{count}名 > 上限%{limit}名",
            "children": "こども%{count}名 > 上限%{limit}名",
            "total": "合計%{count}名 > 総定員%{limit}名"
          },
          "close": "閉じる",
          "empty": {
            "heading": "%{date} にチェックインできる空きはありません。",
            "nearest": "近い候補日: %{dates}（いずれも空きはありません）",
            "none": "期間内に候補となるプラン × チェックイン日がありません。期間・地域・条件を見直してください",
            "show_excluded_hint": "「空き0件の園も表示する」を ON にすると、除外された園とその理由を確認できます",
            "wday_separator": "・",
            "wday_suffix": "%{wday}曜",
            "wdays": "候補プランのチェックイン曜日は「%{wdays}」です"
          },
          "equipment_labels": {
            "bedroom": "寝具",
            "kitchen": "キッチン",
            "laundry": "洗濯",
            "pets": "ペット",
            "wifi": "Wi-Fi"
          },
          "filter": {
            "add_row": "行を追加",
            "adults": "大人",
            "birthday": "生年月日",
            "birthday_note": "入力すると行ごとに年度とクラスを導出します",
            "children": "クラス・人数",
            "children_note": "適用単位: 園ごと。クラスはチェックイン日が属する年度で判定します",
            "class_label": "クラス（学年）",
            "date_range": "チェックイン日の範囲",
            "date_separator": "〜",
            "equipment": "宿の設備",
            "equipment_note": "適用単位: 宿ごと。条件をすべて満たす宿が同一園内に1室以上（AND）",
            "equipment_unset": "未設定 %{count}室（%{ratio}%）",
            "equipment_unset_title": "この項目で絞ると、未設定の %{count}室（全%{total}室の %{ratio}%）は除外されます",
            "features": "園の特徴",
            "features_note": "適用単位: 園ごと。選んだ条件をすべて満たす園（AND）",
            "fiscal_year": "%{year}年度",
            "kids": "こども",
            "location": "地域・園",
            "location_note": "地域・園を指定すると非公開園も候補に含めます（「園非公開」バッジで示します）",
            "mode_birthday": "生年月日で指定",
            "mode_class": "クラスで指定",
            "nursery_count": "%{count}園",
            "nursery_placeholder": "留学施設IDまたは施設名",
            "party_note": "人数は宿の部屋定員（大人上限・こども上限・総定員）の判定に使います",
            "prefecture_all": "都道府県（すべて）",
            "region_note": "地方は選んだもののいずれか（OR）。都道府県も選ぶと両方を満たす園（AND）",
            "remove_row": "この行を削除",
            "reset": "条件リセット",
            "room_count": "%{count}室",
            "room_environments": "園と宿の関係",
            "room_environments_note": "適用単位: 宿ごと。条件をすべて満たす宿が同一園内に1室以上（AND）",
            "scope": "対象",
            "scope_domestic": "国内",
            "scope_jpe": "JPE",
            "set_plan_note": "セットプラン（保育園＋小学生）は生年月日の入力が必要です",
            "show_excluded": "空き0件の園も表示する",
            "stay_day": "滞在期間",
            "stay_day_note": "適用単位: プランごと。選んだ期間のいずれか（OR）",
            "stay_day_options": {
              "14": "2週間",
              "21": "3週間",
              "27": "1ヶ月〜",
              "6": "1週間未満",
              "7": "1週間"
            },
            "submit": "検索",
            "title": "検索条件"
          },
          "flash": {
            "disabled": "このアカウントは利用停止中です。管理者にお問い合わせください。",
            "domain_not_allowed": "この Google アカウントでは利用できません。会社の Google アカウントでログインしてください。",
            "email_unverified": "Google アカウントのメールアドレスが確認済みではありません。",
            "generic_error": "認証に失敗しました。もう一度お試しください。",
            "invalid_response": "認証に失敗しました。もう一度お試しください。",
            "omniauth_failure": "認証に失敗しました。もう一度お試しください。",
            "provisioning_failed": "アカウントの作成に失敗しました。管理者にお問い合わせください。",
            "signed_out": "ログアウトしました。"
          },
          "reason_titles": {
            "accepted_class": "指定したクラスはこの園の受入クラスに含まれません（基本条件由来）。",
            "nursery_class_capacity": "占有期間の %{dates} で留学施設の受入枠が不足しています（クラス別残枠・兄弟制約を含む）。",
            "published": "チェックイン日が非公開です（運営が手動で非公開にした日付）。",
            "room_capacity": "定員超過（%{detail}）",
            "room_deadline": "チェックイン日 %{dates} の予約締切を過ぎています。",
            "room_full": "チェックイン日 %{dates} の宿が予約で埋まっています（残枠0）。",
            "room_no_capacity": "チェックイン日 %{dates} の宿の募集枠が 0 です。",
            "set_plan_birthdays_required": "セットプラン（保育園＋小学生）はクラス指定だけでは判定できません。生年月日を入力してください。",
            "status": {
              "deadline_only": "在庫はありますが締切だけで塞がっています（status = -）。予約締切の手動解除で取れることがあります。",
              "nursery_ng": "滞在期間の %{dates} で留学施設の受入枠が不足しています（受入停止 または 定員0）。",
              "nursery_no_capacity": "留学施設の日別定員が %{dates} に作成されていません。開発者にご連絡ください。",
              "room_full": "滞在期間の %{dates} が予約で埋まっています（残枠0）。",
              "room_no_capacity": "滞在期間の %{dates} に宿の募集枠がありません（0枠）。",
              "status_inconsistent": "在庫スナップショット（status = NG）と現在の在庫・締切・園クラスが食い違っています。再計算が必要です。"
            }
          },
          "reasons": {
            "class_not_accepted": "対象クラス外",
            "deadline_only": "締切のみ（要相談）",
            "deadline_passed": "締切超過",
            "nursery_ng": "受入枠不足",
            "nursery_no_capacity": "定員未作成",
            "room_full": "満枠",
            "room_no_capacity": "在庫なし",
            "room_over_capacity": "定員超過",
            "set_plan_birthdays_required": "生年月日の入力が必要",
            "set_plan_composition": "保育園児と小学生の両方が必要",
            "status_inconsistent": "ステータス不整合（要再計算）",
            "unpublished": "非公開"
          },
          "results": {
            "available_count": "空き %{count}件",
            "excluded_count": "除外 %{count}件",
            "list_separator": "、",
            "loading": "読み込み中…",
            "matching_rooms": "条件を満たす宿: %{rooms}",
            "none": "この条件に合う日程はありません。",
            "nursery_count": "%{count}園",
            "order": "並び: おすすめ順",
            "planner_status_open": "原本を開く",
            "planner_status_source": "プランナー参照用ステータス: 最終取込 %{date}。最新の状態は原本を確認してください",
            "price_estimate_note": "大人%{adults}名・こども%{children}名の概算",
            "price_from": "%{price}〜",
            "refined_limit": "精査の上限（%{max}園）に達したため、これより下位の園は見ていません。地域や期間で絞ってください。",
            "summary": " — 空き %{available}件 / 除外 %{excluded}件（候補 %{candidates}件・精査 %{refined}園）"
          },
          "rows": {
            "available": "空き",
            "check_in_date": "チェックイン日",
            "check_in_dates_link": "CheckInDate 一覧",
            "class_remaining": "残%{remaining}",
            "count_summary": "%{total}件（空き %{available} / 除外 %{excluded}）",
            "derived": "%{birthday} → %{year}年度: %{class_name}",
            "derived_class": "導出クラス",
            "derived_none": "対象外",
            "links": "リンク",
            "lp_full": "LP: 満枠",
            "lp_full_title": "予約はできますが、顧客向け LP では満枠と表示されます。",
            "lp_inquiry": "LP: 問合せ",
            "lp_inquiry_title": "予約はできませんが、顧客向け LP では「問合せ」と表示され、ご家族は問い合わせできます。",
            "lp_open": "LP: ○",
            "lp_open_title": "顧客向け LP では空きとして表示されますが、予約はできません（理由は同じ欄のバッジ）。",
            "lp_unpublished": "LP未公開",
            "lp_unpublished_title": "公開中の LP が無いため、空き日程ページは開けません（404 になります）。",
            "no_limit": "制限なし",
            "nursery_calendar": "園の受入枠カレンダー",
            "plan_hidden": "非公開プラン",
            "plan_hidden_title": "このプランは LP に出ず、プランのページも開けません。",
            "plan_limited": "限定公開プラン",
            "plan_limited_title": "このプランは LP の一覧・検索に出ません（プランのページへの直リンクなら開けます）。",
            "planner_status": "%{year}年度:%{status}",
            "price": "料金",
            "price_unavailable": "-",
            "remaining": "残枠",
            "room": "宿",
            "room_remaining": "宿 残%{remaining}/%{slot}",
            "roomless": "宿泊なし",
            "slug_missing": "URL未設定",
            "slug_missing_title": "留学施設の URL（都道府県 / 市区町村 / 施設）が未設定のため、空き日程ページの URL を生成できません。",
            "status": "状態",
            "stay": "滞在",
            "stay_label": "%{days}日 / %{nights}泊",
            "stay_label_named": "%{name}（%{days}日 / %{nights}泊）",
            "unpublished_domestic": "園非公開（国内）",
            "unpublished_jpe": "園非公開（JPE）"
          },
          "sign_in": {
            "button": "Google でログイン",
            "lead": "会社の Google アカウント（@kitchhike.com）でログインしてください。"
          },
          "sign_out": "ログアウト",
          "title": "Planner Search Beta"
        },
        "primary_contact_information": "代表者情報",
        "reservation_information": "予約情報",
        "rooms": {
          "values": {
            "amenities": [
              "フェイスタオル",
              "バスタオル",
              "シャンプー・コンディショナー",
              "ボディソープ",
              "ハンドソープ",
              "歯ブラシセット",
              "浴衣",
              "化粧水・乳液類",
              "洗濯洗剤",
              "物干しスタンド",
              "ハンガー",
              "ドライヤー"
            ],
            "amenity_supply": [
              "毎日",
              "週1",
              "週2~3",
              "ご自身で対応",
              "フロントへ申し出",
              "なし"
            ],
            "base_room_environment": [
              "モニター貸与",
              "ペット可",
              "食事付の宿",
              "赤ちゃんといっしょ",
              "コワーキングあり",
              "最寄りの主要駅や空港から送迎あり"
            ],
            "bathroom": [
              "バスタブあり",
              "シャワーブースのみ",
              "共用バスルーム",
              "共用シャワーブース"
            ],
            "bedroom": [
              "ベッド",
              "布団",
              "ベビーベッド",
              "ソファーベッド",
              "マットレス"
            ],
            "cleaning_frequency": [
              "毎日",
              "週1",
              "週2~3",
              "なし"
            ],
            "coworking_space_en": {
              "available": "Available",
              "not_available": "Not Available"
            },
            "from_station": {
              "walking_distance": "徒歩圏内",
              "within_1hour": "車で1時間以内",
              "within_20min": "車で20分以内"
            },
            "kids_facilities": [
              "おむつペール",
              "補助便座",
              "ベッドガード",
              "踏み台",
              "子供用食器",
              "ハイチェア",
              "ベビーチェア（子供用椅子）"
            ],
            "kitchen": {
              "none": "-",
              "private": "専用キッチン",
              "shared": "共用キッチン"
            },
            "kitchen_facilities": [
              "冷蔵庫",
              "電子レンジ",
              "コンロ",
              "炊飯器",
              "電気ケトル",
              "トースター",
              "調味料",
              "調理器具",
              "食器類",
              "食器用洗剤",
              "スポンジ"
            ],
            "laundry": {
              "laundry_room": "館内ランドリー",
              "none": "-",
              "washer_dryer": "洗濯乾燥機",
              "washing_machine": "洗濯機"
            },
            "living_facilities": [
              "テレビ",
              "エアコン",
              "扇風機",
              "暖房器具",
              "ダイニングテーブル",
              "ダイニングチェア",
              "ローテーブル",
              "ソファ"
            ],
            "meal_service": {
              "breakfast_dinner": "朝食/夕食",
              "breakfast_only": "朝食のみ",
              "dinner_only": "夕食のみ"
            },
            "nursery_room_environment": [
              "徒歩登園",
              "園と宿が車で15分以内",
              "車なしで移動可能"
            ],
            "other_facilities": [
              "掃除機",
              "掃除用具",
              "自転車",
              "加湿器"
            ],
            "pets": {
              "not_allowed": "不可",
              "small_dogs_only": "小型犬のみ",
              "small_large_dogs": "小~大型犬",
              "small_medium_dogs": "小~中型犬",
              "small_medium_dogs_cats": "小~中型犬/猫"
            },
            "remote_work_facilities": [
              "PCデスク",
              "PCモニター"
            ],
            "room_type": {
              "aparthotel": "アパートメントホテル",
              "guesthouse": "ゲストハウス",
              "hotel": "ホテル",
              "minshuku": "民宿",
              "no_accommodation": "部屋なし",
              "nursery_dormitory": "保育園留学の寮",
              "ryokan": "旅館",
              "whole_building": "一棟貸し"
            },
            "separate_room": {
              "available": "可",
              "not_available": "不可"
            },
            "waste_disposal": [
              "ご自身で対応",
              "フロントへ申し出",
              "回収"
            ],
            "wifi": {
              "available": "あり",
              "pocket_wifi": "ポケットWi-Fi"
            }
          }
        },
        "school_information": "在籍学校について"
      },
      "check_in_month_label": "大人%{adult_count}名・子ども%{children_count}名のプラン",
      "confirmation": {
        "address": "住所",
        "basic_information": "基本情報",
        "billing_information": "請求情報",
        "birth_date": "生年月日",
        "check_in_time": "宿泊施設への到着予定時刻",
        "children_information": "留学する子どもの情報",
        "confirmation": "入力内容確認",
        "contact_information": "連絡先",
        "emergency_contact_during_stay": "緊急連絡先",
        "exercise_section": "その他(0~1歳の場合のみ)",
        "family_confirmation": "家族情報の入力",
        "family_information": "一緒に滞在する方",
        "full_name": "姓名（漢字）",
        "full_name_reading": "姓名（ふりがな）",
        "gender": "性別",
        "interview_question": "取材・アンケート",
        "living_conditions": "生活習慣・健康状態",
        "meal_and_allergy_information": "食事・アレルギー情報",
        "money_unit": "円",
        "no_input": "未入力",
        "occupation": "職業",
        "option": "オプション",
        "people_unit": "人",
        "primary_contact_information": "代表者情報",
        "reservation_information": "予約情報",
        "school_information": "在籍学校について"
      },
      "edit": "編集する",
      "family_master": {
        "confirmed": "確認しました",
        "headings": {
          "address": "住所",
          "allergy_information": "アレルギー情報",
          "basic_information": "基本情報",
          "contact_information": "連絡先",
          "exercise_section": "その他(0~1歳の場合のみ)",
          "living_conditions": "生活習慣・健康状態について",
          "school_information": "在籍学校について",
          "stay_with": "一緒に滞在する方",
          "work": "仕事"
        },
        "messages": {
          "legacy_answer": "以前の回答: %{value}",
          "medical_history_details_note": "※※症状や回数・起こした年齢（例:熱性痙攣 〇回/時期 〇歳〇か月頃）、またご自宅や普段の園生活で配慮している点や留学先の園で対応いただきたいことがある場合もご記入ください。",
          "medical_history_note": "※例：熱性痙攣・肘内障・てんかん・喘息・川崎病・入院手術歴の有無など",
          "special_requests": "※食物アレルギー以外で、宗教上の理由で口にできない食べ物や、ハラール対応が必要な場合など",
          "symptoms_note": "※普段の生活で配慮していることや留学先の園で対応いただきたいことがある場合、またアナフィラキシーがある場合もこちらに必ずご記入ください。"
        },
        "select": "選択してください"
      },
      "flash": {
        "alert": {
          "conditional_requirement_answer": "質問に回答してください",
          "family_confirmation": {
            "no_input": "未入力の項目があります"
          },
          "nursery_meeting": {
            "full": "面談日がいっぱいです。",
            "select": "日付を選択してください。"
          },
          "todo_uploads": "ファイルをアップロードしてください"
        }
      },
      "handbook": {
        "breadcrumb": {
          "top": "TOP"
        },
        "contact": {
          "guest_house": {
            "table": {
              "contact": "連絡先",
              "name": "名称"
            },
            "title": "宿泊施設に関するお問い合わせ"
          },
          "image": "連絡網",
          "note": "ご連絡する際は、お名前とチェックイン日をお伝えください。\n連絡先に迷われた場合は、保育園留学事務局までご連絡ください。",
          "nursery": {
            "table": {
              "contact": "連絡先",
              "name": "名称"
            },
            "title": "留学施設に関するお問い合わせ",
            "title_for_nursery_1": "留学施設①に関するお問い合わせ",
            "title_for_nursery_2": "留学施設②に関するお問い合わせ"
          },
          "program": {
            "table": {
              "contact": "連絡先",
              "contact_value": "support@hoikuen-ryugaku.zendesk.com",
              "name": "名称",
              "name_value": "保育園留学事務局"
            },
            "title": "料金、支払い、その他一般的な手続きに関するお問い合わせ"
          },
          "support_email": "support@hoikuen-ryugaku.zendesk.com",
          "title": "お問い合わせ先"
        },
        "family_notice": {
          "nursery_1": "留学施設①",
          "nursery_2": "留学施設②",
          "title": "留学先からご家族への案内"
        },
        "guest_house": {
          "additional_services": {
            "title": "追加サービス"
          },
          "check_in": {
            "check_in_day_info": "チェックインについて",
            "check_in_items": "チェックインに必要な持ち物",
            "check_in_procedure": "チェックアウトについて",
            "description_html": "<b>◎予約時に「数日のみ合流して滞在する」のオプションを選択された場合</b>\n予約確定メールが届きましたら、数日のみ合流する方のチェックイン・チェックアウト日時のご連絡をお願いいたします。\n予約後に当オプションを追加された場合は、その際にご連絡をお願いします。\n\n<b>◎チェックイン時間を変更する場合</b>\nチェックイン時間の変更は、マイページのやることリストページ内 > [事前質問に回答する] > [滞在時の情報]で到着予定時刻を変更できます。\n人数の変更は滞在開始日の1週間前までとなっております。それ以降の変更は出来かねますので、予めご了承ください。",
            "table": {
              "check_in_method": "チェックイン方法",
              "check_in_time": "チェックイン",
              "check_out_time": "チェックアウト"
            },
            "title": "チェックイン／アウト"
          },
          "facilities": {
            "description": "客室内の家具、ベッド、マットレスなどの移動は、思わぬ破損やケガの原因となることがあります。\nお部屋のレイアウト変更や物品の移動をご希望の場合は、事前に宿のスタッフにご相談ください。",
            "from_guest_house_title": "宿泊施設からのご案内",
            "parking": {
              "available_value": "あり",
              "table": {
                "available": "駐車場の有無",
                "comments": "備考"
              },
              "title": "駐車場",
              "unavailable_value": "なし"
            },
            "table": {
              "amenities": "アメニティ",
              "bathroom": "バスルーム",
              "bedroom": "寝室",
              "free_rental_items": "貸出品",
              "kids_facilities": "子ども用品",
              "kitchen_facilities": "キッチン",
              "laundry": "ランドリー",
              "living_facilities": "リビング",
              "other_facilities": "その他",
              "paid_rental_items": "有料貸出品",
              "remote_work_facilities": "リモートワーク"
            },
            "title": "設備・備品"
          },
          "house_rules": {
            "cleaning": {
              "table": {
                "amenity_supply": "アメニティ補充",
                "cleaning_frequency": "清掃頻度",
                "waste_disposal": "ゴミ出し方法"
              },
              "title": "清掃について"
            },
            "facility_usage": {
              "title": "施設使用上の注意"
            },
            "title": "ハウスルール"
          },
          "luggage": {
            "description": "滞在期間中ご自身の到着以降の受け取れる時間をご指定ください。\n（宿泊施設担当者が荷物のお受け取り代行をすることはいたしかねます。ご家族さまの責任にて管理をお願いいたします。）\n宛先にご自身のお名前もご記入ください。発送元を記入ください。",
            "shipping_address": {
              "title": "発送先住所"
            },
            "title": "荷物の発送について"
          },
          "top": {
            "cards": {
              "additional_services": "追加サービス",
              "check_in": "チェックイン／アウト",
              "facilities": "設備・備品",
              "house_rules": "ハウスルール",
              "luggage": "荷物の発送について"
            },
            "google_map": "Google Map",
            "title": "宿泊施設"
          }
        },
        "local_info": {
          "medical": {
            "note": "最新情報はGoogleマップ、または現地にご確認をお願いします。",
            "table": {
              "address": "住所",
              "name": "名称",
              "url": "URL"
            },
            "title": "医療機関"
          },
          "top": {
            "cards": {
              "medical": "医療機関",
              "transportation": "交通機関"
            },
            "description": "宿泊施設周辺の地図です。\n生活に便利なスーパーやコンビニ、地域の方おすすめのグルメ・アクティビティ・観光地・ワーキングスポットをまとめておりますので、ぜひご活用ください。",
            "title": "周辺情報"
          },
          "transportation": {
            "car_rental": "レンタカー会社情報",
            "other": "その他交通機関",
            "taxi": "近隣のタクシー会社情報",
            "title": "交通機関"
          }
        },
        "nursery": {
          "attire": {
            "belongings": {
              "common": "共通",
              "daily_items": "＜毎日持参するもの＞",
              "elementary": "小学生",
              "infant": "0〜2歳児",
              "items": "持ち物",
              "kept_items": "＜園に預けるもの（最初の登園日のみ持参）＞",
              "notes": "備考",
              "target_class": "対象クラス",
              "toddler": "3〜5歳児"
            },
            "belongings_document": "持ち物資料",
            "belongings_document_open": "PDFを別タブで開く",
            "clothing": "服装",
            "daily_belongings": "毎日の持ち物",
            "note": "※すべての持ち物に記名をお願いします。",
            "rental_items": "借りられる物",
            "title": "服装・持ち物"
          },
          "childcare_hours": {
            "first_day_info": {
              "title": "初日について"
            },
            "hours": {
              "table": {
                "childcare_time": "利用時間",
                "childcare_time_note": "利用時間の補足",
                "extending_time": "延長利用時間",
                "gradual_entry": "慣らし保育"
              }
            },
            "note": "送迎時間について、遵守をお願いしております。指定時間より早い到着、お迎えの遅延がないようご協力お願いします。やむを得ない事情により時間に遅れる可能性がある場合は、事前に施設へお電話にてお知らせください。\n遅刻や欠席につきましては、直接ご利用の留学施設へご連絡ください。",
            "title": "利用時間・初日について"
          },
          "health": {
            "note": "発熱の症状で欠席される場合は、留学施設からの指示に従ってください。\nなお、留学施設の休みやクラス閉鎖、ならびに留学児ご本人の早退・欠席に伴う施設利用料等のプログラム費用については、原則として返金いたしかねます。",
            "table": {
              "absence_conditions": "施設利用を控えていただく場合",
              "fever": "発熱について",
              "fever_value": "%{temperature}以上の熱がある場合はお迎えをお願いします。",
              "medication": "与薬について",
              "sick_care": "病児保育について"
            },
            "title": "健康面について"
          },
          "other_info": {
            "notice": {
              "title": "留学先からのご案内"
            },
            "school_bus_available": "利用可",
            "school_bus_unavailable": "利用不可",
            "table": {
              "communication_note": "連絡帳",
              "school_bus": "園バス利用"
            },
            "title": "その他ご案内"
          },
          "top": {
            "cards": {
              "attire": "服装・持ち物",
              "childcare_hours": "利用時間について",
              "health": "健康面について",
              "other_info": "その他ご案内"
            },
            "title": "留学施設"
          }
        },
        "top": {
          "cards": {
            "contact": "お問い合わせ先",
            "family_notice": "留学先からご家族への案内",
            "guest_house": "宿泊施設の情報",
            "local_info": "周辺情報",
            "nursery": "留学施設の情報",
            "nursery_1": "留学施設①の情報",
            "nursery_2": "留学施設②の情報"
          },
          "title": "留学のしおり"
        }
      },
      "modal_message": {
        "back": "もどる",
        "complete": "完了にする",
        "final_confirm": "最終確認",
        "final_confirm_message": "この内容で提出してよろしいですか？",
        "final_confirm_message_2": "ご対応は完了しましたか？「完了にする」ボタンを押すと、ステータスが完了になります。",
        "final_confirm_message_3": "この内容で提出してよろしいですか？提出後に修正はできません。",
        "submission": "提出へすすむ",
        "submit": "提出する"
      },
      "mypage": {
        "cancel_fee": "キャンセル料 : ",
        "cancelled": "キャンセル",
        "form": {
          "children_form": "留学する子どもの情報",
          "completions": {
            "done": "提出完了",
            "friends_program": {
              "text": "紹介されたお友だちはお得に留学ができて、あなたが留学した園には、支援が届く。家族と地域の未来につながるプログラムです。",
              "title": "お友だち紹介プログラム",
              "url": "https://hoikuen-ryugaku.com/friends",
              "url_text": "確認する"
            },
            "review_form_done": "回答完了",
            "review_thank_you": "アンケートにご協力をいただき誠にありがとうございました。",
            "thank_you": "ご対応ありがとうございます。お疲れ様でした。",
            "top": "やることリストTOPへ"
          },
          "exist_information": "これまで登録したことがある情報",
          "family_form": "一緒に滞在する方の登録",
          "questionnaire_form": {
            "absent_days": {
              "unit": "日",
              "validation": "（半角数字で入力してください）"
            },
            "completed": "留学後アンケートは回答済みです。",
            "create": {
              "error": "回答内容に不備があります。回答内容をお確かめください。"
            },
            "heading": "保育園留学アンケート",
            "modal_message": "この内容で回答してよろしいですか？\n回答後に修正はできません。",
            "modal_submit": "回答する",
            "note": "※本取り組みを、持続的に育てていきたくアンケートのご回答にご協力をお願いいたします。\nアンケート内容は、株式会社キッチハイクと地域担当者間で共有し、今後のサービスの改善に活用させていただきます。",
            "scale": {
              "very_dissatisfied": "とても不満",
              "very_satisfied": "とても満足"
            },
            "submit": "アンケートに回答する"
          },
          "reservations_form": "予約情報",
          "review_form": {
            "activity_details": {
              "label_html": "活動を行った頻度や詳細、また上記選択肢にない活動があれば教えてください",
              "optional": "任意",
              "placeholder": "例：\n・たまたまタイミングが合って、1回だけ園バスに乗って海遊びに行くことができました。\n・園内でうさぎを飼っていたため毎日お世話ができ、ご近所で飼っているヤギにお散歩で会えたようです。"
            },
            "completed": "留学後アンケートは回答済みです。",
            "create": {
              "error": "回答内容に不備があります。回答内容をお確かめください。"
            },
            "drag_and_drop": "ドラッグ＆ドロップも可能です",
            "experienced_activities": {
              "hint": "当てはまるものをすべてお選びください",
              "label_html": "留学中にお子さんが<strong class=\"font-bold\">園の活動として体験したこと</strong>を教えてください",
              "options": [
                "海遊び",
                "森遊び",
                "泥遊び",
                "川遊び",
                "水遊び",
                "雪遊び",
                "動物",
                "食育",
                "英語教育",
                "地域交流",
                "異年齢保育",
                "収穫体験",
                "園外へのお散歩",
                "アート・工作活動",
                "クッキング",
                "焚火",
                "田植え",
                "稲刈り",
                "虫捕り・生き物探し",
                "裸足での活動",
                "保育参観",
                "分からない"
              ]
            },
            "head": "いただいた感想と合わせて、保育園留学のホームページでご紹介可能なお写真がありましたらアップロードをお願いいたします",
            "heading": "保育園留学のご感想・メッセージ",
            "image_count_error": "アップロードできる画像は最大10枚までです。お手数をおかけしますが、画像の枚数をお確かめください。",
            "image_size_error": "1つのファイルの最大サイズは5MBです。お手数をおかけしますが、サイズを超過している画像はリサイズして再度アップロードしてください。",
            "modal_message": "レビューを投稿して\nアンケート回答に進みますか？",
            "modal_submit": "投稿してアンケート回答に進む",
            "nickname_blank": "表示名（ニックネーム）を入力してください",
            "nickname_description": "※ ご紹介時の表示に使用いたします。",
            "nickname_label": "表示名（ニックネーム）",
            "nickname_placeholder": "例）たなか",
            "published_no": "いいえ",
            "published_yes": "はい",
            "submit_next": "投稿して次へ",
            "upload_image": "画像をアップロードする",
            "uploading_notice": "画像をアップロードしています。完了までお待ちください。",
            "validation": "（1枚あたり最大5MB・最大10枚まで）"
          },
          "todo_uploads": {
            "attachment": "添付ファイル",
            "file_size_error": "1つのファイルの最大サイズは20MBです。",
            "upload_file": "ファイルをアップロードする",
            "uploaded_file_1": "添付ファイル1"
          }
        },
        "next_plan": "次の留学先はお決まりですか？",
        "next_plan_message": "すべての地域で、その季節ならではの体験が待っています。次の留学の計画をはじめましょう。",
        "nursery_meeting": {
          "no_available_slots": "現在、予約できる面談日程がありません。受付期間になってからもう一度お試しください。"
        },
        "planned_visit": "留学予定",
        "reservation_status": {
          "cancelled": "キャンセル",
          "completed": "留学済み",
          "processing": "リクエスト中",
          "upcoming": "予約確定"
        },
        "search_study_destination": "留学先を探す",
        "visited": "留学済み"
      },
      "reservation_request": {
        "certificate_of_participation_download": "Download Certificate of Participation >",
        "confirmation_of_reservation": "予約内容の確認 >",
        "confirmed": "確認しました",
        "dashboard_title": "留学予定",
        "errors": {
          "expectation_max_selection": "は3つ以内で選択してください。",
          "expectation_others_required": "を入力してください。",
          "form_validation_error": "回答内容に不備があります。入力した内容をご確認ください。",
          "route_others_required": "を入力してください。"
        },
        "handbook_banner_alt": "留学のしおり",
        "headings": {
          "emergency_contact_during_stay": "滞在時の緊急ご連絡先",
          "information_during_your_stay": "滞在時の情報",
          "interview_question": "取材アンケート",
          "reservation_information": "予約情報の登録"
        },
        "messages": {
          "check_in_time_note": "※チェックイン時刻が当日変更となる場合は、必ず宿へ直接ご連絡をお願いします。",
          "emergency_contact_during_stay_note": "留学施設へ滞在中に緊急でご連絡したい場合、こちらへおかけします",
          "emergency_contact_note": "※現地で何かあった際に滞在者ご本人へつながる番号をご入力下さい。宿と園へ共有させていただきます。"
        },
        "plans": {
          "accommodation": "宿泊施設：%{room_name}",
          "adult": "大人%{count}人、",
          "child": "子ども%{count}人",
          "people": "人数：",
          "period": "留学期間：%{start_date}〜%{end_date}",
          "preschool": "留学施設 : %{nursery_name}",
          "preschool_2": "留学施設2 : %{nursery_name}",
          "reservation_number": "予約番号 : %{reservation_request_id}"
        },
        "todo_list": "やることリスト"
      },
      "reservation_request_todo": {
        "arrange_an_interview_date": "期限：面談日程調整をしてください。",
        "asap": "早急に",
        "date": "実施日：%{date}",
        "done": "完了",
        "soon": "近日中に",
        "submission_due_date": "期限：%{date}まで"
      },
      "todo": {
        "review_not_found": "アンケート回答のTODOが見つかりません。事務局までお問い合わせください。",
        "submission_deadline": "提出期限 : %{date}まで"
      },
      "todo_form_header": {
        "back": "戻る",
        "back_to_mypage": "マイページへ戻る"
      }
    }
  }
}